
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5jmoH", function(module, exports) {
$parcel$export(module.exports, "WidgetLoadingState", function () { return (parcelRequire("1YBxD")).WidgetLoadingState; });
parcelRequire("1YBxD");

});
parcelRegister("1YBxD", function(module, exports) {

$parcel$export(module.exports, "WidgetLoadingState", function () { return $38b27de52eb513e1$export$7e27a2e8e18ffe9b; });

var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $2nOeJ = parcelRequire("2nOeJ");
const $38b27de52eb513e1$var$Header = (0, $gRonV.default).div`
    width: 30%;
    height: 30px;
    border-radius: 8px;
`;
const $38b27de52eb513e1$var$Content = (0, $gRonV.default).div`
    height: ${({ height: height })=>height ?? "100px"};
    border-radius: 8px;
`;
const $38b27de52eb513e1$var$Button = (0, $gRonV.default).div`
    width: 130px;
    height: 40px;
    border-radius: 16px;
    &.sm {
        height: 30px;
    }
`;
const $38b27de52eb513e1$export$7e27a2e8e18ffe9b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).memo(function WidgetLoadingState({ title: title, headerButton: headerButton, height: height }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        "data-testid": "widgetLoadingState",
        title: title ? title : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($38b27de52eb513e1$var$Header, {
            className: "shimmer-container"
        }),
        actionButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($38b27de52eb513e1$var$Button, {
            className: "shimmer-container"
        }),
        ...headerButton && {
            headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($38b27de52eb513e1$var$Button, {
                className: "shimmer-container sm"
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($38b27de52eb513e1$var$Content, {
        className: "shimmer-container",
        height: height
    }));
});

});


parcelRegister("1skD3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45c89563000be69a$export$2e2bcd8739ae039; });

var $kKrSh = parcelRequire("kKrSh");

var $6ozyP = parcelRequire("6ozyP");
const $45c89563000be69a$var$displayDateTime = (date)=>date ? (0, $6ozyP.default)((0, $kKrSh.default)(date), "yyyy-MM-dd HH:mm") : "";
var $45c89563000be69a$export$2e2bcd8739ae039 = $45c89563000be69a$var$displayDateTime;

});

parcelRegister("e9RVe", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $a4ebbbbf3026857f$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a4ebbbbf3026857f$var$isValid;

var $a4ebbbbf3026857f$var$_index = $a4ebbbbf3026857f$require$_interopRequireDefault((parcelRequire("6nthy")));

var $a4ebbbbf3026857f$var$_index2 = $a4ebbbbf3026857f$require$_interopRequireDefault((parcelRequire("69nrk")));

var $a4ebbbbf3026857f$var$_index3 = $a4ebbbbf3026857f$require$_interopRequireDefault((parcelRequire("aIIrR")));
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $a4ebbbbf3026857f$var$isValid(dirtyDate) {
    (0, $a4ebbbbf3026857f$var$_index3.default)(1, arguments);
    if (!(0, $a4ebbbbf3026857f$var$_index.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $a4ebbbbf3026857f$var$_index2.default)(dirtyDate);
    return !isNaN(Number(date));
}
module.exports = module.exports.default;

});
parcelRegister("4f3eE", function(module, exports) {
function $316b129645d70568$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $316b129645d70568$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6nthy", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $4a4b9ae6128e5ba1$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a4b9ae6128e5ba1$var$isDate;

var $4a4b9ae6128e5ba1$var$_typeof2 = $4a4b9ae6128e5ba1$require$_interopRequireDefault((parcelRequire("hsVxL")));

var $4a4b9ae6128e5ba1$var$_index = $4a4b9ae6128e5ba1$require$_interopRequireDefault((parcelRequire("aIIrR")));
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $4a4b9ae6128e5ba1$var$isDate(value) {
    (0, $4a4b9ae6128e5ba1$var$_index.default)(1, arguments);
    return value instanceof Date || (0, $4a4b9ae6128e5ba1$var$_typeof2.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
module.exports = module.exports.default;

});
parcelRegister("hsVxL", function(module, exports) {
function $cb71b0212b4136bb$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $cb71b0212b4136bb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $cb71b0212b4136bb$var$_typeof(o);
}
module.exports = $cb71b0212b4136bb$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aIIrR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7ce07df24bd3771d$var$requiredArgs;
function $7ce07df24bd3771d$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}
module.exports = module.exports.default;

});


parcelRegister("69nrk", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $47a5c403bc2a0687$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $47a5c403bc2a0687$var$toDate;

var $47a5c403bc2a0687$var$_typeof2 = $47a5c403bc2a0687$require$_interopRequireDefault((parcelRequire("hsVxL")));

var $47a5c403bc2a0687$var$_index = $47a5c403bc2a0687$require$_interopRequireDefault((parcelRequire("aIIrR")));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $47a5c403bc2a0687$var$toDate(argument) {
    (0, $47a5c403bc2a0687$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $47a5c403bc2a0687$var$_typeof2.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});


parcelRegister("c3qQ5", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $8c6a958999d7b240$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8c6a958999d7b240$var$subMilliseconds;

var $8c6a958999d7b240$var$_index = $8c6a958999d7b240$require$_interopRequireDefault((parcelRequire("dnwOg")));

var $8c6a958999d7b240$var$_index2 = $8c6a958999d7b240$require$_interopRequireDefault((parcelRequire("aIIrR")));

var $8c6a958999d7b240$var$_index3 = $8c6a958999d7b240$require$_interopRequireDefault((parcelRequire("kSC9t")));
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $8c6a958999d7b240$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $8c6a958999d7b240$var$_index2.default)(2, arguments);
    var amount = (0, $8c6a958999d7b240$var$_index3.default)(dirtyAmount);
    return (0, $8c6a958999d7b240$var$_index.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("dnwOg", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $9bd6dfac6bb91cf5$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9bd6dfac6bb91cf5$var$addMilliseconds;

var $9bd6dfac6bb91cf5$var$_index = $9bd6dfac6bb91cf5$require$_interopRequireDefault((parcelRequire("kSC9t")));

var $9bd6dfac6bb91cf5$var$_index2 = $9bd6dfac6bb91cf5$require$_interopRequireDefault((parcelRequire("69nrk")));

var $9bd6dfac6bb91cf5$var$_index3 = $9bd6dfac6bb91cf5$require$_interopRequireDefault((parcelRequire("aIIrR")));
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $9bd6dfac6bb91cf5$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $9bd6dfac6bb91cf5$var$_index3.default)(2, arguments);
    var timestamp = (0, $9bd6dfac6bb91cf5$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $9bd6dfac6bb91cf5$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});
parcelRegister("kSC9t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f33671ee5f601a03$var$toInteger;
function $f33671ee5f601a03$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});



parcelRegister("2S06x", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $2170b4a2ab623965$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2170b4a2ab623965$var$_index = $2170b4a2ab623965$require$_interopRequireDefault((parcelRequire("jdVm2")));

var $2170b4a2ab623965$var$_index2 = $2170b4a2ab623965$require$_interopRequireDefault((parcelRequire("i8VmX")));

var $2170b4a2ab623965$var$_index3 = $2170b4a2ab623965$require$_interopRequireDefault((parcelRequire("jW2oc")));

var $2170b4a2ab623965$var$_index4 = $2170b4a2ab623965$require$_interopRequireDefault((parcelRequire("2bIzs")));

var $2170b4a2ab623965$var$_index5 = $2170b4a2ab623965$require$_interopRequireDefault((parcelRequire("j0Wb3")));

var $2170b4a2ab623965$var$_index6 = $2170b4a2ab623965$require$_interopRequireDefault((parcelRequire("hQC3n")));

var $2170b4a2ab623965$var$_index7 = $2170b4a2ab623965$require$_interopRequireDefault((parcelRequire("2LHxb")));
var $2170b4a2ab623965$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $2170b4a2ab623965$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $2170b4a2ab623965$var$_index7.default.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $2170b4a2ab623965$var$_index5.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $2170b4a2ab623965$var$_index6.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $2170b4a2ab623965$var$_index6.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $2170b4a2ab623965$var$_index3.default)(date);
        // Padding
        return (0, $2170b4a2ab623965$var$_index6.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $2170b4a2ab623965$var$_index6.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $2170b4a2ab623965$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $2170b4a2ab623965$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return $2170b4a2ab623965$var$_index7.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $2170b4a2ab623965$var$_index6.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $2170b4a2ab623965$var$_index4.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $2170b4a2ab623965$var$_index6.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $2170b4a2ab623965$var$_index2.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $2170b4a2ab623965$var$_index6.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return $2170b4a2ab623965$var$_index7.default.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $2170b4a2ab623965$var$_index.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $2170b4a2ab623965$var$_index6.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $2170b4a2ab623965$var$_index6.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $2170b4a2ab623965$var$_index6.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $2170b4a2ab623965$var$_index6.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $2170b4a2ab623965$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $2170b4a2ab623965$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $2170b4a2ab623965$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $2170b4a2ab623965$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $2170b4a2ab623965$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $2170b4a2ab623965$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $2170b4a2ab623965$var$_index7.default.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return $2170b4a2ab623965$var$_index7.default.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $2170b4a2ab623965$var$_index6.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $2170b4a2ab623965$var$_index6.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return $2170b4a2ab623965$var$_index7.default.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return $2170b4a2ab623965$var$_index7.default.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return $2170b4a2ab623965$var$_index7.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $2170b4a2ab623965$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $2170b4a2ab623965$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $2170b4a2ab623965$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $2170b4a2ab623965$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $2170b4a2ab623965$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $2170b4a2ab623965$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $2170b4a2ab623965$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $2170b4a2ab623965$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $2170b4a2ab623965$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $2170b4a2ab623965$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $2170b4a2ab623965$var$_index6.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $2170b4a2ab623965$var$_index6.default)(timestamp, token.length);
    }
};
function $2170b4a2ab623965$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $2170b4a2ab623965$var$_index6.default)(minutes, 2);
}
function $2170b4a2ab623965$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $2170b4a2ab623965$var$_index6.default)(Math.abs(offset) / 60, 2);
    }
    return $2170b4a2ab623965$var$formatTimezone(offset, dirtyDelimiter);
}
function $2170b4a2ab623965$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $2170b4a2ab623965$var$_index6.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $2170b4a2ab623965$var$_index6.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $2170b4a2ab623965$var$_default = $2170b4a2ab623965$var$formatters;
module.exports.default = $2170b4a2ab623965$var$_default;
module.exports = module.exports.default;

});
parcelRegister("jdVm2", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $dfebb898bd6b0c9f$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dfebb898bd6b0c9f$var$getUTCDayOfYear;

var $dfebb898bd6b0c9f$var$_index = $dfebb898bd6b0c9f$require$_interopRequireDefault((parcelRequire("69nrk")));

var $dfebb898bd6b0c9f$var$_index2 = $dfebb898bd6b0c9f$require$_interopRequireDefault((parcelRequire("aIIrR")));
var $dfebb898bd6b0c9f$var$MILLISECONDS_IN_DAY = 86400000;
function $dfebb898bd6b0c9f$var$getUTCDayOfYear(dirtyDate) {
    (0, $dfebb898bd6b0c9f$var$_index2.default)(1, arguments);
    var date = (0, $dfebb898bd6b0c9f$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dfebb898bd6b0c9f$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("i8VmX", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $d35579af95de58c4$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d35579af95de58c4$var$getUTCISOWeek;

var $d35579af95de58c4$var$_index = $d35579af95de58c4$require$_interopRequireDefault((parcelRequire("69nrk")));

var $d35579af95de58c4$var$_index2 = $d35579af95de58c4$require$_interopRequireDefault((parcelRequire("euWrE")));

var $d35579af95de58c4$var$_index3 = $d35579af95de58c4$require$_interopRequireDefault((parcelRequire("2WCjm")));

var $d35579af95de58c4$var$_index4 = $d35579af95de58c4$require$_interopRequireDefault((parcelRequire("aIIrR")));
var $d35579af95de58c4$var$MILLISECONDS_IN_WEEK = 604800000;
function $d35579af95de58c4$var$getUTCISOWeek(dirtyDate) {
    (0, $d35579af95de58c4$var$_index4.default)(1, arguments);
    var date = (0, $d35579af95de58c4$var$_index.default)(dirtyDate);
    var diff = (0, $d35579af95de58c4$var$_index2.default)(date).getTime() - (0, $d35579af95de58c4$var$_index3.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $d35579af95de58c4$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("euWrE", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $a8e133fbc5906a0d$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a8e133fbc5906a0d$var$startOfUTCISOWeek;

var $a8e133fbc5906a0d$var$_index = $a8e133fbc5906a0d$require$_interopRequireDefault((parcelRequire("69nrk")));

var $a8e133fbc5906a0d$var$_index2 = $a8e133fbc5906a0d$require$_interopRequireDefault((parcelRequire("aIIrR")));
function $a8e133fbc5906a0d$var$startOfUTCISOWeek(dirtyDate) {
    (0, $a8e133fbc5906a0d$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $a8e133fbc5906a0d$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("2WCjm", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $224eb75ca8957623$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $224eb75ca8957623$var$startOfUTCISOWeekYear;

var $224eb75ca8957623$var$_index = $224eb75ca8957623$require$_interopRequireDefault((parcelRequire("jW2oc")));

var $224eb75ca8957623$var$_index2 = $224eb75ca8957623$require$_interopRequireDefault((parcelRequire("euWrE")));

var $224eb75ca8957623$var$_index3 = $224eb75ca8957623$require$_interopRequireDefault((parcelRequire("aIIrR")));
function $224eb75ca8957623$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $224eb75ca8957623$var$_index3.default)(1, arguments);
    var year = (0, $224eb75ca8957623$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $224eb75ca8957623$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("jW2oc", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $e835499637f247e9$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e835499637f247e9$var$getUTCISOWeekYear;

var $e835499637f247e9$var$_index = $e835499637f247e9$require$_interopRequireDefault((parcelRequire("69nrk")));

var $e835499637f247e9$var$_index2 = $e835499637f247e9$require$_interopRequireDefault((parcelRequire("aIIrR")));

var $e835499637f247e9$var$_index3 = $e835499637f247e9$require$_interopRequireDefault((parcelRequire("euWrE")));
function $e835499637f247e9$var$getUTCISOWeekYear(dirtyDate) {
    (0, $e835499637f247e9$var$_index2.default)(1, arguments);
    var date = (0, $e835499637f247e9$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $e835499637f247e9$var$_index3.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $e835499637f247e9$var$_index3.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("2bIzs", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $197f2eb2c7d16b80$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $197f2eb2c7d16b80$var$getUTCWeek;

var $197f2eb2c7d16b80$var$_index = $197f2eb2c7d16b80$require$_interopRequireDefault((parcelRequire("69nrk")));

var $197f2eb2c7d16b80$var$_index2 = $197f2eb2c7d16b80$require$_interopRequireDefault((parcelRequire("aCyR5")));

var $197f2eb2c7d16b80$var$_index3 = $197f2eb2c7d16b80$require$_interopRequireDefault((parcelRequire("29hKX")));

var $197f2eb2c7d16b80$var$_index4 = $197f2eb2c7d16b80$require$_interopRequireDefault((parcelRequire("aIIrR")));
var $197f2eb2c7d16b80$var$MILLISECONDS_IN_WEEK = 604800000;
function $197f2eb2c7d16b80$var$getUTCWeek(dirtyDate, options) {
    (0, $197f2eb2c7d16b80$var$_index4.default)(1, arguments);
    var date = (0, $197f2eb2c7d16b80$var$_index.default)(dirtyDate);
    var diff = (0, $197f2eb2c7d16b80$var$_index2.default)(date, options).getTime() - (0, $197f2eb2c7d16b80$var$_index3.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $197f2eb2c7d16b80$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("aCyR5", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $7bb87d7f746d7d02$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7bb87d7f746d7d02$var$startOfUTCWeek;

var $7bb87d7f746d7d02$var$_index = $7bb87d7f746d7d02$require$_interopRequireDefault((parcelRequire("69nrk")));

var $7bb87d7f746d7d02$var$_index2 = $7bb87d7f746d7d02$require$_interopRequireDefault((parcelRequire("aIIrR")));

var $7bb87d7f746d7d02$var$_index3 = $7bb87d7f746d7d02$require$_interopRequireDefault((parcelRequire("kSC9t")));

var $fVGjF = parcelRequire("fVGjF");
function $7bb87d7f746d7d02$var$startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $7bb87d7f746d7d02$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $fVGjF.getDefaultOptions)();
    var weekStartsOn = (0, $7bb87d7f746d7d02$var$_index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $7bb87d7f746d7d02$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("fVGjF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultOptions = $b98d00fdbf7c913f$var$getDefaultOptions;
module.exports.setDefaultOptions = $b98d00fdbf7c913f$var$setDefaultOptions;
var $b98d00fdbf7c913f$var$defaultOptions = {};
function $b98d00fdbf7c913f$var$getDefaultOptions() {
    return $b98d00fdbf7c913f$var$defaultOptions;
}
function $b98d00fdbf7c913f$var$setDefaultOptions(newOptions) {
    $b98d00fdbf7c913f$var$defaultOptions = newOptions;
}

});


parcelRegister("29hKX", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $190a321b0448bbf8$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $190a321b0448bbf8$var$startOfUTCWeekYear;

var $190a321b0448bbf8$var$_index = $190a321b0448bbf8$require$_interopRequireDefault((parcelRequire("j0Wb3")));

var $190a321b0448bbf8$var$_index2 = $190a321b0448bbf8$require$_interopRequireDefault((parcelRequire("aIIrR")));

var $190a321b0448bbf8$var$_index3 = $190a321b0448bbf8$require$_interopRequireDefault((parcelRequire("aCyR5")));

var $190a321b0448bbf8$var$_index4 = $190a321b0448bbf8$require$_interopRequireDefault((parcelRequire("kSC9t")));

var $fVGjF = parcelRequire("fVGjF");
function $190a321b0448bbf8$var$startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $190a321b0448bbf8$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $fVGjF.getDefaultOptions)();
    var firstWeekContainsDate = (0, $190a321b0448bbf8$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $190a321b0448bbf8$var$_index.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $190a321b0448bbf8$var$_index3.default)(firstWeek, options);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("j0Wb3", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $dd7b25370b9ae36f$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dd7b25370b9ae36f$var$getUTCWeekYear;

var $dd7b25370b9ae36f$var$_index = $dd7b25370b9ae36f$require$_interopRequireDefault((parcelRequire("69nrk")));

var $dd7b25370b9ae36f$var$_index2 = $dd7b25370b9ae36f$require$_interopRequireDefault((parcelRequire("aIIrR")));

var $dd7b25370b9ae36f$var$_index3 = $dd7b25370b9ae36f$require$_interopRequireDefault((parcelRequire("aCyR5")));

var $dd7b25370b9ae36f$var$_index4 = $dd7b25370b9ae36f$require$_interopRequireDefault((parcelRequire("kSC9t")));

var $fVGjF = parcelRequire("fVGjF");
function $dd7b25370b9ae36f$var$getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $dd7b25370b9ae36f$var$_index2.default)(1, arguments);
    var date = (0, $dd7b25370b9ae36f$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $fVGjF.getDefaultOptions)();
    var firstWeekContainsDate = (0, $dd7b25370b9ae36f$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $dd7b25370b9ae36f$var$_index3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $dd7b25370b9ae36f$var$_index3.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("hQC3n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cfe4cf99faaca4e4$var$addLeadingZeros;
function $cfe4cf99faaca4e4$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}
module.exports = module.exports.default;

});

parcelRegister("2LHxb", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $2041bd9187cf8cad$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2041bd9187cf8cad$var$_index = $2041bd9187cf8cad$require$_interopRequireDefault((parcelRequire("hQC3n")));
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $2041bd9187cf8cad$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $2041bd9187cf8cad$var$_index.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $2041bd9187cf8cad$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $2041bd9187cf8cad$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $2041bd9187cf8cad$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $2041bd9187cf8cad$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $2041bd9187cf8cad$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $2041bd9187cf8cad$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $2041bd9187cf8cad$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $2041bd9187cf8cad$var$_default = $2041bd9187cf8cad$var$formatters;
module.exports.default = $2041bd9187cf8cad$var$_default;
module.exports = module.exports.default;

});


parcelRegister("4pCyZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3367691f06a6e95a$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $3367691f06a6e95a$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $3367691f06a6e95a$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $3367691f06a6e95a$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $3367691f06a6e95a$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $3367691f06a6e95a$var$timeLongFormatter(timePattern, formatLong));
};
var $3367691f06a6e95a$var$longFormatters = {
    p: $3367691f06a6e95a$var$timeLongFormatter,
    P: $3367691f06a6e95a$var$dateTimeLongFormatter
};
var $3367691f06a6e95a$var$_default = $3367691f06a6e95a$var$longFormatters;
module.exports.default = $3367691f06a6e95a$var$_default;
module.exports = module.exports.default;

});

parcelRegister("5AgSn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $010c9a729fd25ba0$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $010c9a729fd25ba0$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("3si5s", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $2842045867f24f39$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2842045867f24f39$var$_index = $2842045867f24f39$require$_interopRequireDefault((parcelRequire("jiHKx")));
var $2842045867f24f39$var$_default = $2842045867f24f39$var$_index.default;
module.exports.default = $2842045867f24f39$var$_default;
module.exports = module.exports.default;

});
parcelRegister("jiHKx", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $e0d1a281a746d636$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0d1a281a746d636$var$_index = $e0d1a281a746d636$require$_interopRequireDefault((parcelRequire("hNOhT")));

var $e0d1a281a746d636$var$_index2 = $e0d1a281a746d636$require$_interopRequireDefault((parcelRequire("M58Kz")));

var $e0d1a281a746d636$var$_index3 = $e0d1a281a746d636$require$_interopRequireDefault((parcelRequire("v4zke")));

var $e0d1a281a746d636$var$_index4 = $e0d1a281a746d636$require$_interopRequireDefault((parcelRequire("f3FPN")));

var $e0d1a281a746d636$var$_index5 = $e0d1a281a746d636$require$_interopRequireDefault((parcelRequire("feYQk")));
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $e0d1a281a746d636$var$locale = {
    code: "en-US",
    formatDistance: $e0d1a281a746d636$var$_index.default,
    formatLong: $e0d1a281a746d636$var$_index2.default,
    formatRelative: $e0d1a281a746d636$var$_index3.default,
    localize: $e0d1a281a746d636$var$_index4.default,
    match: $e0d1a281a746d636$var$_index5.default,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $e0d1a281a746d636$var$_default = $e0d1a281a746d636$var$locale;
module.exports.default = $e0d1a281a746d636$var$_default;
module.exports = module.exports.default;

});
parcelRegister("hNOhT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $cf5e0556beca21cb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $cf5e0556beca21cb$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $cf5e0556beca21cb$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $cf5e0556beca21cb$var$_default = $cf5e0556beca21cb$var$formatDistance;
module.exports.default = $cf5e0556beca21cb$var$_default;
module.exports = module.exports.default;

});

parcelRegister("M58Kz", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $0908788842d6cb4c$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0908788842d6cb4c$var$_index = $0908788842d6cb4c$require$_interopRequireDefault((parcelRequire("1bIbm")));
var $0908788842d6cb4c$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $0908788842d6cb4c$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $0908788842d6cb4c$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $0908788842d6cb4c$var$formatLong = {
    date: (0, $0908788842d6cb4c$var$_index.default)({
        formats: $0908788842d6cb4c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $0908788842d6cb4c$var$_index.default)({
        formats: $0908788842d6cb4c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $0908788842d6cb4c$var$_index.default)({
        formats: $0908788842d6cb4c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $0908788842d6cb4c$var$_default = $0908788842d6cb4c$var$formatLong;
module.exports.default = $0908788842d6cb4c$var$_default;
module.exports = module.exports.default;

});
parcelRegister("1bIbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0dd9172c3f243527$var$buildFormatLongFn;
function $0dd9172c3f243527$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("v4zke", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $05d670a03fc2fd7b$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $05d670a03fc2fd7b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $05d670a03fc2fd7b$var$formatRelativeLocale[token];
};
var $05d670a03fc2fd7b$var$_default = $05d670a03fc2fd7b$var$formatRelative;
module.exports.default = $05d670a03fc2fd7b$var$_default;
module.exports = module.exports.default;

});

parcelRegister("f3FPN", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $af679648e90a4db5$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af679648e90a4db5$var$_index = $af679648e90a4db5$require$_interopRequireDefault((parcelRequire("bgZPp")));
var $af679648e90a4db5$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $af679648e90a4db5$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $af679648e90a4db5$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $af679648e90a4db5$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $af679648e90a4db5$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $af679648e90a4db5$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $af679648e90a4db5$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $af679648e90a4db5$var$localize = {
    ordinalNumber: $af679648e90a4db5$var$ordinalNumber,
    era: (0, $af679648e90a4db5$var$_index.default)({
        values: $af679648e90a4db5$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $af679648e90a4db5$var$_index.default)({
        values: $af679648e90a4db5$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $af679648e90a4db5$var$_index.default)({
        values: $af679648e90a4db5$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $af679648e90a4db5$var$_index.default)({
        values: $af679648e90a4db5$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $af679648e90a4db5$var$_index.default)({
        values: $af679648e90a4db5$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $af679648e90a4db5$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $af679648e90a4db5$var$_default = $af679648e90a4db5$var$localize;
module.exports.default = $af679648e90a4db5$var$_default;
module.exports = module.exports.default;

});
parcelRegister("bgZPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8351261fd727fbbc$var$buildLocalizeFn;
function $8351261fd727fbbc$var$buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("feYQk", function(module, exports) {
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $b1875bf49d2b4a64$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b1875bf49d2b4a64$var$_index = $b1875bf49d2b4a64$require$_interopRequireDefault((parcelRequire("hZnG0")));

var $b1875bf49d2b4a64$var$_index2 = $b1875bf49d2b4a64$require$_interopRequireDefault((parcelRequire("aPahq")));
var $b1875bf49d2b4a64$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $b1875bf49d2b4a64$var$parseOrdinalNumberPattern = /\d+/i;
var $b1875bf49d2b4a64$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $b1875bf49d2b4a64$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $b1875bf49d2b4a64$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $b1875bf49d2b4a64$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b1875bf49d2b4a64$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $b1875bf49d2b4a64$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $b1875bf49d2b4a64$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $b1875bf49d2b4a64$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $b1875bf49d2b4a64$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $b1875bf49d2b4a64$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $b1875bf49d2b4a64$var$match = {
    ordinalNumber: (0, $b1875bf49d2b4a64$var$_index2.default)({
        matchPattern: $b1875bf49d2b4a64$var$matchOrdinalNumberPattern,
        parsePattern: $b1875bf49d2b4a64$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $b1875bf49d2b4a64$var$_index.default)({
        matchPatterns: $b1875bf49d2b4a64$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b1875bf49d2b4a64$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $b1875bf49d2b4a64$var$_index.default)({
        matchPatterns: $b1875bf49d2b4a64$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b1875bf49d2b4a64$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $b1875bf49d2b4a64$var$_index.default)({
        matchPatterns: $b1875bf49d2b4a64$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b1875bf49d2b4a64$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $b1875bf49d2b4a64$var$_index.default)({
        matchPatterns: $b1875bf49d2b4a64$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b1875bf49d2b4a64$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $b1875bf49d2b4a64$var$_index.default)({
        matchPatterns: $b1875bf49d2b4a64$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b1875bf49d2b4a64$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $b1875bf49d2b4a64$var$_default = $b1875bf49d2b4a64$var$match;
module.exports.default = $b1875bf49d2b4a64$var$_default;
module.exports = module.exports.default;

});
parcelRegister("hZnG0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d18a7fd3f79fd4b9$var$buildMatchFn;
function $d18a7fd3f79fd4b9$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $d18a7fd3f79fd4b9$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $d18a7fd3f79fd4b9$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $d18a7fd3f79fd4b9$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $d18a7fd3f79fd4b9$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});

parcelRegister("aPahq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7e16a430ccabefe0$var$buildMatchPatternFn;
function $7e16a430ccabefe0$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});




parcelRegister("cVCzn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9698ba051cc80397$var$assign;
function $9698ba051cc80397$var$assign(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}
module.exports = module.exports.default;

});


var $7E7Dk = parcelRequire("7E7Dk");

var $9Sg2u = parcelRequire("9Sg2u");

var $3um4r = parcelRequire("3um4r");

var $2rQNl = parcelRequire("2rQNl");

var $eHYdO = parcelRequire("eHYdO");

var $1iD12 = parcelRequire("1iD12");

var $aLIw2 = parcelRequire("aLIw2");

var $1IBeB = parcelRequire("1IBeB");

var $aCffN = parcelRequire("aCffN");

var $9p3YO = parcelRequire("9p3YO");

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $4AX6R = parcelRequire("4AX6R");
var $3um4r = parcelRequire("3um4r");

var $j60L3 = parcelRequire("j60L3");

var $9Rf8k = parcelRequire("9Rf8k");

var $f0ov8 = parcelRequire("f0ov8");

var $aojuQ = parcelRequire("aojuQ");

var $dm5pM = parcelRequire("dm5pM");

var $a4GLo = parcelRequire("a4GLo");

var $cemTh = parcelRequire("cemTh");

var $hcqxO = parcelRequire("hcqxO");

var $feN3c = parcelRequire("feN3c");

var $awukm = parcelRequire("awukm");

var $yF3FB = parcelRequire("yF3FB");

var $h8spA = parcelRequire("h8spA");

var $lRXhp = parcelRequire("lRXhp");

var $bVWHj = parcelRequire("bVWHj");

var $81LJ2 = parcelRequire("81LJ2");

var $PmdvF = parcelRequire("PmdvF");

var $kNBIm = parcelRequire("kNBIm");

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $2rQNl = parcelRequire("2rQNl");

var $3um4r = parcelRequire("3um4r");

var $5u6k9 = parcelRequire("5u6k9");

var $igvrl = parcelRequire("igvrl");

var $1O9Jh = parcelRequire("1O9Jh");

var $gGcRO = parcelRequire("gGcRO");

var $9p3YO = parcelRequire("9p3YO");

var $aCffN = parcelRequire("aCffN");

var $ac4co = parcelRequire("ac4co");

var $gtjDQ = parcelRequire("gtjDQ");
const $c24d70584502555a$var$initialState = {
    isConfirmedScopedAccessActive: false
};
const $c24d70584502555a$var$scopedAccessSessionSlice = (0, $gtjDQ.createSlice)({
    name: "scopedAccessSession",
    initialState: $c24d70584502555a$var$initialState,
    reducers: {
        setIsConfirmedScopedAccessActive: (state, action)=>{
            state.isConfirmedScopedAccessActive = action.payload;
        }
    }
});
const { setIsConfirmedScopedAccessActive: $c24d70584502555a$export$ece459c2e56d5829 } = $c24d70584502555a$var$scopedAccessSessionSlice.actions;
const $c24d70584502555a$export$3c3500f95c5ce184 = (state)=>state.scopedAccessSession.isConfirmedScopedAccessActive;
var $c24d70584502555a$export$2e2bcd8739ae039 = $c24d70584502555a$var$scopedAccessSessionSlice.reducer;



var $hCeZX = parcelRequire("hCeZX");
const $010482ba7d327024$export$b4fa564fef3bb0f8 = ()=>{
    const text = (0, $5u6k9.default)();
    const location = (0, $3um4r.useLocation)();
    const navigate = (0, $3um4r.useNavigate)();
    const toast = (0, $aCffN.useToast)();
    const dispatch = (0, $2rQNl.useDispatch)();
    const { data: scopedAccessContext, isSuccess: hasResolvedScopedAccessContextQuery } = (0, $1O9Jh.useScopedAccessGetCurrentScopedAccessContextQuery)(undefined, {
        pollingInterval: 60000,
        refetchOnMountOrArgChange: true
    });
    const [stopScopedAccessContext, { isLoading: isStoppingScopedAccess }] = (0, $1O9Jh.useScopedAccessStopScopedAccessContextMutation)();
    const [showInvalidatedSessionDialog, setShowInvalidatedSessionDialog] = (0, $7E7Dk.useState)(false);
    const [hasConfirmedActiveScopedAccessSession, setHasConfirmedActiveScopedAccessSession] = (0, $7E7Dk.useState)(false);
    const activeScopedAccessContext = scopedAccessContext ?? null;
    const expectedCompanyId = (0, $ac4co.readScopedAccessExpectedCompanyIdFromSearch)(location.search) ?? (0, $ac4co.readScopedAccessExpectedCompanyId)();
    const hasUnexpectedScopedAccessCompany = Boolean(activeScopedAccessContext?.isScopedAccessActive) && Boolean(expectedCompanyId) && !(0, $hCeZX.areCompanyIdsEqual)(activeScopedAccessContext?.effectiveCompanyId, expectedCompanyId);
    const isScopedAccessSessionActive = Boolean(activeScopedAccessContext?.isScopedAccessActive) && !hasUnexpectedScopedAccessCompany;
    const hasStoredScopedAccessReturnOrigin = Boolean((0, $ac4co.readScopedAccessReturnTo)());
    const scopedAccessSessionStatus = !hasResolvedScopedAccessContextQuery ? "pending" : hasUnexpectedScopedAccessCompany ? "invalidated" : isScopedAccessSessionActive ? "active" : hasConfirmedActiveScopedAccessSession && hasStoredScopedAccessReturnOrigin ? "invalidated" : "inactive";
    const redirectToStoredReturnOriginOrNotifyError = (0, $7E7Dk.useCallback)(()=>{
        try {
            (0, $ac4co.getScopedAccessReturnTo)();
            (0, $ac4co.redirectToStoredScopedAccessReturnTo)();
            return true;
        } catch  {
            toast.notifyError(text("msgScopedAccessMissingReturnOrigin"));
            return false;
        }
    }, [
        text,
        toast
    ]);
    // Consume one-time bootstrap params, persist them for this tab, and remove them from the URL.
    (0, $7E7Dk.useEffect)(()=>{
        const returnTo = (0, $ac4co.readScopedAccessReturnToFromSearch)(location.search);
        const expectedCompanyIdFromSearch = (0, $ac4co.readScopedAccessExpectedCompanyIdFromSearch)(location.search);
        if (!returnTo && !expectedCompanyIdFromSearch) return;
        if (returnTo) (0, $ac4co.storeScopedAccessReturnTo)(returnTo);
        if (expectedCompanyIdFromSearch) (0, $ac4co.storeScopedAccessExpectedCompanyId)(expectedCompanyIdFromSearch);
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete((0, $ac4co.SCOPED_ACCESS_RETURN_TO_PARAM));
        searchParams.delete((0, $ac4co.SCOPED_ACCESS_EXPECTED_COMPANY_ID_PARAM));
        navigate({
            pathname: location.pathname,
            search: searchParams.toString() ? `?${searchParams.toString()}` : ""
        }, {
            replace: true
        });
    }, [
        location.pathname,
        location.search,
        navigate
    ]);
    // Model the scoped-access lifecycle explicitly so active, invalidated, and stale-bootstrap cases stay distinct.
    (0, $7E7Dk.useEffect)(()=>{
        switch(scopedAccessSessionStatus){
            case "active":
                dispatch((0, $c24d70584502555a$export$ece459c2e56d5829)(true));
                setHasConfirmedActiveScopedAccessSession(true);
                setShowInvalidatedSessionDialog(false);
                return;
            case "invalidated":
                dispatch((0, $c24d70584502555a$export$ece459c2e56d5829)(false));
                setShowInvalidatedSessionDialog(true);
                return;
            case "inactive":
                (0, $ac4co.clearScopedAccessReturnTo)();
                (0, $ac4co.clearScopedAccessExpectedCompanyId)();
                dispatch((0, $c24d70584502555a$export$ece459c2e56d5829)(false));
                return;
            case "pending":
            default:
                return;
        }
    }, [
        dispatch,
        scopedAccessSessionStatus
    ]);
    // React immediately when another tab ends or replaces scoped access, instead of waiting for polling.
    (0, $7E7Dk.useEffect)(()=>(0, $ac4co.addScopedAccessEndedListener)(()=>{
            dispatch((0, $c24d70584502555a$export$ece459c2e56d5829)(false));
            setShowInvalidatedSessionDialog(true);
        }), [
        dispatch
    ]);
    const handleExitSession = async ()=>{
        try {
            await stopScopedAccessContext().unwrap();
            dispatch((0, $c24d70584502555a$export$ece459c2e56d5829)(false));
            (0, $ac4co.broadcastScopedAccessEnded)();
            (0, $ac4co.clearScopedAccessExpectedCompanyId)();
            redirectToStoredReturnOriginOrNotifyError();
        } catch (error) {
            if ((0, $gGcRO.isFetchBaseQueryError)(error) && (0, $ac4co.isScopedAccessEndedResponse)(error)) {
                dispatch((0, $c24d70584502555a$export$ece459c2e56d5829)(false));
                setShowInvalidatedSessionDialog(true);
                return;
            }
            toast.notifyError(text("msgCouldNotExitScopedAccessSession"));
        }
    };
    if (showInvalidatedSessionDialog) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9p3YO.ConfirmDialog), {
        visible: showInvalidatedSessionDialog,
        testId: "scoped-access-invalidated-dialog",
        header: text("msgScopedAccessSessionNoLongerValid"),
        message: text("msgScopedAccessSessionNoLongerValidDescription"),
        icon: "pi pi-exclamation-triangle",
        closable: false,
        dismissableMask: false,
        onHide: ()=>undefined,
        footer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex justify-content-end"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                type: "button",
                label: text("btnGoBack"),
                onClick: redirectToStoredReturnOriginOrNotifyError,
                "data-testid": "btn-go-back-invalid-scoped-access-session"
            }))
    });
    if (!isScopedAccessSessionActive) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "w-full h-3rem m-0 border-bottom-1 border-blue-100 bg-blue-50 text-blue-800 flex align-items-center gap-3 px-3 justify-content-between",
        "data-testid": "scoped-access-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        "data-testid": "scoped-access-banner-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgScopedAccessBanner",
        values: {
            companyName: activeScopedAccessContext?.effectiveScopeName ?? text("lblThisOrganisationFallback")
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        size: "small",
        outlined: true,
        className: "border-blue-800 text-blue-800",
        loading: isStoppingScopedAccess,
        label: text("btnExitScopedAccessSession"),
        onClick: ()=>void handleExitSession(),
        "data-testid": "btn-exit-scoped-access-session"
    }));
};





var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $76MyM = parcelRequire("76MyM");

var $81LJ2 = parcelRequire("81LJ2");

var $5u6k9 = parcelRequire("5u6k9");


var $bVWHj = parcelRequire("bVWHj");

var $2eCtI = parcelRequire("2eCtI");
function $8b8a6f2964387153$export$e47503f05082112({ className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    const entitlements = (0, $81LJ2.useEntitlements)();
    const isConfirmedScopedAccessActive = (0, $2rQNl.useSelector)((0, $c24d70584502555a$export$3c3500f95c5ce184));
    const canAccessBilling = (0, $bVWHj.canAccessBillingPage)(entitlements);
    const MENU_LINKS = [
        {
            href: "/dashboard",
            labelCode: "btnDashboard"
        },
        {
            href: "/chargepoints",
            labelCode: "lblChargers"
        },
        {
            href: "/pools",
            labelCode: "btnPools"
        },
        {
            href: "/users",
            labelCode: "lblUsers"
        },
        {
            href: "/nfcTags",
            labelCode: "lblRFID"
        },
        {
            href: "/loadbalancer",
            labelCode: "btnLoadbalancer"
        },
        {
            href: "/measurementDevices",
            labelCode: "lblMeasurementDevices"
        },
        {
            href: "/reports",
            labelCode: "btnReports"
        },
        {
            href: "/settings",
            labelCode: "lblSettings"
        },
        ...canAccessBilling ? [
            {
                href: "/billing",
                labelCode: "lblBilling"
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2eCtI.PageHeader), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        links: MENU_LINKS,
        title: "Admin",
        disableLogout: isConfirmedScopedAccessActive,
        logoutDisabledReason: isConfirmedScopedAccessActive ? text("msgScopedAccessLogoutDisabled") : undefined
    });
}





var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $gRonV = parcelRequire("gRonV");

var $3um4r = parcelRequire("3um4r");

var $aBfUs = parcelRequire("aBfUs");

var $Ri8UW = parcelRequire("Ri8UW");
const $f4ae27c9565cda6e$var$acceptInvitation = (invitationToken)=>(0, $Ri8UW.default)({
        method: "PUT",
        path: `/auth/invitation/accept/${invitationToken}`
    });
var $f4ae27c9565cda6e$export$2e2bcd8739ae039 = $f4ae27c9565cda6e$var$acceptInvitation;



var $23wDf = parcelRequire("23wDf");

var $igvrl = parcelRequire("igvrl");

var $7FZyo = parcelRequire("7FZyo");
const $6dd54a8f0093c2fd$var$Container = (0, $gRonV.default).div`
    width: 440px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    padding: 10px;
`;
const $6dd54a8f0093c2fd$var$ReturnButton = (0, $gRonV.default).div`
    color: ${({ theme: theme })=>theme.font.midDarkColor};
    font-size: 16px;

    &:hover {
        cursor: pointer;
    }
`;
function $6dd54a8f0093c2fd$export$49b43be1058c84eb({ className: className, style: style }) {
    const navigate = (0, $3um4r.useNavigate)();
    const [searchParams] = (0, $3um4r.useSearchParams)();
    const [message, setMessage] = (0, $7E7Dk.useState)({
        type: undefined,
        message: ""
    });
    const acceptInvitationRequest = (0, $23wDf.default)((token)=>(0, $f4ae27c9565cda6e$export$2e2bcd8739ae039)(token));
    (0, $7E7Dk.useEffect)(()=>{
        const token = searchParams.get("token");
        if (token) acceptInvitationRequest.execute(token).catch(()=>{});
        else setMessage({
            type: "error",
            message: "msgInviteNotAccepted"
        });
    }, []);
    (0, $7E7Dk.useEffect)(()=>{
        if (acceptInvitationRequest.status === (0, $23wDf.Status).SUCCESS) setMessage({
            type: "success",
            message: "msgInviteAccepted"
        });
        if (acceptInvitationRequest.status === (0, $23wDf.Status).ERROR) setMessage({
            type: "error",
            message: "msgInviteNotAccepted"
        });
    }, [
        acceptInvitationRequest.status
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($6dd54a8f0093c2fd$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7FZyo.FormHeader), null), message.type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.SNotification), {
        error: message.type === "error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: message.message
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($6dd54a8f0093c2fd$var$ReturnButton, {
        onClick: ()=>navigate("/login")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "btnReturnToSignIn"
    }))));
}





var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $1O9Jh = parcelRequire("1O9Jh");

var $hhXpq = parcelRequire("hhXpq");

var $igvrl = parcelRequire("igvrl");

var $26yAo = parcelRequire("26yAo");

var $7D5nE = parcelRequire("7D5nE");

var $l5N01 = parcelRequire("l5N01");

var $7YeJw = parcelRequire("7YeJw");
parcelRequire("5jmoH");
var $1YBxD = parcelRequire("1YBxD");

var $gRonV = parcelRequire("gRonV");
const $e1269038cf8b9ba4$export$1e86fd0e1db89578 = (0, $gRonV.default).div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    font-weight: var(--font-weight-light);
    font-size: 1rem;
`;
const $e1269038cf8b9ba4$export$8ba719520b473d7d = (0, $gRonV.default).div`
    margin-bottom: 40px;
    display: flex;
    flex-direction: column;
`;
const $e1269038cf8b9ba4$export$61b0b4c79441baec = (0, $gRonV.default).div`
    height: ${({ size: size })=>size === "sm" ? "16px" : "36px"};
    width: 337px;
    align-self: center;
    margin-bottom: 24px;
    border-radius: 16px;
`;


const $133c0d2af6898776$export$fedd53519a0e2bce = /*#__PURE__*/ (0, $7E7Dk.memo)(function DashboardPage() {
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const { data: totalConsumtionData, isLoading: isLoading } = (0, $1O9Jh.useStatisticsGetCompanyTotalConsumptionQuery)({
        companyId: companyId
    });
    const { data: chargePointStatistics } = (0, $1O9Jh.useStatisticsGetChargePointStatusStatsForCompanyQuery)({
        companyId: companyId
    });
    const { data: companyStatistics } = (0, $1O9Jh.useStatisticsGetCompanyUsageStatisticsQuery)({
        companyId: companyId
    });
    (0, $7E7Dk.useEffect)(()=>{
        if (totalConsumtionData?.consumptionPerChargePoint?.length) {
            const data = totalConsumtionData.consumptionPerChargePoint;
            const dyGraphCurrentData = data.map((item, index)=>[
                    index + 1,
                    item.totalConsumptionKwh ?? 0
                ]);
            const xToIdMapper = data.reduce((map, item, index)=>{
                return Object.assign(map, {
                    [index + 1]: item.chargePointId ?? ""
                });
            }, {});
            (0, $7D5nE.configureChart)(dyGraphCurrentData, // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            xToIdMapper, "lastSevenDaysGraph", 100, 80, true, "legendSevenDays", "kWh");
        }
    }, [
        totalConsumtionData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-10"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row"
    }, !isLoading && totalConsumtionData?.totalConsumption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e1269038cf8b9ba4$export$8ba719520b473d7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e1269038cf8b9ba4$export$1e86fd0e1db89578), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhXpq.Header), {
        code: "lblTotalConsumptionForMonth"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgClickAndDrugToZoom"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7D5nE.BarChart), {
        barChartId: "lastMonthGraph",
        data: totalConsumtionData?.totalConsumption,
        useMonth: false
    })), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e1269038cf8b9ba4$export$8ba719520b473d7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e1269038cf8b9ba4$export$61b0b4c79441baec), {
        className: "shimmer-container shimmer-xs",
        size: "md"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e1269038cf8b9ba4$export$61b0b4c79441baec), {
        className: "shimmer-container shimmer-xs",
        size: "sm"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), {
        height: "320px"
    })), !isLoading && totalConsumtionData?.consumptionPerChargePoint && totalConsumtionData?.consumptionPerChargePoint?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e1269038cf8b9ba4$export$8ba719520b473d7d), {
        className: "margin-top-xlarge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e1269038cf8b9ba4$export$1e86fd0e1db89578), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhXpq.Header), {
        code: "lblConsumptionPerCharger"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgClickAndDrugToZoom"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "text-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        id: "legendSevenDays",
        className: "legend-one-month"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        id: "lastSevenDaysGraph",
        className: "admin-dashboard-graph",
        style: {
            width: "95%"
        },
        "data-testid": "bar-chart"
    }))), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e1269038cf8b9ba4$export$8ba719520b473d7d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e1269038cf8b9ba4$export$61b0b4c79441baec), {
        className: "shimmer-container shimmer-xs",
        size: "md"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e1269038cf8b9ba4$export$61b0b4c79441baec), {
        className: "shimmer-container shimmer-xs",
        size: "sm"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), {
        height: "320px"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-2 stats-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $l5N01.ChargePointStatusDashboardWidget), {
        chargePointStatusStats: chargePointStatistics
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7YeJw.ChargingStatistics), {
        stats: companyStatistics,
        direction: "column"
    }))));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $2rQNl = parcelRequire("2rQNl");

var $1ot1u = parcelRequire("1ot1u");

var $3um4r = parcelRequire("3um4r");

var $eUJ8c = parcelRequire("eUJ8c");

var $aBfUs = parcelRequire("aBfUs");

var $ljoiY = parcelRequire("ljoiY");

var $1O9Jh = parcelRequire("1O9Jh");

var $7y3ec = parcelRequire("7y3ec");

var $hw820 = parcelRequire("hw820");


var $5u6k9 = parcelRequire("5u6k9");

var $7FZyo = parcelRequire("7FZyo");

var $c6fcw = parcelRequire("c6fcw");

var $aCffN = parcelRequire("aCffN");
const $aa23c1e069405140$export$d89e43e3db240a63 = /*#__PURE__*/ (0, $7E7Dk.memo)(function SelectOrganisationPage({ className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    const navigate = (0, $3um4r.useNavigate)();
    const toast = (0, $aCffN.useToast)();
    const signOut = (0, $ljoiY.useSignOut)();
    const applyOrganisationSelection = (0, $7y3ec.useApplyOrganisationSelection)();
    const location = (0, $3um4r.useLocation)();
    const from = location?.state?.from || "/";
    const [selectedOrganisationId, setSelectedOrganisationId] = (0, $7E7Dk.useState)(null);
    const [isEntitlementsLoaded, setIsEntitlementsLoaded] = (0, $7E7Dk.useState)(false);
    const [isFetchingEntitlements, setIsFetchingEntitlements] = (0, $7E7Dk.useState)(false);
    const latestEntitlementsRequest = (0, $7E7Dk.useRef)(0);
    const { data: organisations, isLoading: isLoading } = (0, $1O9Jh.useCompanyGetAdministratedCompaniesQuery)();
    const [getEntitlements] = (0, $1O9Jh.useEntitlementsCreateContextTokenMutation)();
    const dispatch = (0, $2rQNl.useDispatch)();
    const signedInUser = (0, $2rQNl.useSelector)((state)=>state.user);
    const isConfirmedScopedAccessActive = (0, $2rQNl.useSelector)((0, $c24d70584502555a$export$3c3500f95c5ce184));
    (0, $7E7Dk.useEffect)(()=>{
        // handle logged in scenario
        if (signedInUser?.selectedCompanyId) navigate(from || "/dashboard", {
            replace: true
        });
    }, [
        from,
        navigate,
        signedInUser?.selectedCompanyId
    ]);
    const handleSubmit = async (event)=>{
        event.preventDefault();
        if (!signedInUser || !selectedOrganisationId) {
            navigate("/login", {
                replace: true
            });
            return;
        }
        try {
            await applyOrganisationSelection({
                organizationId: selectedOrganisationId
            });
            navigate(from || "/dashboard", {
                replace: true
            });
        } catch  {
            dispatch((0, $hw820.clearEntitlements)());
            toast.notifyError(text("lblCouldNotGetEntitlements"));
        }
    };
    const organisationOptions = organisations?.map((organisation)=>({
            label: organisation?.name,
            value: organisation.id
        }));
    const handleSelectedOrg = async (selectedOrgId)=>{
        const requestId = latestEntitlementsRequest.current + 1;
        latestEntitlementsRequest.current = requestId;
        setSelectedOrganisationId(selectedOrgId);
        setIsEntitlementsLoaded(false);
        if (!selectedOrgId) {
            dispatch((0, $hw820.clearEntitlements)());
            setIsFetchingEntitlements(false);
            return;
        }
        setIsFetchingEntitlements(true);
        try {
            const authenticationServiceContextRequest = {
                organizationId: selectedOrgId
            };
            const res = await getEntitlements({
                authenticationServiceContextRequest: authenticationServiceContextRequest
            }).unwrap();
            if (requestId !== latestEntitlementsRequest.current) return;
            dispatch((0, $hw820.setEntitlements)((0, $hw820.normalizeEntitlementsState)(res, selectedOrgId)));
            setIsEntitlementsLoaded(true);
        } catch (error) {
            if (requestId !== latestEntitlementsRequest.current) return;
            dispatch((0, $hw820.clearEntitlements)());
            toast.notifyError(text("lblCouldNotGetEntitlements"));
        } finally{
            if (requestId === latestEntitlementsRequest.current) setIsFetchingEntitlements(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.LandingPageLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        background: (0, $eUJ8c.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "sm:w-8 md:w-6 w-11"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7FZyo.FormHeader), {
        className: "mb-8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        onSubmit: handleSubmit,
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
        id: "select-organisation",
        className: "w-full",
        options: organisationOptions,
        value: selectedOrganisationId,
        onChange: (option)=>handleSelectedOrg(option.value),
        loading: isLoading,
        disabled: isConfirmedScopedAccessActive || isLoading,
        disabledReason: isConfirmedScopedAccessActive ? text("msgScopedAccessOrganisationSwitchDisabled") : undefined,
        filter: true,
        showClear: false,
        placeholder: text("lblSelectOrganisation")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-4 justify-content-center align-items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        disabled: !selectedOrganisationId || isLoading || isFetchingEntitlements || !isEntitlementsLoaded || isConfirmedScopedAccessActive,
        type: "submit",
        className: "mt-5",
        label: text("btnNext"),
        iconPos: "right",
        icon: "pi pi-arrow-right"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        link: true,
        label: text("btnSignOut"),
        "data-testid": "btn-logout",
        onClick: signOut,
        disabled: isConfirmedScopedAccessActive
    }), isConfirmedScopedAccessActive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("small", {
        "data-testid": "select-organisation-logout-disabled-reason"
    }, text("msgScopedAccessLogoutDisabled")) : null))));
});





var $76MyM = parcelRequire("76MyM");

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $3um4r = parcelRequire("3um4r");

var $1ot1u = parcelRequire("1ot1u");

var $ej4sl = parcelRequire("ej4sl");

var $1O9Jh = parcelRequire("1O9Jh");

var $r38ZI = parcelRequire("r38ZI");

var $26yAo = parcelRequire("26yAo");

var $2nOeJ = parcelRequire("2nOeJ");

var $5u6k9 = parcelRequire("5u6k9");

var $9p3YO = parcelRequire("9p3YO");

var $g915J = parcelRequire("g915J");

var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $2rQNl = parcelRequire("2rQNl");

var $1ot1u = parcelRequire("1ot1u");

var $1O9Jh = parcelRequire("1O9Jh");

var $5u6k9 = parcelRequire("5u6k9");

var $MMfqT = parcelRequire("MMfqT");

var $1o9MR = parcelRequire("1o9MR");

var $aCffN = parcelRequire("aCffN");
const $7978a6c88c9435eb$var$formId = "create-pool-form";
const $7978a6c88c9435eb$export$4deb0b01173d388b = /*#__PURE__*/ (0, $7E7Dk.memo)(function CreatePoolDialog({ visible: visible, onSuccess: onSuccess, onHide: onHide }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const [createPool, { isLoading: isLoading }] = (0, $1O9Jh.usePoolCreateMutation)();
    const { register: register, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isSubmitted: isSubmitted, isSubmitting: isSubmitting, isValid: isValid } } = (0, $cCnqE.useForm)({
        defaultValues: {
            name: ""
        },
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    (0, $7E7Dk.useEffect)(()=>{
        if (visible) reset();
    }, [
        reset,
        visible
    ]);
    const onSubmit = async ({ name: name })=>{
        try {
            await createPool({
                pool: {
                    name: name,
                    companyId: companyId
                }
            }).unwrap();
            toast.notifySuccess(text("msgPoolAdded"));
            onSuccess();
        } catch  {
            toast.notifyError(text("msgPoolNotCreated"));
        }
    };
    const submitDisabled = isLoading || isSubmitting || isSubmitted && !isValid;
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: onHide
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCreate"),
        type: "submit",
        form: $7978a6c88c9435eb$var$formId,
        disabled: submitDisabled,
        loading: isLoading || isSubmitting
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        header: text("lblNewPoolModal"),
        visible: visible,
        onHide: onHide,
        footer: footer,
        "data-testid": "create-pool-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $7978a6c88c9435eb$var$formId,
        onSubmit: handleSubmit(onSubmit),
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "pool-name",
        label: text("lblName"),
        ...register("name", {
            required: text("msgNameRequired")
        }),
        error: errors.name?.message,
        required: true,
        autoComplete: "off"
    })));
});




const $f05131e21285008e$export$4c210577356eef88 = /*#__PURE__*/ (0, $7E7Dk.memo)(function PoolsPage({ className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    const user = (0, $2rQNl.useSelector)((state)=>state.user);
    const [openAddModal, setOpenAddModal] = (0, $7E7Dk.useState)(false);
    const cancel = ()=>setOpenAddModal(false);
    const { currentData: pools, isLoading: isLoading, refetch: refetch } = (0, $1O9Jh.useCompanyGetPoolsQuery)({
        companyId: user?.selectedCompanyId
    }, {
        skip: !user.selectedCompanyId
    });
    const [removePool] = (0, $1O9Jh.usePoolDeletePoolMutation)();
    const save = ()=>{
        refetch();
        setOpenAddModal(false);
    };
    const removePools = async (poolId)=>{
        if (!poolId) return;
        const confirmed = await (0, $9p3YO.confirm)({
            header: text("lblProceedConfirmation"),
            message: text("msgRemovePool"),
            variant: "danger"
        });
        if (!confirmed) return;
        try {
            await removePool({
                poolId: poolId,
                companyId: user.selectedCompanyId
            }).unwrap();
            (0, $r38ZI.notifySuccess)(text("msgPoolRemoved"));
            refetch();
        } catch (e) {
            console.error(e);
            (0, $r38ZI.notifyError)(text("msgPoolNotRemoved"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        headerButtons: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            label: text("btnAdd"),
            icon: "pi pi-plus",
            type: "button",
            "data-testid": "add-icon",
            onClick: ()=>setOpenAddModal(true)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: pools ?? [],
        loading: isLoading,
        emptyMessage: text("msgNoPoolsFound"),
        className: "mt-3",
        "data-testid": "pools-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "name",
        header: text("lblName"),
        body: (pool)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.Link), {
                to: `/pool/${pool.id}`
            }, pool.name)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        body: (pool)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex justify-content-end gap-2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                type: "button",
                icon: "pi pi-times",
                size: "small",
                outlined: true,
                rounded: true,
                severity: "danger",
                "data-testid": `remove-pool-${pool.id}`,
                "aria-label": text("btnRemove"),
                tooltip: text("btnRemove"),
                tooltipOptions: {
                    position: "top"
                },
                onClick: ()=>removePools(pool.id)
            }))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7978a6c88c9435eb$export$4deb0b01173d388b), {
        visible: openAddModal,
        onHide: cancel,
        onSuccess: save
    })));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $4AX6R = parcelRequire("4AX6R");

var $6oqHU = parcelRequire("6oqHU");

var $26yAo = parcelRequire("26yAo");

var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $1ot1u = parcelRequire("1ot1u");

var $1O9Jh = parcelRequire("1O9Jh");

var $r38ZI = parcelRequire("r38ZI");

var $1o9MR = parcelRequire("1o9MR");

var $5u6k9 = parcelRequire("5u6k9");
const $20b92b65fb81a562$export$13144779a2e61869 = /*#__PURE__*/ (0, $7E7Dk.memo)(function PoolDetailsWidget({ save: save, poolValue: poolValue, poolName: poolName }) {
    const text = (0, $5u6k9.default)();
    const [editPool] = (0, $1O9Jh.usePoolUpdateMutation)();
    const { register: register, handleSubmit: handleSubmit, formState: { isDirty: isDirty, isValid: isValid, errors: errors } } = (0, $cCnqE.useForm)({
        mode: "all",
        values: {
            name: poolName ?? poolValue?.name ?? ""
        }
    });
    const onSubmit = async (data)=>{
        if (!poolValue) return;
        try {
            await editPool({
                pool: {
                    ...poolValue,
                    name: data.name
                }
            }).unwrap();
            save();
        } catch (e) {
            (0, $r38ZI.notifyError)(text("msgPoolNotUpdated"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        onSubmit: handleSubmit(onSubmit)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        ...register("name", {
            required: text("msgNameRequired")
        }),
        id: "input-name",
        "data-testid": "name-input",
        label: text("lblName"),
        autoComplete: "off",
        required: true,
        error: errors.name?.message
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end mt-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "submit",
        "data-testid": "save-btn",
        label: text("btnSave"),
        icon: "pi pi-save",
        disabled: !poolValue || !isValid || !isDirty
    })));
});





var $1O9Jh = parcelRequire("1O9Jh");

var $r38ZI = parcelRequire("r38ZI");

var $5u6k9 = parcelRequire("5u6k9");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $3um4r = parcelRequire("3um4r");

var $6oqHU = parcelRequire("6oqHU");

var $ej4sl = parcelRequire("ej4sl");

var $1ot1u = parcelRequire("1ot1u");

var $eHYdO = parcelRequire("eHYdO");

var $6L9Rn = parcelRequire("6L9Rn");

var $1O9Jh = parcelRequire("1O9Jh");

var $5u6k9 = parcelRequire("5u6k9");

var $g915J = parcelRequire("g915J");

var $1o9MR = parcelRequire("1o9MR");

var $aCffN = parcelRequire("aCffN");

var $3RGGz = parcelRequire("3RGGz");

var $bAq2r = parcelRequire("bAq2r");

var $4qITT = parcelRequire("4qITT");

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $eHYdO = parcelRequire("eHYdO");

var $1ot1u = parcelRequire("1ot1u");

var $ej4sl = parcelRequire("ej4sl");

var $1O9Jh = parcelRequire("1O9Jh");

var $MMfqT = parcelRequire("MMfqT");

var $3RGGz = parcelRequire("3RGGz");

var $bAq2r = parcelRequire("bAq2r");

var $6L9Rn = parcelRequire("6L9Rn");
function $ddca036059d539bb$export$de29389d53f8108f(fields, search) {
    if (!search) return true;
    return !!fields.filter((field)=>{
        if (!field) return false;
        return field.toLocaleLowerCase().includes(search.trim().toLocaleLowerCase());
    }).length;
}





var $1o9MR = parcelRequire("1o9MR");

var $5u6k9 = parcelRequire("5u6k9");

var $g915J = parcelRequire("g915J");
const $e3e26d1ac0c8319a$export$bdd9af547a0739aa = /*#__PURE__*/ (0, $7E7Dk.memo)(function AddChargePointToPoolDialog({ visible: visible, pendingChargePointIds: pendingChargePointIds, onAdd: onAdd, onHide: onHide }) {
    const text = (0, $5u6k9.default)();
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const [draftSearch, setDraftSearch] = (0, $7E7Dk.useState)("");
    const [appliedSearch, setAppliedSearch] = (0, $7E7Dk.useState)("");
    const [first, setFirst] = (0, $7E7Dk.useState)(0);
    const [rows, setRows] = (0, $7E7Dk.useState)((0, $g915J.INITIAL_DEFAULT_TABLE_ROWS));
    const onPage = (event)=>{
        setFirst(event.first);
        setRows(event.rows);
    };
    const submitSearch = (event)=>{
        event.preventDefault();
        setFirst(0);
        setAppliedSearch(draftSearch.trim());
    };
    const updateDraftSearch = (event)=>{
        const search = event.target.value;
        setDraftSearch(search);
        if (search.trim() === "") {
            setFirst(0);
            setAppliedSearch("");
        }
    };
    const { data: chargePoints, isFetching: isLoadingChargePoints } = (0, $1O9Jh.useCompanyGetChargePointsPagedQuery)({
        companyId: companyId ?? undefined,
        page: first / rows,
        noOfItems: rows
    }, {
        refetchOnMountOrArgChange: true,
        skip: !companyId || !visible
    });
    const filteredChargePoints = (0, $7E7Dk.useMemo)(()=>chargePoints?.items?.filter((chargePoint)=>(0, $ddca036059d539bb$export$de29389d53f8108f)([
                chargePoint.id,
                chargePoint.name ?? undefined
            ], appliedSearch)) ?? [], [
        appliedSearch,
        chargePoints?.items
    ]);
    const displayedChargePoints = (0, $7E7Dk.useMemo)(()=>filteredChargePoints.map((chargePoint)=>({
                ...chargePoint,
                isPending: pendingChargePointIds.has(chargePoint.id),
                isAssigned: !!chargePoint.poolId
            })), [
        filteredChargePoints,
        pendingChargePointIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        header: text("lblAddChargePoint"),
        visible: visible,
        onHide: onHide,
        style: {
            width: "80rem",
            maxHeight: "90vh"
        },
        breakpoints: {
            "960px": "96vw"
        },
        contentStyle: {
            overflow: "visible"
        },
        "data-testid": "add-charge-points-to-pool-dialog",
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            label: text("btnCancel"),
            text: true,
            onClick: onHide
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        className: "flex flex-column md:flex-row align-items-end gap-2 mb-2",
        onSubmit: submitSearch
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        className: "w-full flex-1",
        "data-testid": "search",
        type: "search",
        name: "search",
        id: "search",
        placeholder: text("lblSearch"),
        "aria-label": text("lblSearch"),
        value: draftSearch,
        onChange: updateDraftSearch
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        "data-testid": "search-button",
        type: "submit",
        label: text("lblSearch"),
        icon: (0, $eHYdO.PrimeIcons).SEARCH
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: displayedChargePoints,
        lazy: true,
        paginator: true,
        first: first,
        rows: rows,
        totalRecords: chargePoints?.totalCount ?? 0,
        onPage: onPage,
        loading: isLoadingChargePoints,
        scrollable: true,
        scrollHeight: "45vh",
        paginatorDropdownAppendTo: "self",
        emptyMessage: text("lblNoChargersFound"),
        "data-testid": "add-charge-points-to-pool-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "id",
        header: text("lblSerialNumberColumn"),
        style: {
            minWidth: "8rem"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "chargePointStatus",
        header: text("lblStatus"),
        body: (chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3RGGz.ChargepointStatus), {
                chargePoint: chargePoint
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "name",
        header: text("lblName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "settings",
        header: text("lblSettings"),
        body: (chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6L9Rn.default), {
                chargePoint: chargePoint
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "lastHeartbeat",
        header: text("lblLastSeenTime"),
        body: (chargePoint)=>chargePoint.chargePointStatus === "Offline" && (0, $bAq2r.default)(chargePoint.lastHeartbeat || "") || "---"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "add",
        style: {
            width: "5rem"
        },
        body: (chargePoint)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex justify-content-end"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                "data-testid": `add-button-charger-${chargePoint.id}`,
                icon: "pi pi-plus",
                "aria-label": text("btnAdd"),
                size: "small",
                outlined: true,
                rounded: true,
                severity: "success",
                tooltip: chargePoint.isAssigned ? text("msgChargerAlreadyAssignedToPool") : text("btnAdd"),
                tooltipOptions: {
                    position: "top",
                    showOnDisabled: true
                },
                loading: chargePoint.isPending,
                disabled: chargePoint.isPending || chargePoint.isAssigned,
                onClick: ()=>onAdd(chargePoint)
            }));
        }
    })));
});




const $9f4a245b47e43d67$export$f2a841894361457d = /*#__PURE__*/ (0, $7E7Dk.memo)(function AdminCompanyChargersWidget({ className: className, style: style, poolId: poolId }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const [addChargersDialog, setAddChargersDialog] = (0, $7E7Dk.useState)({
        visible: false,
        sessionId: 0
    });
    const [pendingChargePointIds, setPendingChargePointIds] = (0, $7E7Dk.useState)(()=>new Set());
    const [globalFilter, setGlobalFilter] = (0, $7E7Dk.useState)("");
    const openAddChargersDialog = ()=>{
        setAddChargersDialog(({ sessionId: sessionId })=>({
                visible: true,
                sessionId: sessionId + 1
            }));
    };
    const hideAddChargersDialog = ()=>{
        setAddChargersDialog((dialog)=>({
                ...dialog,
                visible: false
            }));
    };
    const { data: chargePointsData, isFetching: isLoading } = (0, $1O9Jh.usePoolGetChargePointsQuery)({
        poolId: poolId
    }, {
        refetchOnMountOrArgChange: true
    });
    const [addChargePointToPool] = (0, $1O9Jh.useChargePointAddToPoolMutation)();
    const handleAddChargerToPool = async (chargePoint)=>{
        setPendingChargePointIds((ids)=>new Set(ids).add(chargePoint.id));
        try {
            await addChargePointToPool({
                chargePointId: chargePoint.id,
                poolId: poolId
            }).unwrap();
            toast.notifySuccess(text("lblChargerWasAddedToPool"));
        } catch  {
            toast.notifyError(text("msgChargerFailedToAddToPool"));
        } finally{
            setPendingChargePointIds((ids)=>{
                const nextIds = new Set(ids);
                nextIds.delete(chargePoint.id);
                return nextIds;
            });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6oqHU.Card), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("header", {
        className: "flex flex-column md:flex-row md:align-items-center justify-content-between gap-3 mb-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h2", {
        className: "p-card-title m-0"
    }, text("lblChargers")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        "data-testid": "table-rfid-add-btn",
        onClick: openAddChargersDialog,
        label: text("btnAdd"),
        icon: "pi pi-plus"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "chargers-search-input",
        type: "search",
        value: globalFilter,
        onChange: (e)=>setGlobalFilter(e.target.value),
        placeholder: text("lblSearch"),
        icon: (0, $eHYdO.PrimeIcons).SEARCH
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e3e26d1ac0c8319a$export$bdd9af547a0739aa), {
        key: addChargersDialog.sessionId,
        visible: addChargersDialog.visible,
        pendingChargePointIds: pendingChargePointIds,
        onAdd: handleAddChargerToPool,
        onHide: hideAddChargersDialog
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: chargePointsData ?? [],
        lazy: true,
        paginator: true,
        globalFilter: globalFilter,
        globalFilterFields: [
            "id",
            "name"
        ],
        totalRecords: chargePointsData?.length,
        loading: isLoading,
        emptyMessage: text("lblNoChargersFound"),
        "data-testid": "table-charge-points"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "id",
        header: text("lblSerialNumberColumn"),
        body: (chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.Link), {
                className: "m-0",
                "data-testid": `tb-${chargePoint.id}`,
                to: `/chargepoints/${chargePoint.id}`
            }, chargePoint.id)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "name",
        header: text("lblName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "productType",
        header: text("lblModel"),
        body: (chargePoint)=>(0, $4qITT.getChargerProductModelName)(chargePoint.productId, chargePoint.productType ?? "")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "status",
        header: text("lblStatus"),
        body: (chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3RGGz.ChargepointStatus), {
                chargePoint: chargePoint
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "lastSeen",
        header: text("lblLastSeenTime"),
        body: (chargePoint)=>chargePoint.chargePointStatus === "Offline" ? (0, $bAq2r.default)(chargePoint?.lastHeartbeat) : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "settings",
        header: text("lblSettings"),
        body: (chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6L9Rn.default), {
                chargePoint: chargePoint
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "additionalInfo.partnerDescription",
        header: text("lblPartnerInfo")
    })));
});


const $af8c754e567304aa$export$72fb5ffeaac1b378 = /*#__PURE__*/ (0, $7E7Dk.memo)(function PoolPageProps(props) {
    const text = (0, $5u6k9.default)();
    const { poolId: currentPoolId = "-1" } = (0, $4AX6R.useParams)();
    const { currentData: poolById } = (0, $1O9Jh.usePoolGetByIdQuery)({
        poolId: currentPoolId
    });
    const saveEdit = ()=>{
        (0, $r38ZI.notifySuccess)(text("msgPoolUpdated"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(props.className),
        style: props.style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6oqHU.Card), {
        className: "mb-3",
        title: text("lblPoolPage", {
            name: poolById?.name ?? ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $20b92b65fb81a562$export$13144779a2e61869), {
        save: saveEdit,
        poolName: poolById?.name,
        poolValue: poolById
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9f4a245b47e43d67$export$f2a841894361457d), {
        poolId: currentPoolId
    })));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $6oqHU = parcelRequire("6oqHU");

var $h5QsW = parcelRequire("h5QsW");

var $26yAo = parcelRequire("26yAo");

var $evBXI = parcelRequire("evBXI");

var $1O9Jh = parcelRequire("1O9Jh");
const $aec0605491af26da$export$8de4554fe05e44f8 = /*#__PURE__*/ (0, $7E7Dk.memo)(function MeasurementDevicesPage({ style: style }) {
    const user = (0, $2rQNl.useSelector)((state)=>state.user);
    const defaultFiltersValue = {
        serialNumber: "",
        companyId: user?.selectedCompanyId,
        name: "",
        companyName: "",
        partnerName: "",
        page: 0,
        noOfItems: 15
    };
    const [filter, setFilter] = (0, $7E7Dk.useState)(defaultFiltersValue);
    const handleFilterSubmit = (filters)=>{
        setFilter({
            ...defaultFiltersValue,
            ...filters
        });
    };
    const { currentData: measurementDeviceData, isFetching: isLoading } = (0, $1O9Jh.useMeasurementDevicesGetFilteredPagedQuery)(filter, {
        refetchOnMountOrArgChange: true,
        skip: !user?.selectedCompanyId
    });
    const clearDevices = ()=>{
        setFilter(defaultFiltersValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6oqHU.Card), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $evBXI.MeasurementDeviceSearchListForm), {
        onSubmit: handleFilterSubmit,
        clearDevice: clearDevices,
        isLoading: isLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $h5QsW.MeasurementDevicesTableWidget), {
        data: measurementDeviceData,
        isLoading: isLoading,
        filter: filter,
        setFilter: setFilter
    })));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $3um4r = parcelRequire("3um4r");

var $1ot1u = parcelRequire("1ot1u");

var $ej4sl = parcelRequire("ej4sl");

var $1O9Jh = parcelRequire("1O9Jh");


var $26yAo = parcelRequire("26yAo");

var $cbseE = parcelRequire("cbseE");

var $2nOeJ = parcelRequire("2nOeJ");

var $cRXmD = parcelRequire("cRXmD");

var $5u6k9 = parcelRequire("5u6k9");

var $9p3YO = parcelRequire("9p3YO");

var $aoz19 = parcelRequire("aoz19");

var $1o9MR = parcelRequire("1o9MR");

var $g915J = parcelRequire("g915J");

var $aCffN = parcelRequire("aCffN");

var $gtjDQ = parcelRequire("gtjDQ");
const $d66a8c58f38f865e$var$initialState = {
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    passwordCompare: "",
    roleInCompany: "",
    userStatus: "New"
};
const $d66a8c58f38f865e$export$72a4433635166412 = (0, $gtjDQ.createSlice)({
    name: "selectedUser",
    initialState: $d66a8c58f38f865e$var$initialState,
    reducers: {
        setSelectedUser: (_, action)=>{
            return {
                ...action.payload
            };
        },
        resetSelectedUser: ()=>{
            return {
                ...$d66a8c58f38f865e$var$initialState
            };
        }
    }
});
const { setSelectedUser: $d66a8c58f38f865e$export$cb57a0abd67769d3, resetSelectedUser: $d66a8c58f38f865e$export$d2e2801f8995a0fa } = $d66a8c58f38f865e$export$72a4433635166412.actions;
var $d66a8c58f38f865e$export$2e2bcd8739ae039 = $d66a8c58f38f865e$export$72a4433635166412.reducer;



var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $1ot1u = parcelRequire("1ot1u");

var $dE8RX = parcelRequire("dE8RX");

var $fL2dz = parcelRequire("fL2dz");

var $2rQNl = parcelRequire("2rQNl");

var $5u6k9 = parcelRequire("5u6k9");

var $gGcRO = parcelRequire("gGcRO");

var $1O9Jh = parcelRequire("1O9Jh");

var $9p3YO = parcelRequire("9p3YO");

var $MMfqT = parcelRequire("MMfqT");

var $1o9MR = parcelRequire("1o9MR");

var $aCffN = parcelRequire("aCffN");
const $5072c6778b232ed2$var$formId = "create-user-form";
const $5072c6778b232ed2$var$userRoles = [
    {
        value: "User",
        labelCode: "lblUserTypeUser",
        testId: "radio-user"
    },
    {
        value: "Admin",
        labelCode: "lblUserTypeAdmin",
        testId: "radio-admin"
    },
    {
        value: "AdminViewOnly",
        labelCode: "lblUserTypeAdminViewOnly",
        testId: "radio-admin-view-only"
    }
];
const $5072c6778b232ed2$var$defaultValues = {
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    password: "",
    confirmPassword: "",
    roleInCompany: ""
};
const $5072c6778b232ed2$export$bc6de2b7e495d4b5 = /*#__PURE__*/ (0, $7E7Dk.memo)(function CreateUserDialog({ visible: visible, onSuccess: onSuccess, onHide: onHide }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const [createUser, { isLoading: isCreatingUser }] = (0, $1O9Jh.useCompanyCreateUserMutation)();
    const [addRole, { isLoading: isAddingRole }] = (0, $1O9Jh.useCompanyAddRoleToUserMutation)();
    const [inviteUser, { isLoading: isInvitingUser }] = (0, $1O9Jh.useCompanyInviteExistingUserToCompanyMutation)();
    const { control: control, getValues: getValues, handleSubmit: handleSubmit, register: register, reset: reset, formState: { errors: errors, isSubmitted: isSubmitted, isSubmitting: isSubmitting, isValid: isValid } } = (0, $cCnqE.useForm)({
        defaultValues: $5072c6778b232ed2$var$defaultValues,
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    (0, $7E7Dk.useEffect)(()=>{
        if (visible) reset($5072c6778b232ed2$var$defaultValues);
    }, [
        reset,
        visible
    ]);
    const inviteExistingUser = async (chargePointUser)=>{
        const confirmed = await (0, $9p3YO.confirm)({
            header: text("lblProceedConfirmation"),
            message: text("msgShouldSendInviteToExistingUser")
        });
        if (!confirmed) return;
        try {
            await inviteUser({
                companyId: companyId,
                chargePointUser: chargePointUser,
                role: chargePointUser.roleInCompany ?? ""
            }).unwrap();
            toast.notifySuccess(text("msgInviteSent"));
            await onSuccess();
        } catch  {
            toast.notifyError(text("msgInviteNotSent"));
        }
    };
    const submit = async (values)=>{
        const chargePointUser = {
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            mobile: values.mobile || null,
            password: values.password,
            roleInCompany: values.roleInCompany,
            userStatus: "Valid"
        };
        let createdUser;
        try {
            createdUser = await createUser({
                companyId: companyId,
                chargePointUser: chargePointUser
            }).unwrap();
        } catch (error) {
            if ((0, $gGcRO.isFetchBaseQueryError)(error) && error.status === 412) {
                toast.notifyError(text("msgUserAlreadyInOrg"));
                return;
            }
            if ((0, $gGcRO.isFetchBaseQueryError)(error) && error.status === 409) {
                await inviteExistingUser(chargePointUser);
                return;
            }
            toast.notifyError(text("msgUserNotSaved"));
            return;
        }
        if (!createdUser.id) {
            toast.notifyError(text("msgUserNotSaved"));
            return;
        }
        try {
            await addRole({
                companyId: companyId,
                userId: createdUser.id,
                role: {
                    claim: values.roleInCompany,
                    companyId: companyId,
                    chargePointUserId: createdUser.id
                }
            }).unwrap();
            toast.notifySuccess(text("lblNewUsercreated"));
            await onSuccess();
        } catch  {
            toast.notifyError(text("msgUserNotSaved"));
        }
    };
    const isLoading = isCreatingUser || isAddingRole || isInvitingUser || isSubmitting;
    const submitDisabled = isLoading || isSubmitted && !isValid;
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: onHide
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCreate"),
        type: "submit",
        form: $5072c6778b232ed2$var$formId,
        disabled: submitDisabled,
        loading: isLoading
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        header: text("lblNewUserDialog"),
        visible: visible,
        onHide: onHide,
        footer: footer,
        "data-testid": "create-user-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $5072c6778b232ed2$var$formId,
        onSubmit: handleSubmit(submit),
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "formgrid grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 md:col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "create-user-first-name",
        label: text("lblFirstName"),
        required: true,
        error: errors.firstName?.message,
        ...register("firstName", {
            required: text("msgFirstNameRequired")
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 md:col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "create-user-last-name",
        label: text("lblLastNameField"),
        required: true,
        error: errors.lastName?.message,
        ...register("lastName", {
            required: text("msgLastNameRequired")
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 md:col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "create-user-email",
        type: "email",
        label: text("lblEmail"),
        autoComplete: "email",
        required: true,
        error: errors.email?.message,
        ...register("email", {
            required: text("msgEmailRequired")
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 md:col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "create-user-mobile",
        type: "tel",
        label: text("lblMobile"),
        autoComplete: "tel",
        ...register("mobile")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 md:col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "create-user-password",
        type: "password",
        label: text("lblNewPasswordField"),
        autoComplete: "new-password",
        subtitle: text("msgMinimumPasswordLength"),
        required: true,
        error: errors.password?.message,
        ...register("password", {
            required: text("msgPasswordRequired"),
            minLength: {
                value: 8,
                message: text("msgPasswordToShort")
            }
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 md:col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "create-user-confirm-password",
        type: "password",
        label: text("lblConfirmPasswordField"),
        autoComplete: "new-password",
        required: true,
        error: errors.confirmPassword?.message,
        ...register("confirmPassword", {
            required: text("msgPasswordDoNotMatch"),
            deps: "password",
            validate: (value)=>value === getValues("password") || text("msgPasswordDoNotMatch")
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 mb-0",
        role: "group",
        "aria-labelledby": "create-user-role-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        id: "create-user-role-label",
        className: "p-label block mb-2 required-label"
    }, text("lblRole")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "roleInCompany",
        control: control,
        rules: {
            required: text("msgRequiredShort")
        },
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex flex-column gap-2"
            }, $5072c6778b232ed2$var$userRoles.map((role)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                    key: role.value,
                    className: "flex align-items-center gap-2"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $fL2dz.RadioButton), {
                    inputId: `create-user-role-${role.value}`,
                    value: role.value,
                    name: field.name,
                    checked: field.value === role.value,
                    onBlur: field.onBlur,
                    onChange: (event)=>field.onChange(event.value),
                    "data-testid": role.testId
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
                    htmlFor: `create-user-role-${role.value}`
                }, text(role.labelCode)))))
    }), errors.roleInCompany?.message ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dE8RX.Message), {
        severity: "error",
        text: errors.roleInCompany.message,
        className: "mt-2"
    }) : null))));
});




var $9c7d2f5b2d3027a4$var$SortParameter;
(function(SortParameter) {
    SortParameter["FIRSTNAME"] = "firstName";
    SortParameter["EMAIL"] = "email";
    SortParameter["MOBILE"] = "mobile";
})($9c7d2f5b2d3027a4$var$SortParameter || ($9c7d2f5b2d3027a4$var$SortParameter = {}));
const $9c7d2f5b2d3027a4$export$107317390f5aa598 = /*#__PURE__*/ (0, $7E7Dk.memo)(function UsersPage() {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const dispatch = (0, $2rQNl.useDispatch)();
    const [createUserDialogVisible, setCreateUserDialogVisible] = (0, $7E7Dk.useState)(false);
    const [searchValue, setSearchValue] = (0, $7E7Dk.useState)("");
    const [sortFilter, setSortFilter] = (0, $7E7Dk.useState)({
        parameter: "email",
        order: 1
    });
    const user = (0, $2rQNl.useSelector)((state)=>state.user);
    const isAdmin = (0, $cbseE.default)(user, user.selectedCompanyId, (0, $cRXmD.default).Admin);
    const { data: users, isFetching: loading, refetch: refetch } = (0, $1O9Jh.useCompanyGetUsersQuery)({
        companyId: user.selectedCompanyId
    }, {
        skip: !user.selectedCompanyId,
        refetchOnMountOrArgChange: true
    });
    const [removeUser] = (0, $1O9Jh.useCompanyRemoveUserMutation)();
    const filteredUsers = (0, $7E7Dk.useMemo)(()=>(users ?? []).filter((listedUser)=>(0, $ddca036059d539bb$export$de29389d53f8108f)([
                listedUser.firstName ?? "",
                listedUser.mobile ?? "",
                listedUser.lastName ?? "",
                listedUser.email ?? "",
                listedUser.userStatus
            ], searchValue)), [
        searchValue,
        users
    ]);
    const removeUserValue = async (userId)=>{
        const confirmed = await (0, $9p3YO.confirm)({
            header: text("lblProceedConfirmation"),
            message: text("msgRemoveUser"),
            variant: "danger"
        });
        if (!confirmed) return;
        try {
            await removeUser({
                userId: userId,
                companyId: user.selectedCompanyId
            }).unwrap();
            toast.notifySuccess(text("msgUserRemoved"));
            await refetch();
        } catch (error) {
            const messageCode = (0, $aoz19.getErrorMessageCode)(error);
            if (messageCode === "msgUserWithMDCantBeRemovedFromCompany") {
                toast.notifyError(text("msgUserWithMDCantBeRemovedFromCompany"));
                return;
            }
            if (messageCode === "msgUserWithTagsCantBeRemovedFromCompany") {
                toast.notifyError(text("msgUserWithTagsCantBeRemovedFromCompany"));
                return;
            }
            toast.notifyError(text("msgUserNotRemoved"));
        }
    };
    const onSort = (event)=>{
        setSortFilter({
            parameter: event.sortField,
            order: event.sortOrder === -1 ? -1 : 1
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: text("lblUsers"),
        headerButtons: isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            label: text("btnCreate"),
            icon: "pi pi-plus",
            onClick: ()=>setCreateUserDialogVisible(true),
            "data-testid": "create-user"
        }) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex mb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "user-search",
        type: "search",
        value: searchValue,
        onChange: (event)=>setSearchValue(event.target.value),
        placeholder: text("lblSearch"),
        "aria-label": text("lblSearch"),
        icon: "pi pi-search",
        className: "w-full md:w-20rem",
        "data-testid": "search"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: filteredUsers,
        loading: loading,
        sortField: sortFilter.parameter,
        sortOrder: sortFilter.order,
        onSort: onSort,
        emptyMessage: searchValue ? text("msgNoResultsFound") : text("msgNoData"),
        "data-testid": "users-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "firstName",
        header: text("lblName"),
        sortable: true,
        body: (listedUser)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.Link), {
                to: `/user/${listedUser.id}`,
                onClick: ()=>dispatch((0, $d66a8c58f38f865e$export$cb57a0abd67769d3)(listedUser))
            }, listedUser.firstName, " ", listedUser.lastName)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "email",
        header: text("lblEmail"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "mobile",
        header: text("lblMobile"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "userStatus",
        header: text("lblStatus"),
        body: (listedUser)=>listedUser.userStatus === "Valid" ? text("lblValidStatus") : text("lblInvalidStatus")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "roleInCompany",
        header: text("lblRole")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        body: (listedUser)=>isAdmin && listedUser.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex justify-content-end gap-2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                type: "button",
                icon: "pi pi-times",
                size: "small",
                outlined: true,
                rounded: true,
                severity: "danger",
                "aria-label": text("btnRemove"),
                tooltip: text("btnRemove"),
                tooltipOptions: {
                    position: "top"
                },
                onClick: ()=>void removeUserValue(listedUser.id)
            })) : null
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5072c6778b232ed2$export$bc6de2b7e495d4b5), {
        visible: createUserDialogVisible,
        onHide: ()=>setCreateUserDialogVisible(false),
        onSuccess: async ()=>{
            await refetch();
            setCreateUserDialogVisible(false);
        }
    }));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $gRonV = parcelRequire("gRonV");

var $3um4r = parcelRequire("3um4r");
var $4AX6R = parcelRequire("4AX6R");

var $1ot1u = parcelRequire("1ot1u");

var $1O9Jh = parcelRequire("1O9Jh");

var $eGlQL = parcelRequire("eGlQL");

var $r38ZI = parcelRequire("r38ZI");

var $26yAo = parcelRequire("26yAo");

var $2nOeJ = parcelRequire("2nOeJ");

var $ilUpc = parcelRequire("ilUpc");

var $igvrl = parcelRequire("igvrl");

var $5u6k9 = parcelRequire("5u6k9");
const $ff5dcb1437c56c04$var$ButtonContainer = (0, $gRonV.default).div`
    margin-bottom: 20px;
    justify-content: flex-end;
    display: flex;
    gap: 4px;
`;
const $ff5dcb1437c56c04$export$51ad302672431b01 = /*#__PURE__*/ (0, $7E7Dk.memo)(function AdminUsersWidget() {
    const text = (0, $5u6k9.default)();
    const [pools, setPools] = (0, $7E7Dk.useState)([]);
    const { id: userId } = (0, $4AX6R.useParams)();
    const navigate = (0, $3um4r.useNavigate)();
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const { data: data, isLoading: loadingInitialData } = (0, $1O9Jh.useCompanyGetPoolsWithNfcInfoQuery)({
        companyId: companyId,
        userId: userId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    const [updateAccess, { isLoading: isLoading }] = (0, $1O9Jh.useCompanySetPoolsNfcInfoMutation)();
    (0, $7E7Dk.useEffect)(()=>{
        if (data) setPools([
            ...data
        ]);
    }, [
        data
    ]);
    const updateNfcAccess = (pool)=>{
        const newPoolsArray = pools.map((p)=>{
            if (pool.id === p.id) return {
                ...pool,
                hasNfcAccess: !pool.hasNfcAccess
            };
            return p;
        });
        setPools(newPoolsArray);
    };
    const save = async ()=>{
        try {
            await updateAccess({
                userId: userId,
                companyId: companyId,
                body: pools
            }).unwrap();
            (0, $r38ZI.notifySuccess)(text("lblRFIDAccessToPoolsUpdated"), true);
            navigate(`/user/${userId}`);
        } catch (e) {
            console.error(e);
            (0, $r38ZI.notifyError)(text("lblSomethingWentWrong"), true);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($ff5dcb1437c56c04$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnSave"),
        icon: "pi pi-save",
        onClick: ()=>save(),
        loading: isLoading,
        "data-testid": "btnSave"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnBack"),
        icon: "pi pi-arrow-left",
        outlined: true,
        onClick: ()=>navigate(`/user/${userId}`),
        "data-testid": "btnBack"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: text("lblPoolsPage")
    }, userId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.Table), {
        "data-testid": "table-rfid-access"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
        "data-testid": "h-cell-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
        "data-testid": "h-cell-access"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblRFIDAccess"
    })))), !loadingInitialData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBody), null, pools?.map((p)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), {
            key: p.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": "b-cell-name"
        }, p.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": "b-cell-access"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.Toggle), {
            "data-testid": "pools-toggle",
            isToggled: p.hasNfcAccess ?? false,
            toggleFn: ()=>updateNfcAccess(p)
        })))))), loadingInitialData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "shimmer-container shimmer-small"
    })));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $2rQNl = parcelRequire("2rQNl");

var $3um4r = parcelRequire("3um4r");
var $4AX6R = parcelRequire("4AX6R");

var $1ot1u = parcelRequire("1ot1u");

var $1O9Jh = parcelRequire("1O9Jh");

var $eGlQL = parcelRequire("eGlQL");

var $r38ZI = parcelRequire("r38ZI");

var $4gSsL = parcelRequire("4gSsL");

var $26yAo = parcelRequire("26yAo");

var $2nOeJ = parcelRequire("2nOeJ");

var $ilUpc = parcelRequire("ilUpc");

var $igvrl = parcelRequire("igvrl");


var $5u6k9 = parcelRequire("5u6k9");
const $2713497242aaaecb$var$ButtonContainer = (0, $gRonV.default).div`
    margin-bottom: 20px;
    justify-content: flex-end;
    display: flex;
    gap: 4px;
`;
const $2713497242aaaecb$var$ToggleContainer = (0, $gRonV.default).span`
    display: flex;
    flex-direction: column;
`;
const $2713497242aaaecb$var$ToggleItem = (0, $gRonV.default).span`
    display: flex;
    flex-direction: row;
    align-items: center;
`;
const $2713497242aaaecb$export$11c799359c81f5d8 = /*#__PURE__*/ (0, $7E7Dk.memo)(function UserChargepointsPage() {
    const text = (0, $5u6k9.default)();
    const navigate = (0, $3um4r.useNavigate)();
    const [chargePoints, setChargePoints] = (0, $7E7Dk.useState)([]);
    const [changedChargePoints, setChangedChargePoints] = (0, $7E7Dk.useState)([]);
    const adaptConnectorNaming = (0, $4gSsL.useAdaptConnectorNaming)();
    const { id: userId } = (0, $4AX6R.useParams)();
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const [searchValue, setSearchValue] = (0, $7E7Dk.useState)("");
    const { data: initialChargePoints, isFetching: isFetching } = (0, $1O9Jh.useCompanyGetChargePointsWithNfcInfoQuery)({
        userId: userId,
        companyId: companyId
    }, {
        refetchOnMountOrArgChange: true
    });
    const [updateChargepointsNfcAccess, { isLoading: saving }] = (0, $1O9Jh.useCompanySetChargePointsNfcInfoMutation)();
    (0, $7E7Dk.useEffect)(()=>{
        if (initialChargePoints) setChargePoints(initialChargePoints);
    }, [
        initialChargePoints
    ]);
    const updateNfcAccess = (chargePointId, connectorId, hasNfcAccess)=>{
        const newChargePointArray = chargePoints.map((c)=>{
            if (c.id === chargePointId) return {
                ...c,
                connectors: c?.connectors?.map((conn)=>{
                    if (conn.connectorId === connectorId) return {
                        ...conn,
                        hasNfcAccess: hasNfcAccess
                    };
                    return conn;
                })
            };
            return c;
        });
        setChargePoints(newChargePointArray);
        let isExisting = false;
        const tempChanged = changedChargePoints.map((c)=>{
            if (c.chargePointId === chargePointId && c.connectorId === connectorId) {
                isExisting = true;
                return {
                    ...c,
                    hasNfcAccess: hasNfcAccess
                };
            }
            return c;
        });
        if (!isExisting) tempChanged.push({
            chargePointId: chargePointId,
            connectorId: connectorId,
            hasNfcAccess: hasNfcAccess
        });
        setChangedChargePoints(tempChanged);
    };
    const save = async ()=>{
        try {
            await updateChargepointsNfcAccess({
                companyId: companyId,
                userId: userId,
                body: changedChargePoints
            }).unwrap();
            (0, $r38ZI.notifySuccess)(text("lblRFIDAccessToChargersUpdated"), true);
            navigate(`/user/${userId}`);
        } catch (e) {
            console.error(e);
            (0, $r38ZI.notifyError)(text("lblSomethingWentWrong"), true);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($2713497242aaaecb$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnSave"),
        icon: "pi pi-save",
        "data-testid": "btnSave",
        loading: saving,
        onClick: ()=>save()
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnBack"),
        icon: "pi pi-arrow-left",
        outlined: true,
        onClick: ()=>navigate(`/user/${userId}`),
        "data-testid": "btnBack"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: text("lblChargers")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "row margin-bottom-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-xs-12 col-md-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("input", {
        "data-testid": "search",
        type: "text",
        name: "search",
        id: "search",
        className: "form-control",
        value: searchValue,
        onChange: (event)=>setSearchValue(event.target.value),
        placeholder: text("lblSearch")
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
        "data-testid": "h-cell-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblId"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
        "data-testid": "h-cell-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
        "data-testid": "h-cell-access"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblRFIDAccess"
    })))), !isFetching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBody), null, chargePoints?.filter((c)=>(0, $ddca036059d539bb$export$de29389d53f8108f)([
            c.id,
            c.name ?? ""
        ], searchValue))?.map((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), {
            key: c.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": "b-cell-id"
        }, c.id), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": "b-cell-name"
        }, c.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": "b-cell-access"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($2713497242aaaecb$var$ToggleContainer, null, c?.connectors?.map((conn)=>{
            if (conn.connectorFunctionType === "Charger") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($2713497242aaaecb$var$ToggleItem, {
                key: conn.connectorId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ilUpc.default), {
                "data-testid": `connector-toggle-${conn.connectorId}`,
                key: conn.connectorId,
                size: "md",
                isToggled: conn?.hasNfcAccess ?? false,
                toggleFn: ()=>{
                    updateNfcAccess(c.id, conn.connectorId, !conn?.hasNfcAccess);
                }
            }), adaptConnectorNaming(conn.name));
        }))))))), isFetching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "shimmer-container shimmer-small"
    })));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $gRonV = parcelRequire("gRonV");

var $1ot1u = parcelRequire("1ot1u");

var $3um4r = parcelRequire("3um4r");
var $4AX6R = parcelRequire("4AX6R");

var $1O9Jh = parcelRequire("1O9Jh");

var $eGlQL = parcelRequire("eGlQL");

var $r38ZI = parcelRequire("r38ZI");

var $26yAo = parcelRequire("26yAo");

var $2nOeJ = parcelRequire("2nOeJ");

var $igvrl = parcelRequire("igvrl");

var $5u6k9 = parcelRequire("5u6k9");
const $e0b2f92f02eafec8$var$ButtonContainer = (0, $gRonV.default).div`
    margin-bottom: 20px;
    justify-content: flex-end;
    display: flex;
    gap: 4px;
`;
const $e0b2f92f02eafec8$var$InputContainer = (0, $gRonV.default).div`
    max-width: 300px;
    margin-bottom: 20px;
`;
const $e0b2f92f02eafec8$export$39bb14b1a5fcc6b8 = /*#__PURE__*/ (0, $7E7Dk.memo)(function UserNfcTagsPage() {
    const text = (0, $5u6k9.default)();
    const { id: userId } = (0, $4AX6R.useParams)();
    const navigate = (0, $3um4r.useNavigate)();
    const [searchFilter, setSearchFilter] = (0, $7E7Dk.useState)("");
    const [buttonLoading, setButtonLoading] = (0, $7E7Dk.useState)("");
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const { data: nfcTags, isLoading: isLoading } = (0, $1O9Jh.useCompanyGetNfcTagsQuery)({
        companyId: companyId
    }, {
        refetchOnMountOrArgChange: true
    });
    const [connectNfcToUser] = (0, $1O9Jh.useNfcTagConnectToUserMutation)();
    const addToUser = async (tagId)=>{
        setButtonLoading(tagId);
        try {
            await connectNfcToUser({
                nfcTagId: tagId,
                userId: userId
            }).unwrap();
            (0, $r38ZI.notifySuccess)(text("msgRFIDTagAddedToUser"), true);
            navigate(`/user/${userId}`);
        } catch (e) {
            console.error(e);
            (0, $r38ZI.notifyError)(text("msgRFIDTagCouldNotBeAdded"), true);
            setButtonLoading("");
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e0b2f92f02eafec8$var$ButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnBack"),
        icon: "pi pi-arrow-left",
        outlined: true,
        onClick: ()=>navigate(`/user/${userId}`),
        "data-testid": "btnBack"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: text("lblRFIDPage")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($e0b2f92f02eafec8$var$InputContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("input", {
        type: "text",
        name: "search",
        id: "search",
        placeholder: text("lblSearch"),
        className: "form-control",
        onChange: (e)=>setSearchFilter(e.target.value)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "h-cell-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblId"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "h-cell-comment"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblComment"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "h-cell-user"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBody), null, nfcTags?.filter((tag)=>{
        const search = searchFilter.toString().toLocaleLowerCase();
        return tag.id?.toString().toLocaleLowerCase().includes(search) || tag.comment?.toLowerCase()?.includes(search) || tag.firstName?.toLowerCase()?.includes(search) || tag.lastName?.toLowerCase()?.includes(search);
    })?.map((tag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), {
            key: tag.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": "b-cell-id"
        }, tag?.id), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": "b-cell-comment"
        }, tag?.comment), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": "b-cell-id"
        }, tag?.firstName ? `${tag.firstName} ${tag.lastName}` : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            size: "small",
            label: text("btnAssignToUser"),
            icon: "pi pi-user-plus",
            onClick: ()=>tag.id && addToUser(tag.id),
            loading: buttonLoading === tag.id,
            "data-testid": "add-to-user-btn"
        })))))), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "shimmer-container shimmer-small"
    })));
});





var $76MyM = parcelRequire("76MyM");

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $3um4r = parcelRequire("3um4r");

var $5E6A5 = parcelRequire("5E6A5");

var $1ot1u = parcelRequire("1ot1u");

var $6oqHU = parcelRequire("6oqHU");

var $ej4sl = parcelRequire("ej4sl");
var $5df7d0ee5876103b$export$edd0ae81c67ebc59;
(function(SortOrders) {
    SortOrders["Ascending"] = "Ascending";
    SortOrders["Descending"] = "Descending";
})($5df7d0ee5876103b$export$edd0ae81c67ebc59 || ($5df7d0ee5876103b$export$edd0ae81c67ebc59 = {}));



var $r38ZI = parcelRequire("r38ZI");
const $9e8b90404b272fcf$var$chargePointHasPool = (chargePoint)=>chargePoint.poolId !== "00000000-0000-0000-0000-000000000000" && chargePoint.poolId !== undefined && chargePoint.poolId !== null;
var $9e8b90404b272fcf$export$2e2bcd8739ae039 = $9e8b90404b272fcf$var$chargePointHasPool;



var $3RGGz = parcelRequire("3RGGz");

var $26yAo = parcelRequire("26yAo");

var $6L9Rn = parcelRequire("6L9Rn");
const $e6714e0e278f2c23$export$b108a22f683cb589 = (blobData, name = "data")=>{
    const blob = new Blob([
        blobData
    ], {
        type: "text/csv"
    });
    const browserNavigator = window.navigator;
    if (browserNavigator && browserNavigator.msSaveOrOpenBlob) browserNavigator.msSaveBlob(blob, `${name}.csv`);
    else {
        const elem = window.document.createElement("a");
        elem.href = window.URL.createObjectURL(blob);
        elem.download = `${name}.csv`;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }
};



var $5MLZI = parcelRequire("5MLZI");

var $1O9Jh = parcelRequire("1O9Jh");

var $9WSfA = parcelRequire("9WSfA");

var $7E7Dk = parcelRequire("7E7Dk");

var $hhoFb = parcelRequire("hhoFb");
const $826f4943e22083e5$var$ImportIcon = ({ fill: fill = "currentColor", size: size = 14, title: title, id: id = "info-icon" })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhoFb.SIconSpan), {
        title: title,
        id: id,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: fill ?? "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-upload-cloud"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("polyline", {
        points: "16 16 12 12 8 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("line", {
        x1: "12",
        y1: "12",
        x2: "12",
        y2: "21"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("polyline", {
        points: "16 16 12 12 8 16"
    })));
};
var $826f4943e22083e5$export$2e2bcd8739ae039 = $826f4943e22083e5$var$ImportIcon;



var $7E7Dk = parcelRequire("7E7Dk");

var $hhoFb = parcelRequire("hhoFb");
const $5aa3038cf7e43aea$var$DownloadIcon = ({ fill: fill = "currentColor", size: size = 14, title: title, id: id = "download-icon" })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hhoFb.SIconSpan), {
        title: title,
        id: id,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("g", {
        clipPath: "url(#clip0_3375_9880)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M11.8 2H10.2V11H11.8V2Z",
        fill: fill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M11 15.9092C11.856 15.9092 12.656 15.5656 13.264 14.952L18.728 9.36377H16.456L12.128 13.7901C11.832 14.101 11.424 14.2729 11 14.2729C10.576 14.2729 10.168 14.101 9.87197 13.7901L5.54397 9.36377H3.27197L8.73597 14.952C9.34397 15.5656 10.144 15.9092 11 15.9092Z",
        fill: fill
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M19 18.3638H3V20.0001H19V18.3638Z",
        fill: fill
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("clipPath", {
        id: "clip0_3375_9880"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("rect", {
        width: "16",
        height: "18",
        fill: "white",
        transform: "translate(3 2)"
    })))));
};
var $5aa3038cf7e43aea$export$2e2bcd8739ae039 = $5aa3038cf7e43aea$var$DownloadIcon;



var $6GGmy = parcelRequire("6GGmy");

var $bAq2r = parcelRequire("bAq2r");

var $5u6k9 = parcelRequire("5u6k9");

var $gGcRO = parcelRequire("gGcRO");

var $g915J = parcelRequire("g915J");

var $9p3YO = parcelRequire("9p3YO");

var $aCffN = parcelRequire("aCffN");

var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $2rQNl = parcelRequire("2rQNl");

var $1ot1u = parcelRequire("1ot1u");

var $1O9Jh = parcelRequire("1O9Jh");

var $MMfqT = parcelRequire("MMfqT");

var $1o9MR = parcelRequire("1o9MR");

var $aCffN = parcelRequire("aCffN");

var $5u6k9 = parcelRequire("5u6k9");
const $f4dc7c5db0eb5807$var$formId = "add-charge-point-form";
const $f4dc7c5db0eb5807$export$58199e6f500a92fe = /*#__PURE__*/ (0, $7E7Dk.memo)(function AddChargePointDialog({ visible: visible, onSuccess: onSuccess, onHide: onHide }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const [addChargePoint, { isLoading: isLoading }] = (0, $1O9Jh.useCompanyAddChargePointToCompanyMutation)();
    const { register: register, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isSubmitted: isSubmitted, isSubmitting: isSubmitting, isValid: isValid } } = (0, $cCnqE.useForm)({
        defaultValues: {
            id: "",
            wifiPassword: ""
        },
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    (0, $7E7Dk.useEffect)(()=>{
        if (visible) reset();
    }, [
        reset,
        visible
    ]);
    const doAddChargePoint = async (formValues)=>{
        try {
            await addChargePoint({
                companyId: companyId,
                chargePointCredentials: formValues
            }).unwrap();
            toast.notifySuccess(text("lblChargerWasAdded"));
            onSuccess();
        } catch  {
            toast.notifyError(text("msgChargerFailedToAdd"));
        }
    };
    const submitDisabled = isLoading || isSubmitting || isSubmitted && !isValid;
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: onHide
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnAdd"),
        type: "submit",
        form: $f4dc7c5db0eb5807$var$formId,
        disabled: submitDisabled,
        loading: isLoading || isSubmitting
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        header: text("lblAddChargerDialogTitle"),
        visible: visible,
        onHide: onHide,
        footer: footer,
        "data-testid": "add-charge-point-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $f4dc7c5db0eb5807$var$formId,
        onSubmit: handleSubmit(doAddChargePoint),
        className: "flex flex-column gap-3",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "id",
        label: text("lblSerialNumberField"),
        ...register("id", {
            required: text("msgAddChargePointSerialNumberRequired")
        }),
        error: errors.id?.message,
        required: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "wifiPassword",
        label: text("lblPin"),
        ...register("wifiPassword", {
            required: text("msgPinCodeRequired")
        }),
        error: errors.wifiPassword?.message,
        required: true
    })));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $1ot1u = parcelRequire("1ot1u");

var $ej4sl = parcelRequire("ej4sl");

var $gAFX4 = parcelRequire("gAFX4");

var $cpfnh = parcelRequire("cpfnh");

var $5u6k9 = parcelRequire("5u6k9");

var $MMfqT = parcelRequire("MMfqT");

var $g915J = parcelRequire("g915J");

var $aCffN = parcelRequire("aCffN");

var $1hIPE = parcelRequire("1hIPE");

var $hohPv = parcelRequire("hohPv");

var $3rYDT = parcelRequire("3rYDT");

var $lFIQ9 = parcelRequire("lFIQ9");

var $igvrl = parcelRequire("igvrl");

var $2YlDj = parcelRequire("2YlDj");

var $7E7Dk = parcelRequire("7E7Dk");

var $3T1QU = parcelRequire("3T1QU");

var $5u6k9 = parcelRequire("5u6k9");

var $1hIPE = parcelRequire("1hIPE");

var $hohPv = parcelRequire("hohPv");

var $3rYDT = parcelRequire("3rYDT");

var $lFIQ9 = parcelRequire("lFIQ9");
const $e7170679611e42da$export$1e933131e22bdef0 = /*#__PURE__*/ (0, $7E7Dk.memo)((props)=>{
    const text = (0, $5u6k9.default)();
    const connectors = props.chargePoint.connectors ?? [];
    const onePVal = (connector)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, text("msgImportInst"), ":", connector.installationPhaseMode, "-", connector.installationPhase, "-", connector.installationCurrent, "A, LB:", connector.loadBalancerOfflinePhase, "-", connector.loadBalancerOfflineCurrent, "A");
    const threePVal = (connector)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, text("msgImportInst"), ":", connector.installationPhaseMode, "-", connector.installationCurrent, " A, LB:", connector.loadBalancerOfflinePhase, "-", connector.loadBalancerOfflineCurrent, " A");
    const renderConnectorInfo = (connector)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, (connector.installationPhaseMode === (0, $3T1QU.PhaseMode).onePhase || connector.installationPhaseMode === null) && onePVal(connector), connector.installationPhaseMode === (0, $3T1QU.PhaseMode).threePhase && threePVal(connector));
    };
    const renderAuraInformation = ()=>connectors.map((connector, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, {
                key: connector.connectorId ?? index
            }, renderConnectorInfo(connector)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, (0, $1hIPE.isAuraImport)(props.chargePoint) ? renderAuraInformation() : null, ((0, $3rYDT.isHaloImport)(props.chargePoint) || (0, $hohPv.isDawnImport)(props.chargePoint) || (0, $lFIQ9.isLunaImport)(props.chargePoint)) && connectors[0] ? renderConnectorInfo(connectors[0]) : null);
});


const $fcb2dc52609729cf$var$importResultSeverityClass = {
    danger: "text-red-500",
    info: "text-blue-500",
    warning: "text-yellow-600"
};
const $fcb2dc52609729cf$var$ImportResultInfo = ({ ariaLabel: ariaLabel, icon: icon, messages: messages, severity: severity, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: `import-result-info-tooltip inline-flex align-items-center justify-content-center text-xl ${$fcb2dc52609729cf$var$importResultSeverityClass[severity]}`,
        role: "img",
        tabIndex: 0,
        "aria-label": ariaLabel,
        "data-testid": testId,
        "data-pr-tooltip": messages.join(" \u2022 ")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
        className: icon,
        "aria-hidden": "true"
    }));
};
const $fcb2dc52609729cf$var$initialImportSession = {
    input: "",
    results: []
};
const $fcb2dc52609729cf$export$c3b4e3f0e76c357c = /*#__PURE__*/ (0, $7E7Dk.memo)(function ImportChargePointsDialog({ visible: visible, onSuccess: onSuccess, onHide: onHide }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const [session, setSession] = (0, $7E7Dk.useState)($fcb2dc52609729cf$var$initialImportSession);
    const [showInfoMessage, setShowInfoMessage] = (0, $7E7Dk.useState)(false);
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const [validateImport, { isLoading: isValidating }] = (0, $2YlDj.useValidateImportMutation)();
    const [importChargePoints, { isLoading: isImporting }] = (0, $2YlDj.useImportChargepointsMutation)();
    const doImportChargePoints = async ()=>{
        try {
            await importChargePoints({
                companyId: companyId,
                importData: session.results
            }).unwrap();
            onSuccess();
        } catch  {
            toast.notifyError(text("lblSomethingWentWrong"));
        }
    };
    const doValidateImport = async (event)=>{
        const clipboardText = event.clipboardData.getData("text");
        setSession({
            input: clipboardText.trim(),
            results: []
        });
        try {
            const results = await validateImport({
                companyId: companyId,
                importData: clipboardText
            }).unwrap();
            setSession({
                input: "",
                results: results,
                isValid: !results.some((result)=>result.hasError)
            });
        } catch (error) {
            const responseData = error.data;
            setSession({
                input: "",
                results: Array.isArray(responseData) ? responseData : [],
                isValid: false
            });
            toast.notifyError(text("msgImportChargersFailed"));
        }
    };
    const updateInput = (event)=>{
        setSession({
            input: event.target.value,
            results: []
        });
    };
    const getDetails = (importRow)=>{
        const details = [];
        const connectors = importRow.connectors ?? [];
        const firstConnector = connectors[0];
        if (importRow.description !== undefined && importRow.description !== null) details.push(`${text("lblDescription")}: ${importRow.description}`);
        if (importRow.partnerDescription !== undefined && importRow.partnerDescription !== null) details.push(`${text("lblPartnerInfo")}: ${importRow.partnerDescription}`);
        if (importRow.hasServiceAgreement !== undefined && importRow.hasServiceAgreement !== null) details.push(`${text("lblHasServiceAgreement")}: ${importRow.hasServiceAgreement}`);
        if (importRow.installationDate !== undefined && importRow.installationDate !== null) details.push(`${text("lblInstallationDate")}: ${importRow.installationDate}`);
        if ((0, $1hIPE.isAuraImport)(importRow)) connectors.forEach((connector, index)=>{
            const connectorId = index + 1;
            if (connector.mode !== undefined) details.push(`${text("lblSocketMode", {
                name: connectorId
            })}: ${connector.mode}`);
            if (connector.nfcLocked !== undefined) details.push(`${text("lblSocketRfidLocked", {
                name: connectorId
            })}: ${connector.nfcLocked}`);
        });
        else if (((0, $hohPv.isDawnImport)(importRow) || (0, $lFIQ9.isLunaImport)(importRow)) && firstConnector) details.push(`${text("lblInstallationOfflinePhase")}: ${firstConnector.loadBalancerOfflinePhase}`, `${text("lblInstallationOfflineCurrent")}: ${firstConnector.loadBalancerOfflineCurrent}`);
        else if ((0, $3rYDT.isHaloImport)(importRow) && connectors.length > 1) details.push(`${text("lblChargerMode")}: ${connectors[0].mode}`, `${text("lblSchukoMode")}: ${connectors[1].mode}`, `${text("lblRFIDLocked")}: ${connectors[0].nfcLocked}`);
        return details.length > 0 ? details : [
            text("lblImportDetails")
        ];
    };
    const renderDetails = (importRow)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($fcb2dc52609729cf$var$ImportResultInfo, {
            ariaLabel: text("lblImportDetails"),
            icon: "pi pi-info-circle",
            messages: getDetails(importRow),
            severity: "info",
            testId: `import-details-${importRow.id}`
        });
    const renderValidationMessages = (importRow)=>{
        const errorReasons = importRow.errorReason ?? [];
        const warningReasons = importRow.warningReason ?? [];
        const reasons = errorReasons.concat(importRow.hasError ? [] : warningReasons);
        return reasons.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($fcb2dc52609729cf$var$ImportResultInfo, {
            ariaLabel: text("lblShowImportValidationMessages"),
            icon: "pi pi-exclamation-triangle",
            messages: reasons,
            severity: importRow.hasError ? "danger" : "warning",
            testId: `import-validation-messages-${importRow.id}`
        }) : null;
    };
    const header = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, text("lblChargersImportModal")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        icon: "pi pi-info-circle",
        severity: "info",
        text: true,
        rounded: true,
        "aria-label": text("lblImportDetails"),
        tooltip: text("lblImportDetails"),
        tooltipOptions: {
            position: "top"
        },
        onClick: ()=>setShowInfoMessage((showInfo)=>!showInfo)
    }));
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: onHide
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnImport"),
        type: "button",
        disabled: !session.isValid || isValidating || isImporting,
        loading: isImporting,
        onClick: doImportChargePoints,
        "data-testid": "import-chargepoints-button"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        header: header,
        visible: visible,
        onHide: onHide,
        focusOnShow: false,
        style: {
            width: "60rem"
        },
        breakpoints: {
            "960px": "90vw",
            "641px": "95vw"
        },
        footer: footer,
        "data-testid": "import-charge-points-dialog"
    }, showInfoMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("section", {
        className: "max-h-20rem overflow-y-auto p-3 border-1 border-200 border-round mb-3",
        "data-testid": "info-msg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "msgImportChargersFileTip"
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "mb-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gAFX4.InputTextarea), {
        id: "import-charge-points-input",
        className: "w-full",
        placeholder: text("msgPasteLinesField"),
        "aria-label": text("msgPasteLinesField"),
        value: session.input,
        onChange: updateInput,
        onPaste: doValidateImport,
        autoFocus: true,
        rows: 6,
        autoResize: true,
        disabled: isValidating || isImporting,
        "data-testid": "paste-textarea"
    })), session.results.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cpfnh.Tooltip), {
        target: ".import-result-info-tooltip",
        position: "top"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: session.results,
        dataKey: "id",
        scrollable: true,
        scrollHeight: "24rem",
        rowClassName: (importRow)=>({
                "bg-red-50": !!importRow.hasError,
                "bg-yellow-50": !importRow.hasError && (importRow.warningReason?.length ?? 0) > 0
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "id",
        header: text("lblSerialNumberColumn")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "name",
        header: text("lblName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "supplyCurrent",
        header: text("lblSupplyCurrent"),
        body: (importRow)=>importRow.supplyCurrent ? `${importRow.supplyCurrent} A` : null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        header: text("lblSocketSettings"),
        body: (importRow)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e7170679611e42da$export$1e933131e22bdef0), {
                chargePoint: importRow
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        header: text("lblDetails"),
        body: renderDetails
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        header: text("lblErrorReason"),
        body: renderValidationMessages
    }))) : null);
});




const $fa94066ef9392a1a$var$mapSearchParamsToFilter = ({ id: id, imsiNumber: imsiNumber, companyId: companyId, status: status, name: name, ownerEmail: ownerEmail, ownerName: ownerName, ownerMobile: ownerMobile, ocppOnly: ocppOnly, productId: productId })=>{
    return {
        id: id,
        imsiNumber: imsiNumber,
        companyId: companyId,
        status: status,
        name: name,
        ownerEmail: ownerEmail,
        ownerName: ownerName,
        ownerMobile: ownerMobile,
        ocppOnly: ocppOnly,
        productId: productId
    };
};
var $fa94066ef9392a1a$var$SortParameter;
(function(SortParameter) {
    SortParameter["ID"] = "id";
    SortParameter["NAME"] = "name";
    SortParameter["STATUS"] = "chargePointStatus";
    SortParameter["ORGANISATION"] = "companyName";
    SortParameter["LAST_HEARTBEAT"] = "lastHeartbeat";
    SortParameter["OWNER_NAME"] = "ownerName";
    SortParameter["DESCRIPTION"] = "additionalInfo.description";
    SortParameter["LOADBALANCER_GROUP_NAME"] = "loadBalancerGroupName";
    SortParameter["POOL"] = "poolName";
})($fa94066ef9392a1a$var$SortParameter || ($fa94066ef9392a1a$var$SortParameter = {}));
const $fa94066ef9392a1a$export$99edf21a326d7114 = /*#__PURE__*/ (0, $7E7Dk.memo)(function AdminChargepointsPage({ className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const [chargePointModalOpen, setChargePointModalOpen] = (0, $7E7Dk.useState)(false);
    const [currentPage, setCurrentPage] = (0, $7E7Dk.useState)(0);
    const [importChargePointsDialog, setImportChargePointsDialog] = (0, $7E7Dk.useState)({
        visible: false,
        sessionId: 0
    });
    const [pageSize, setPageSize] = (0, $7E7Dk.useState)(20);
    const [sortFilter, setSortFilter] = (0, $7E7Dk.useState)({
        parameter: "id",
        reversed: false
    });
    const [searchParams, setParams] = (0, $3um4r.useSearchParams)();
    const params = Object.fromEntries(searchParams.entries());
    const filter = $fa94066ef9392a1a$var$mapSearchParamsToFilter(params);
    const { isAdmin: isAdmin, selectedCompanyId: companyId } = (0, $2rQNl.useSelector)((state)=>state.user);
    const { currentData: chargePoints, error: error, isFetching: isLoading, refetch: refetch } = (0, $1O9Jh.useCompanyGetChargePointsPagedQuery)({
        id: filter.id,
        CompanyId: companyId,
        companyId: companyId,
        sortOrder: sortFilter.reversed ? (0, $5df7d0ee5876103b$export$edd0ae81c67ebc59).Descending : (0, $5df7d0ee5876103b$export$edd0ae81c67ebc59).Ascending,
        column: sortFilter.parameter,
        page: currentPage,
        noOfItems: pageSize,
        status: filter.status,
        productId: filter.productId,
        name: filter.name,
        imsiNumber: filter.imsiNumber,
        ownerName: filter.ownerName,
        ownerEmail: filter.ownerEmail,
        ownerMobile: filter.ownerMobile,
        ocppOnly: filter.ocppOnly,
        expand: "additionalInfo,ocppConfig"
    }, {
        refetchOnMountOrArgChange: true
    });
    const [removeChargePointMutation] = (0, $1O9Jh.useCompanyRemoveChargePointMutation)();
    const [trigger] = (0, $1O9Jh.useLazyCompanyCreateImportStringQuery)();
    (0, $7E7Dk.useEffect)(()=>{
        if (!error) return;
        (0, $r38ZI.notifyError)((0, $gGcRO.isFetchBaseQueryError)(error) && typeof error.data === "string" ? error.data : text("msgChargersFailedToFetch"));
    }, [
        error,
        text
    ]);
    const downloadImportInfo = async ()=>{
        try {
            (0, $r38ZI.notifySuccess)(text("msgDownloadImportInformationStarted"));
            const response = await trigger({
                companyId: companyId
            });
            if (!response || !response.data) throw Error;
            (0, $e6714e0e278f2c23$export$b108a22f683cb589)(response.data, text("lblImportDataCSVFile"));
        } catch (e) {
            (0, $r38ZI.notifyError)(text("msgDownloadImportInformationFailed"));
        }
    };
    const openAddChargePoint = ()=>{
        setChargePointModalOpen(true);
    };
    const openImportChargePoint = ()=>{
        setImportChargePointsDialog(({ sessionId: sessionId })=>({
                visible: true,
                sessionId: sessionId + 1
            }));
    };
    const hideImportChargePointsDialog = ()=>{
        setImportChargePointsDialog((dialog)=>({
                ...dialog,
                visible: false
            }));
    };
    const removeChargePoint = async (chargePoint)=>{
        const confirmed = await (0, $9p3YO.confirm)({
            header: text("lblProceedConfirmation"),
            message: text("msgConfirmChargerRemoval"),
            variant: "danger"
        });
        if (!confirmed) return;
        try {
            await removeChargePointMutation({
                companyId: companyId,
                chargePointId: chargePoint.id
            }).unwrap();
            refetch();
        } catch (e) {
            (0, $r38ZI.notifyError)(text("msgChargerFailedToRemove"));
        }
    };
    const saveAndClose = ()=>{
        refetch();
        setChargePointModalOpen(false);
    };
    const onPage = (event)=>{
        setCurrentPage(event.page ?? event.first / event.rows);
        setPageSize(event.rows);
    };
    const onSort = (event)=>{
        setSortFilter({
            parameter: event.sortField,
            reversed: event.sortOrder === -1
        });
        setCurrentPage(0);
    };
    const filterSubmit = (filter)=>{
        setParams((0, $5E6A5.pickBy)(filter, (value)=>value !== undefined && value !== null));
        if (currentPage !== 0) setCurrentPage(0);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6oqHU.Card), {
        "data-testid": "table-charge-points",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))("flex-1", className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column md:flex-row justify-content-between gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "mr-auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnAddCharger"),
        icon: "pi pi-plus",
        onClick: openAddChargePoint,
        "data-testid": "open-add-chargepoints-btn"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-2 w-full md:w-6 md:ml-auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5MLZI.ChargePointsSearchWidget), {
        onSubmit: filterSubmit,
        filter: filter
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9WSfA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9WSfA.DropdownMenuItem), {
        onClick: ()=>openImportChargePoint(),
        text: text("lblChargersImportModal"),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $826f4943e22083e5$export$2e2bcd8739ae039), null),
        key: "btnImportChargers",
        "data-testid": "open-import-chargepoints-btn"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9WSfA.DropdownMenuItem), {
        onClick: ()=>downloadImportInfo(),
        text: text("msgDownloadImportInformation"),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5aa3038cf7e43aea$export$2e2bcd8739ae039), null),
        key: "btnDownloadImportInformation",
        "data-testid": "open-download-import-info-btn"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: chargePoints?.items ?? [],
        lazy: true,
        paginator: true,
        first: currentPage * pageSize,
        rows: pageSize,
        totalRecords: chargePoints?.totalCount ?? 0,
        onPage: onPage,
        sortField: sortFilter.parameter,
        sortOrder: sortFilter.reversed ? -1 : 1,
        onSort: onSort,
        loading: isLoading,
        emptyMessage: text("lblNoChargersFound"),
        className: "mt-3",
        "data-testid": "chargepoints-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "id",
        header: text("lblSerialNumberColumnHeader"),
        sortable: true,
        body: (chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.Link), {
                to: `/chargepoints/${chargePoint.id}`
            }, chargePoint.id)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "chargePointStatus",
        header: text("lblStatus"),
        sortable: true,
        body: (chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3RGGz.ChargepointStatus), {
                chargePoint: chargePoint
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "name",
        header: text("lblName"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "additionalInfo.description",
        header: text("lblDescription"),
        sortable: true,
        body: (chargePoint)=>chargePoint.additionalInfo?.description,
        className: "hidden-xs hidden-sm"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "ownerName",
        header: text("lblUserOrOwner"),
        sortable: true,
        body: (chargePoint)=>(0, $6GGmy.getOwner)(chargePoint),
        className: "hidden-xs hidden-sm"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "loadBalancerGroupName",
        header: text("lblLoadBalancerColumnHeader"),
        sortable: true,
        body: (chargePoint)=>chargePoint.loadBalancerGroupId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.Link), {
                to: `/loadbalancer/${chargePoint.loadBalancerGroupId}`
            }, chargePoint.loadBalancerGroupName) : null,
        className: "hidden-xs hidden-sm"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "poolName",
        header: text("lblPool"),
        sortable: true,
        body: (chargePoint)=>(0, $9e8b90404b272fcf$export$2e2bcd8739ae039)(chargePoint) ? chargePoint.poolName : null,
        className: "hidden-xs hidden-sm"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        header: text("lblSettings"),
        body: (chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6L9Rn.default), {
                chargePoint: chargePoint
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        field: "lastHeartbeat",
        header: text("lblOfflineSinceColumnHeader"),
        sortable: true,
        body: (chargePoint)=>chargePoint.chargePointStatus === "Offline" ? (0, $bAq2r.default)(chargePoint.isOcpp ? chargePoint.offlineSince : chargePoint.lastHeartbeat) : null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
        body: (chargePoint)=>isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex justify-content-end gap-2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                type: "button",
                icon: "pi pi-times",
                size: "small",
                outlined: true,
                rounded: true,
                severity: "danger",
                "data-testid": `remove-charge-point-${chargePoint.id}`,
                "aria-label": text("btnRemove"),
                tooltip: chargePoint.loadBalancerGroupId ? text("msgRemoveChargerDisabledLoadBalancer") : text("btnRemove"),
                tooltipOptions: {
                    position: "top",
                    showOnDisabled: true
                },
                onClick: ()=>removeChargePoint(chargePoint),
                disabled: !!chargePoint.loadBalancerGroupId
            })) : null
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $f4dc7c5db0eb5807$export$58199e6f500a92fe), {
        visible: chargePointModalOpen,
        onSuccess: saveAndClose,
        onHide: ()=>setChargePointModalOpen(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $fcb2dc52609729cf$export$c3b4e3f0e76c357c), {
        key: importChargePointsDialog.sessionId,
        visible: importChargePointsDialog.visible,
        onSuccess: ()=>{
            hideImportChargePointsDialog();
            toast.notifySuccess(text("lblChargerWasAdded"));
            refetch();
        },
        onHide: hideImportChargePointsDialog
    }));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $2rQNl = parcelRequire("2rQNl");

var $26yAo = parcelRequire("26yAo");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $cCnqE = parcelRequire("cCnqE");

var $2rQNl = parcelRequire("2rQNl");

var $1ot1u = parcelRequire("1ot1u");

var $igvrl = parcelRequire("igvrl");

var $2nOeJ = parcelRequire("2nOeJ");

var $1O9Jh = parcelRequire("1O9Jh");

var $r38ZI = parcelRequire("r38ZI");

var $iKemc = parcelRequire("iKemc");

var $bnWCl = parcelRequire("bnWCl");

var $5u6k9 = parcelRequire("5u6k9");

var $c6fcw = parcelRequire("c6fcw");

var $aLIw2 = parcelRequire("aLIw2");

var $dos1r = parcelRequire("dos1r");

var $c4hCO = parcelRequire("c4hCO");

var $iUBfY = parcelRequire("iUBfY");
const $deaa6aae70f2a525$var$getFormValues = (company)=>{
    return {
        name: company?.name ?? "",
        phone: company?.phone ?? "",
        contactPerson: company?.contactPerson ?? "",
        address1: company?.address1 ?? "",
        address2: company?.address2 ?? "",
        kWhPrice: company?.kWhPrice ?? 0,
        comment: company?.comment ?? "",
        description: company?.description ?? "",
        ownerReadOnly: company?.ownerReadOnly ?? false,
        email: company?.email ?? "",
        country: company?.country || null
    };
};
const $deaa6aae70f2a525$export$4e56bbf0e7f4ff77 = /*#__PURE__*/ (0, $7E7Dk.memo)(function OrganisationInformationWidget({ className: className, style: style, partner: partner, isPartnerFetching: isPartnerFetching, disabled: disabled }) {
    const text = (0, $5u6k9.default)();
    const { locale: locale } = (0, $aLIw2.useLocalizationContext)();
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const countryOptions = (0, $7E7Dk.useMemo)(()=>Object.entries((0, $dos1r.getNamesWithFallback)(locale)).map(([key, value])=>({
                key: key,
                value: value
            })).sort((a, b)=>a.value.localeCompare(b.value, locale)), [
        locale
    ]);
    const [updateCompany, { isLoading: isSaving }] = (0, $1O9Jh.useCompanyUpdateCompanyMutation)();
    const { data: company, isLoading: isLoading, refetch: refetch } = (0, $1O9Jh.useCompanyGetCompanyByIdQuery)({
        companyId: companyId
    });
    const { register: register, control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isValid: isValid, isDirty: isDirty } } = (0, $cCnqE.useForm)({
        defaultValues: $deaa6aae70f2a525$var$getFormValues(company),
        mode: "onChange",
        delayError: 500
    });
    (0, $7E7Dk.useEffect)(()=>{
        reset($deaa6aae70f2a525$var$getFormValues(company));
    }, [
        company,
        reset
    ]);
    const saveCompany = async (formValues)=>{
        if (disabled) return;
        try {
            await updateCompany({
                company: {
                    ...company,
                    ...formValues
                }
            }).unwrap();
            refetch();
            (0, $r38ZI.notifySuccess)(text("msgCompanyUpdated"));
        } catch  {
            (0, $r38ZI.notifyError)(text("msgCompanyNotUpdated"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        title: text("lblOrganisationInformationWidgetTitle"),
        loadingStatus: isLoading,
        "data-testid": "org-settings-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        className: "flex flex-wrap gap-5",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("section", {
        className: "flex flex-column gap-3 flex-grow-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "name",
        "data-testid": "name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $iKemc.default), {
        "data-testid": "name-input",
        id: "name",
        ...register("name", {
            required: {
                value: true,
                message: text("msgNameRequired")
            }
        }),
        error: errors && errors.name?.message,
        maxLength: (0, $c4hCO.MAX_NAME_LENGTH),
        required: true,
        readOnly: disabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "phone",
        "data-testid": "phone"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblPhone"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $iKemc.default), {
        id: "phone",
        ...register("phone", {
            validate: (value)=>(0, $iUBfY.validatePhoneNumber)(value) || text("lblPhoneValueInvalid")
        }),
        error: errors.phone?.message,
        maxLength: (0, $c4hCO.MAX_ORG_PHONE_NO_LENGTH),
        readOnly: disabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "contactPerson",
        "data-testid": "contactPerson"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblContactPerson"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $iKemc.default), {
        id: "contactPerson",
        ...register("contactPerson"),
        maxLength: (0, $c4hCO.MAX_ORG_CONTACT_PERSON_LENGTH),
        readOnly: disabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "price",
        "data-testid": "kWhPrice"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblPricePerKWhField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $iKemc.default), {
        id: "price",
        type: "number",
        min: "0",
        ...register("kWhPrice", {
            setValueAs: (v)=>v === "" ? undefined : +v,
            min: {
                value: 0,
                message: text("lblKWhPriceNegative")
            }
        }),
        error: errors && errors.kWhPrice?.message,
        readOnly: disabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "comment",
        "data-testid": "comment"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblComment"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $bnWCl.default), {
        id: "comment",
        rows: 5,
        cols: 5,
        ...register("comment"),
        maxLength: (0, $c4hCO.MAX_ORG_COMMENT_LENGTH),
        readOnly: disabled
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("section", {
        className: "flex flex-column gap-3 flex-grow-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h3", {
        className: "mt-0 mb-2 text-lg"
    }, text("lblOrganisationPartnerLabel")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "m-0",
        "data-testid": "partner"
    }, isPartnerFetching ? text("msgLoading") : partner?.name || text("lblServicePartnerUnknownPartner"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "description",
        "data-testid": "description"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblDescriptionField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $iKemc.default), {
        id: "description",
        "data-testid": "description-input",
        ...register("description"),
        error: errors && errors.description?.message,
        maxLength: (0, $c4hCO.MAX_ORG_DESC_LENGTH),
        readOnly: disabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "email",
        "data-testid": "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblEmail"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $iKemc.default), {
        type: "email",
        id: "email",
        ...register("email"),
        maxLength: (0, $c4hCO.MAX_ORG_EMAIL_LENGTH),
        readOnly: disabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "address1",
        "data-testid": "address1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblAddressLineOneField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $iKemc.default), {
        id: "address1",
        ...register("address1"),
        maxLength: (0, $c4hCO.MAX_ORG_ADDRESS_1_LENGTH),
        readOnly: disabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "address2",
        "data-testid": "address2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblAddressLineTwoField"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $iKemc.default), {
        id: "address2",
        ...register("address2"),
        maxLength: (0, $c4hCO.MAX_ORG_ADDRESS_2_LENGTH),
        readOnly: disabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "country",
        "data-testid": "country-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblCountry"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "country",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
                id: "country",
                "aria-label": text("lblCountry"),
                options: countryOptions,
                optionLabel: "value",
                optionValue: "key",
                value: field.value,
                disabled: disabled,
                onChange: (event)=>field.onChange(event.value ?? null),
                onBlur: field.onBlur
            })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h5", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblReadOnlyAccess"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblReadOnlyAccessDescription"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("input", {
        id: "ownerReadOnly",
        type: "checkbox",
        className: "checkbox-black",
        disabled: disabled,
        ...register("ownerReadOnly")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        className: "mt-1 mb-0",
        htmlFor: "ownerReadOnly",
        "data-testid": "ownerReadOnly"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h5", null, text("lblActivateReadOnlyAccess"))))), !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end mt-auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        "data-testid": "save-btn",
        type: "submit",
        disabled: isLoading || isSaving || !isValid || !isDirty,
        onClick: handleSubmit(saveCompany),
        label: text("btnSave"),
        icon: "pi pi-save"
    })))));
});





var $5bkW8 = parcelRequire("5bkW8");

var $cbseE = parcelRequire("cbseE");

var $cRXmD = parcelRequire("cRXmD");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $ej4sl = parcelRequire("ej4sl");

var $1ot1u = parcelRequire("1ot1u");

var $2WeIl = parcelRequire("2WeIl");

var $5u6k9 = parcelRequire("5u6k9");

var $g915J = parcelRequire("g915J");

var $9p3YO = parcelRequire("9p3YO");

var $aCffN = parcelRequire("aCffN");

var $bAq2r = parcelRequire("bAq2r");

var $1O9Jh = parcelRequire("1O9Jh");

var $2nOeJ = parcelRequire("2nOeJ");

var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $1ot1u = parcelRequire("1ot1u");

var $k6jwa = parcelRequire("k6jwa");

var $56EgM = parcelRequire("56EgM");

var $dE8RX = parcelRequire("dE8RX");

var $7mQI5 = parcelRequire("7mQI5");

var $5u6k9 = parcelRequire("5u6k9");

var $MMfqT = parcelRequire("MMfqT");

var $1o9MR = parcelRequire("1o9MR");

var $aCffN = parcelRequire("aCffN");

var $gGcRO = parcelRequire("gGcRO");

var $1O9Jh = parcelRequire("1O9Jh");
const $6235916f410e9a4c$var$lookupFormId = "service-partner-lookup-form";
const $6235916f410e9a4c$var$addFormId = "add-service-partner-form";
const $6235916f410e9a4c$var$getLookupErrorMessageKey = (error)=>{
    if (!(0, $gGcRO.isFetchBaseQueryError)(error)) return "msgServicePartnerCodeLookupFailed";
    switch(error.status){
        case 400:
            return "msgServicePartnerCodeInvalid";
        case 409:
            return "msgServicePartnerAlreadyAdded";
        case 410:
            return "msgServicePartnerValidationTokenExpired";
        default:
            return "msgServicePartnerCodeLookupFailed";
    }
};
const $6235916f410e9a4c$var$getAddErrorMessageKey = (error)=>{
    if (!(0, $gGcRO.isFetchBaseQueryError)(error)) return "msgServicePartnerAddFailed";
    switch(error.status){
        case 409:
            return "msgServicePartnerValidationTokenAlreadyUsed";
        case 410:
            return "msgServicePartnerValidationTokenExpired";
        default:
            return "msgServicePartnerAddFailed";
    }
};
const $6235916f410e9a4c$var$normalizePartnerName = (name)=>name?.trim().toLocaleLowerCase() ?? "";
const $6235916f410e9a4c$var$getLookupBlockingMessageKey = ({ matchedPartnerId: matchedPartnerId, matchedPartnerName: matchedPartnerName, partnerId: partnerId, servicePartners: servicePartners })=>{
    if (matchedPartnerId != null && partnerId != null && matchedPartnerId === partnerId) return "msgServicePartnerCurrentPartner";
    const normalizedMatchedPartnerName = $6235916f410e9a4c$var$normalizePartnerName(matchedPartnerName);
    if (!normalizedMatchedPartnerName) return undefined;
    return servicePartners.some((servicePartner)=>$6235916f410e9a4c$var$normalizePartnerName(servicePartner.partnerName) === normalizedMatchedPartnerName) ? "msgServicePartnerAlreadyAdded" : undefined;
};
function $6235916f410e9a4c$export$6ccae501f3c5a85({ visible: visible, companyId: companyId, onHide: onHide, onSuccess: onSuccess, servicePartners: servicePartners, partnerId: partnerId }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const minimumValidTo = new Date();
    const [lookupServicePartner, { data: matchedServicePartnerCode, error: lookupError, isLoading: isLookingUp, reset: resetMatchedServicePartnerCode }] = (0, $1O9Jh.useCompanyGetServicePartnerCodeInformationMutation)();
    const [addServicePartner, { isLoading: isAdding }] = (0, $1O9Jh.useCompanyAddServicePartnerMutation)();
    const lookupForm = (0, $cCnqE.useForm)({
        defaultValues: {
            partnerReferenceCode: ""
        },
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    const addForm = (0, $cCnqE.useForm)({
        defaultValues: {
            validTo: (0, $7mQI5.default)(new Date(), 1),
            indefiniteAccess: false
        },
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    const indefiniteAccess = addForm.watch("indefiniteAccess");
    const partnerReferenceCode = lookupForm.watch("partnerReferenceCode") ?? "";
    const partnerReferenceCodeRegistration = lookupForm.register("partnerReferenceCode");
    const validationToken = matchedServicePartnerCode?.invitation?.validationToken;
    const matchedPartnerId = matchedServicePartnerCode?.partner?.partnerId;
    const matchedPartnerName = matchedServicePartnerCode?.partner?.partnerName;
    const hasNoMatch = (0, $gGcRO.isFetchBaseQueryError)(lookupError) && lookupError.status === 404;
    const lookupBlockingMessageKey = $6235916f410e9a4c$var$getLookupBlockingMessageKey({
        matchedPartnerId: matchedPartnerId,
        matchedPartnerName: matchedPartnerName,
        partnerId: partnerId,
        servicePartners: servicePartners
    });
    const lookupBlockingMessage = lookupBlockingMessageKey ? text(lookupBlockingMessageKey) : undefined;
    const searchDisabled = !companyId || isLookingUp || isAdding || lookupForm.formState.isSubmitting || partnerReferenceCode.trim().length !== 8;
    const lookupPartner = async ({ partnerReferenceCode: partnerReferenceCode })=>{
        const code = partnerReferenceCode?.trim() ?? "";
        if (!companyId || code.length !== 8) return;
        resetMatchedServicePartnerCode();
        try {
            await lookupServicePartner({
                companyId: companyId,
                servicePartnerCodeLookupRequest: {
                    code: code
                }
            }).unwrap();
            addForm.reset({
                validTo: (0, $7mQI5.default)(new Date(), 1),
                indefiniteAccess: false
            });
        } catch (error) {
            if ((0, $gGcRO.isFetchBaseQueryError)(error) && error.status === 404) return;
            const messageKey = $6235916f410e9a4c$var$getLookupErrorMessageKey(error);
            const message = text(messageKey);
            toast.notifyError(message);
        }
    };
    const confirmAdd = async ({ validTo: validTo, indefiniteAccess: indefiniteAccess })=>{
        if (!companyId || !validationToken || !indefiniteAccess && (!(validTo instanceof Date) || validTo.getTime() <= Date.now()) || lookupBlockingMessage) return;
        const addServicePartnerRequest = {
            validationToken: validationToken,
            validTo: indefiniteAccess ? null : validTo?.toISOString() ?? null
        };
        try {
            await addServicePartner({
                companyId: companyId,
                addServicePartnerRequest: addServicePartnerRequest
            }).unwrap();
            toast.notifySuccess(text("msgServicePartnerAdded"));
            onSuccess();
            onHide();
        } catch (error) {
            toast.notifyError(text($6235916f410e9a4c$var$getAddErrorMessageKey(error)));
        }
    };
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: onHide
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnAdd"),
        type: "submit",
        form: $6235916f410e9a4c$var$addFormId,
        disabled: !validationToken || !!lookupBlockingMessage || isLookingUp || isAdding || addForm.formState.isSubmitted && !addForm.formState.isValid,
        loading: isAdding,
        "data-testid": "confirm-add-service-partner"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        header: text("lblAddServicePartner"),
        visible: visible,
        onHide: onHide,
        footer: footer,
        "data-testid": "add-service-partner-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $6235916f410e9a4c$var$lookupFormId,
        className: "flex flex-column gap-3",
        onSubmit: lookupForm.handleSubmit(lookupPartner),
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        className: "p-label required-label",
        htmlFor: "service-partner-reference-code"
    }, text("lblServicePartnerReferenceCode")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column md:flex-row md:align-items-start gap-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "service-partner-reference-code",
        "data-testid": "service-partner-reference-code",
        ...partnerReferenceCodeRegistration,
        onChange: (event)=>{
            lookupForm.setValue("partnerReferenceCode", event.target.value.toUpperCase(), {
                shouldDirty: true
            });
            resetMatchedServicePartnerCode();
        },
        disabled: isLookingUp || isAdding,
        className: "flex-1",
        placeholder: "ABCDEFGH",
        maxLength: 8,
        required: true,
        autoFocus: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "submit",
        label: text("lblSearch"),
        icon: "pi pi-search",
        loading: isLookingUp,
        disabled: searchDisabled,
        className: "align-self-start",
        "data-testid": "search-service-partner"
    })))), matchedServicePartnerCode?.partner || hasNoMatch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $6235916f410e9a4c$var$addFormId,
        className: "flex flex-column gap-3 mt-4",
        onSubmit: addForm.handleSubmit(confirmAdd),
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "border-1 surface-border border-round p-3",
        "data-testid": hasNoMatch ? "service-partner-no-match" : "service-partner-match"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "text-sm text-color-secondary mb-2"
    }, text("lblMatchedServicePartner")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center justify-content-between gap-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: hasNoMatch ? "text-color-secondary" : "font-bold"
    }, hasNoMatch ? text("msgServicePartnerCodeNotFound") : matchedPartnerName || text("lblServicePartnerUnknownPartner")), lookupBlockingMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "text-sm text-color-secondary text-right"
    }, lookupBlockingMessage) : null)), matchedServicePartnerCode?.partner && !lookupBlockingMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "validTo",
        control: addForm.control,
        rules: {
            validate: (value)=>{
                if (addForm.getValues("indefiniteAccess")) return true;
                if (!(value instanceof Date)) return text("msgServicePartnerAccessValidToRequired");
                return value.getTime() > Date.now() || text("msgServicePartnerAccessValidToMustBeFuture");
            }
        },
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex flex-column"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
                className: indefiniteAccess ? "p-label" : "p-label required-label",
                htmlFor: "service-partner-valid-to"
            }, text("lblServicePartnerAccessValidTo")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $k6jwa.Calendar), {
                inputId: "service-partner-valid-to",
                "data-testid": "service-partner-valid-to",
                value: field.value,
                onChange: (event)=>field.onChange(event.value instanceof Date ? event.value : null),
                onBlur: field.onBlur,
                minDate: minimumValidTo,
                showTime: true,
                hourFormat: "24",
                showIcon: true,
                showButtonBar: true,
                showOnFocus: false,
                dateFormat: "yy-mm-dd",
                className: "w-full",
                invalid: !!addForm.formState.errors.validTo,
                disabled: isAdding || indefiniteAccess,
                required: !indefiniteAccess
            }), addForm.formState.errors.validTo?.message ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dE8RX.Message), {
                severity: "error",
                text: addForm.formState.errors.validTo.message,
                "data-testid": "service-partner-valid-to-error-message",
                className: "mt-2"
            }) : null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "indefiniteAccess",
        control: addForm.control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex align-items-center gap-2"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $56EgM.Checkbox), {
                inputId: "service-partner-indefinite-access",
                checked: field.value,
                onChange: (event)=>{
                    field.onChange(Boolean(event.checked));
                    if (addForm.formState.isSubmitted) addForm.trigger("validTo");
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
                htmlFor: "service-partner-indefinite-access",
                className: "cursor-pointer select-none"
            }, text("lblServicePartnerIndefiniteAccess")))
    })) : null) : null);
}






const $47c6c377630b1e31$var$MAX_SERVICE_PARTNERS = 5;
const $47c6c377630b1e31$var$getServicePartnerAccessStatus = (status)=>{
    const normalizedStatus = status?.trim().toLowerCase();
    return normalizedStatus === "active" || normalizedStatus === "inactive" ? normalizedStatus : "unknown";
};
function $47c6c377630b1e31$export$9d8c2b45741e6f23({ className: className, style: style, companyId: companyId, canManageServicePartners: canManageServicePartners = false, partner: partner, isPartnerFetching: isPartnerFetching = false }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const { data: servicePartners = [], isFetching: isServicePartnersFetching, refetch: refetchServicePartners } = (0, $1O9Jh.useCompanyGetServicePartnersQuery)({
        companyId: companyId ?? ""
    }, {
        skip: !companyId
    });
    const [removeServicePartner, { isLoading: isRemoving }] = (0, $1O9Jh.useCompanyRemoveServicePartnerMutation)();
    const [addServicePartnerDialog, setAddServicePartnerDialog] = (0, $7E7Dk.useState)({
        visible: false,
        sessionId: 0
    });
    const sortedServicePartners = [
        ...servicePartners
    ].sort((a, b)=>(a.partnerName ?? "").localeCompare(b.partnerName ?? ""));
    const activeServicePartnerCount = servicePartners.filter((servicePartner)=>$47c6c377630b1e31$var$getServicePartnerAccessStatus(servicePartner.status) === "active").length;
    const hasReachedServicePartnerLimit = activeServicePartnerCount >= $47c6c377630b1e31$var$MAX_SERVICE_PARTNERS;
    const addServicePartnerDisabled = !companyId || isServicePartnersFetching || isPartnerFetching || hasReachedServicePartnerLimit;
    const openAddServicePartnerDialog = ()=>{
        setAddServicePartnerDialog(({ sessionId: sessionId })=>({
                visible: true,
                sessionId: sessionId + 1
            }));
    };
    const hideAddServicePartnerDialog = ()=>{
        setAddServicePartnerDialog((dialog)=>({
                ...dialog,
                visible: false
            }));
    };
    const handleRemove = async (servicePartner)=>{
        if (!companyId || !servicePartner.servicePartnerConnectionId) return;
        if ($47c6c377630b1e31$var$getServicePartnerAccessStatus(servicePartner.status) !== "inactive") {
            const confirmed = await (0, $9p3YO.confirm)({
                header: text("lblProceedConfirmation"),
                message: text("msgRemoveServicePartnerConfirmation", {
                    partnerName: servicePartner.partnerName || text("lblServicePartnerUnknownPartner")
                }),
                variant: "danger"
            });
            if (!confirmed) return;
        }
        try {
            await removeServicePartner({
                companyId: companyId,
                servicePartnerConnectionId: servicePartner.servicePartnerConnectionId
            }).unwrap();
            toast.notifySuccess(text("msgServicePartnerRemoved"));
            refetchServicePartners();
        } catch  {
            toast.notifyError(text("msgServicePartnerRemoveFailed"));
        }
    };
    const servicePartnerColumns = [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
            key: "partnerName",
            field: "partnerName",
            header: text("lblServicePartnerNameColumn"),
            body: (servicePartner)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, servicePartner.partnerName || text("lblServicePartnerUnknownPartner"))
        }),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
            key: "validTo",
            field: "validTo",
            header: text("lblValidTo"),
            body: (servicePartner)=>servicePartner.validTo === null ? text("lblServicePartnerIndefiniteValidity") : servicePartner.validTo ? (0, $bAq2r.default)(servicePartner.validTo) : "\u2014"
        }),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
            key: "status",
            header: text("lblStatus"),
            body: (servicePartner)=>{
                const status = $47c6c377630b1e31$var$getServicePartnerAccessStatus(servicePartner.status);
                if (status === "unknown") return "\u2014";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2WeIl.Tag), {
                    value: text(status === "active" ? "lblActive" : "lblInactiveStatus"),
                    severity: status === "active" ? "success" : "danger"
                });
            }
        }),
        ...canManageServicePartners ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ej4sl.Column), {
                key: "actions",
                bodyClassName: "text-right",
                body: (servicePartner)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                        tooltip: text("btnRemove"),
                        "aria-label": text("btnRemove"),
                        icon: "pi pi-times",
                        size: "small",
                        severity: "danger",
                        outlined: true,
                        rounded: true,
                        disabled: isRemoving,
                        onClick: ()=>handleRemove(servicePartner),
                        "data-testid": `remove-service-partner-${servicePartner.servicePartnerConnectionId}`
                    })
            })
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        title: text("lblOrganisationServicePartnersWidgetTitle"),
        "data-testid": "organisation-service-partners-widget",
        headerButtons: canManageServicePartners ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            label: text("btnAdd"),
            icon: "pi pi-plus",
            disabled: addServicePartnerDisabled,
            tooltip: hasReachedServicePartnerLimit ? text("msgServicePartnerLimitReached") : undefined,
            tooltipOptions: {
                showOnDisabled: true
            },
            onClick: openAddServicePartnerDialog,
            "data-testid": "add-service-partner"
        }) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("section", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "text-sm text-color-secondary mb-2",
        "data-testid": "service-partners-count"
    }, text("lblActiveServicePartnerCount", {
        activeCount: activeServicePartnerCount,
        limit: $47c6c377630b1e31$var$MAX_SERVICE_PARTNERS
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $g915J.Table), {
        value: sortedServicePartners,
        loading: isServicePartnersFetching,
        dataKey: "servicePartnerConnectionId",
        emptyMessage: text("msgNoServicePartners"),
        simplified: true,
        "data-testid": "service-partners-table"
    }, servicePartnerColumns)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6235916f410e9a4c$export$6ccae501f3c5a85), {
        key: addServicePartnerDialog.sessionId,
        visible: addServicePartnerDialog.visible,
        companyId: companyId,
        onHide: hideAddServicePartnerDialog,
        onSuccess: refetchServicePartners,
        servicePartners: servicePartners,
        partnerId: partner?.id
    }));
}





var $1O9Jh = parcelRequire("1O9Jh");
const $552cda2d41e0e57a$export$8f6dcfe950367406 = /*#__PURE__*/ (0, $7E7Dk.memo)(function SettingsPage({ className: className, style: style }) {
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const user = (0, $2rQNl.useSelector)((state)=>state.user);
    const canUpdateCompany = (0, $cbseE.default)(user, companyId || "", (0, $cRXmD.default).Admin);
    const { data: partner, isFetching: isPartnerFetching } = (0, $1O9Jh.useCompanyGetPartnerQuery)({
        companyId: companyId ?? ""
    }, {
        skip: !companyId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $deaa6aae70f2a525$export$4e56bbf0e7f4ff77), {
        partner: partner,
        isPartnerFetching: isPartnerFetching,
        disabled: !canUpdateCompany
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-12 md:col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5bkW8.OrganisationSettingsWidget), {
        companyId: companyId,
        disabled: !canUpdateCompany
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-12 md:col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $47c6c377630b1e31$export$9d8c2b45741e6f23), {
        companyId: companyId,
        canManageServicePartners: canUpdateCompany,
        partner: partner,
        isPartnerFetching: isPartnerFetching
    }))));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $gRonV = parcelRequire("gRonV");

var $4AX6R = parcelRequire("4AX6R");

var $1O9Jh = parcelRequire("1O9Jh");

var $r38ZI = parcelRequire("r38ZI");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $3um4r = parcelRequire("3um4r");
var $4AX6R = parcelRequire("4AX6R");

var $1ot1u = parcelRequire("1ot1u");

var $2nOeJ = parcelRequire("2nOeJ");

var $eGlQL = parcelRequire("eGlQL");

var $igvrl = parcelRequire("igvrl");

var $1hIPE = parcelRequire("1hIPE");

var $5u6k9 = parcelRequire("5u6k9");
const $0bc1ae4548fed1b8$export$a71ecc24683233d6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).memo(function AdminUserAccessToChargersWidget({ chargePoints: chargePoints, isAdmin: isAdmin, dataLoadingChargePoints: dataLoadingChargePoints, style: style }) {
    const { id: userId } = (0, $4AX6R.useParams)();
    const navigate = (0, $3um4r.useNavigate)();
    const text = (0, $5u6k9.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblRFIDAccessToChargers"
        }),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            widgetprocessing: dataLoadingChargePoints
        }),
        headerButtons: isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            label: text("btnEdit"),
            icon: "pi pi-pencil",
            onClick: ()=>navigate(`/user/${userId}/userChargePoints`),
            "data-testid": "btn-edit"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null),
        "data-testid": "access-chargers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.Table), {
        "data-testid": "access-chargers-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "lbl-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblId"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "lbl-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblName"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "lbl-sockets"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblSockets"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBody), null, chargePoints?.map((chargePoint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), {
            key: chargePoint.id,
            "data-testid": `row-${chargePoint.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.Link), {
            to: `/chargepoints/${chargePoint.id}`,
            "data-testid": "btn-link"
        }, chargePoint.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": `name-${chargePoint.id}`
        }, chargePoint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": `socket-${chargePoint.id}`
        }, !(0, $1hIPE.default)(chargePoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "fa fa-circle"
        }), (0, $1hIPE.default)(chargePoint) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, chargePoint.connectors?.map((connector)=>connector.hasNfcAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
                key: connector.connectorId,
                "data-testid": "users-has-nfc-access",
                className: "fa fa-circle margin-right-2"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
                key: connector.connectorId,
                "data-testid": "users-has-no-nfc-access",
                className: "fa fa-circle-o"
            }))))))))));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $3um4r = parcelRequire("3um4r");

var $igvrl = parcelRequire("igvrl");

var $eGlQL = parcelRequire("eGlQL");

var $gWMOV = parcelRequire("gWMOV");

var $2nOeJ = parcelRequire("2nOeJ");
function $8bc24291d4c88354$export$72eeb2e143f5b912({ style: style, registeredChargePoints: registeredChargePoints, dataLoadingOwnedChargePoints: dataLoadingOwnedChargePoints }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        loadingStatus: dataLoadingOwnedChargePoints,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblRegisteredToChargers"
        }),
        style: style,
        "data-testid": "registered-to-chargers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.Table), {
        "data-testid": "registered-chargers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "lbl-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblId"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "lbl-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblName"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBody), null, registeredChargePoints?.map((c, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), {
            key: i,
            "data-testid": `row-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": `charger-id-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gWMOV.STableLink), {
            as: (0, $3um4r.Link),
            to: `/chargepoints/${c.id}`
        }, c.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": `charger-name-${i}`
        }, c.name))))));
}





var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $3um4r = parcelRequire("3um4r");

var $1ot1u = parcelRequire("1ot1u");

var $2nOeJ = parcelRequire("2nOeJ");

var $eGlQL = parcelRequire("eGlQL");

var $igvrl = parcelRequire("igvrl");

var $5u6k9 = parcelRequire("5u6k9");
const $f84e076af9a796bc$export$3dcba8e413d97468 = /*#__PURE__*/ (0, $7E7Dk.memo)(function AdminUserAccessToPoolsWidget({ pools: pools, style: style, isAdmin: isAdmin, dataloadingPools: dataloadingPools, disableEdit: disableEdit, userId: userId }) {
    const navigate = (0, $3um4r.useNavigate)();
    const text = (0, $5u6k9.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblRFIDAccessToPools"
        }),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))({
            widgetprocessing: dataloadingPools
        }),
        headerButtons: isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            disabled: disableEdit,
            label: text("btnEdit"),
            icon: "pi pi-pencil",
            onClick: ()=>navigate(`/user/${userId}/userPools`),
            "data-testid": "btn-edit"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null),
        "data-testid": "access-pools"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.Table), {
        "data-testid": "access-pools-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "lbl-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblName"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBody), null, pools?.map((pool)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), {
            key: pool.id,
            "data-testid": "name"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), null, pool.name)))))));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $gRonV = parcelRequire("gRonV");

var $3um4r = parcelRequire("3um4r");
var $4AX6R = parcelRequire("4AX6R");

var $1ot1u = parcelRequire("1ot1u");

var $diakb = parcelRequire("diakb");

var $2nOeJ = parcelRequire("2nOeJ");

var $eGlQL = parcelRequire("eGlQL");

var $igvrl = parcelRequire("igvrl");

var $5u6k9 = parcelRequire("5u6k9");

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $56EgM = parcelRequire("56EgM");

var $5u6k9 = parcelRequire("5u6k9");

var $MMfqT = parcelRequire("MMfqT");

var $1o9MR = parcelRequire("1o9MR");
const $961a91e038b9f3a0$var$MAX_LENGTH = 40;
const $961a91e038b9f3a0$var$formId = "bulk-edit-rfid-tags-form";
const $961a91e038b9f3a0$export$3cff4f22673142c = ({ visible: visible, nfcTags: nfcTags, onSubmit: onSubmit, onHide: onHide })=>{
    const text = (0, $5u6k9.default)();
    const [clearComment, setClearComment] = (0, $7E7Dk.useState)(false);
    const [clearExternalId, setClearExternalId] = (0, $7E7Dk.useState)(false);
    const [rfidTags, setRfidTags] = (0, $7E7Dk.useState)(nfcTags);
    const [comment, setComment] = (0, $7E7Dk.useState)("");
    const [externalId, setExternalId] = (0, $7E7Dk.useState)("");
    const placeholder = (value, clearFlag)=>{
        if (clearFlag) return text("msgValueWillBeCleared");
        if (!value) return text("msgKeepWithoutChanges");
        return text("msgClearTheValue");
    };
    const toggleSelect = (rfidTag)=>{
        if (rfidTags.some((tag)=>tag.id === rfidTag.id)) setRfidTags(rfidTags.filter((tag)=>tag.id !== rfidTag.id));
        else setRfidTags([
            ...rfidTags,
            rfidTag
        ]);
    };
    const toggleSelectAll = ()=>{
        setRfidTags(rfidTags.length === nfcTags.length ? [] : nfcTags);
    };
    const save = async ()=>{
        await onSubmit(rfidTags.map((tag)=>({
                ...tag,
                comment: clearComment || comment.length ? comment : tag.comment,
                externalId: clearExternalId || externalId.length ? externalId : tag.externalId
            })));
    };
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnCancel"),
        type: "button",
        text: true,
        onClick: onHide
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnSave"),
        type: "submit",
        form: $961a91e038b9f3a0$var$formId,
        disabled: !rfidTags.length
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        header: text("lblBulkEditRfidTagsDialogTitle"),
        visible: visible,
        onHide: onHide,
        footer: footer,
        "data-testid": "bulk-edit-rfid-tags-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $961a91e038b9f3a0$var$formId,
        className: "flex flex-column gap-4",
        onSubmit: (event)=>{
            event.preventDefault();
            save();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("section", {
        "aria-labelledby": "bulk-edit-rfid-tags-selection-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center justify-content-between gap-2 mb-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        id: "bulk-edit-rfid-tags-selection-label",
        className: "p-label"
    }, text("msgSelectRfidTagsToUpdate")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text(rfidTags.length === nfcTags.length ? "btnUnselectAll" : "btnSelectAll"),
        type: "button",
        text: true,
        size: "small",
        onClick: toggleSelectAll
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-wrap gap-3",
        role: "group",
        "aria-labelledby": "bulk-edit-rfid-tags-selection-label"
    }, nfcTags.map((nfcTag)=>{
        const inputId = `bulk-edit-rfid-tag-${nfcTag.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex align-items-center gap-2",
            key: nfcTag.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $56EgM.Checkbox), {
            inputId: inputId,
            checked: rfidTags.some((tag)=>tag.id === nfcTag.id),
            onChange: ()=>toggleSelect(nfcTag)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
            htmlFor: inputId,
            className: "mb-0 cursor-pointer"
        }, nfcTag.id));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "bulk-edit-rfid-tags-comment",
        className: "p-label"
    }, text("lblComment")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("small", {
        id: "bulk-edit-rfid-tags-comment-help",
        className: "text-color-secondary"
    }, text("msgBulkEditRfidTagsClearCommentHelp"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "bulk-edit-rfid-tags-comment",
        "aria-describedby": "bulk-edit-rfid-tags-comment-help",
        placeholder: placeholder(comment, clearComment),
        disabled: clearComment,
        value: comment,
        onChange: (event)=>setComment(event.target.value)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $56EgM.Checkbox), {
        inputId: "clear-bulk-edit-rfid-tags-comment",
        checked: clearComment,
        "aria-label": text("lblClearCommentAction"),
        onChange: (event)=>{
            const checked = event.checked ?? false;
            setClearComment(checked);
            if (checked) setComment("");
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "clear-bulk-edit-rfid-tags-comment",
        className: "mb-0 cursor-pointer"
    }, text("lblClearExistingValuesAction")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "bulk-edit-rfid-tags-external-id",
        className: "p-label"
    }, text("lblExternalIdField")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("small", {
        id: "bulk-edit-rfid-tags-external-id-help",
        className: "text-color-secondary"
    }, text("msgBulkEditRfidTagsClearExternalIdHelp"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "bulk-edit-rfid-tags-external-id",
        "aria-describedby": "bulk-edit-rfid-tags-external-id-help",
        placeholder: placeholder(externalId, clearExternalId),
        disabled: clearExternalId,
        value: externalId,
        onChange: (event)=>setExternalId(event.target.value),
        maxLength: $961a91e038b9f3a0$var$MAX_LENGTH
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $56EgM.Checkbox), {
        inputId: "clear-bulk-edit-rfid-tags-external-id",
        checked: clearExternalId,
        "aria-label": text("lblClearExternalIdAction"),
        onChange: (event)=>setClearExternalId(event.checked ?? false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
        htmlFor: "clear-bulk-edit-rfid-tags-external-id",
        className: "mb-0 cursor-pointer"
    }, text("lblClearExistingValuesAction"))))));
};




const $7f6667f4e0fd8a1d$var$RfidTable = (0, $gRonV.default).div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;
const $7f6667f4e0fd8a1d$export$dca7950e5ef74285 = /*#__PURE__*/ (0, $7E7Dk.memo)(function AdminUserRfidTagsWidget({ nfcTags: nfcTags, isAdmin: isAdmin, onBulkEdit: onBulkEdit, deleteNfcTagFromUser: deleteNfcTagFromUser, style: style }) {
    const text = (0, $5u6k9.default)();
    const navigate = (0, $3um4r.useNavigate)();
    const { id: userId } = (0, $4AX6R.useParams)();
    const [bulkEditDialog, setBulkEditDialog] = (0, $7E7Dk.useState)({
        visible: false,
        sessionId: 0
    });
    const [editRfidTagDialogIsOpen, setEditRfidTagDialogIsOpen] = (0, $7E7Dk.useState)(false);
    const [editTag, setEditTag] = (0, $7E7Dk.useState)();
    const openBulkEditDialog = ()=>{
        setBulkEditDialog(({ sessionId: sessionId })=>({
                visible: true,
                sessionId: sessionId + 1
            }));
    };
    const hideBulkEditDialog = ()=>{
        setBulkEditDialog((dialog)=>({
                ...dialog,
                visible: false
            }));
    };
    const hideEditRfidTagDialog = ()=>{
        setEditRfidTagDialogIsOpen(false);
        setEditTag(undefined);
    };
    const handleBulkEdit = async (tags)=>{
        const succeeded = await onBulkEdit(tags);
        if (succeeded) hideBulkEditDialog();
    };
    const renderWidgetHeaderButtons = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex align-items-center gap-2"
        }, isAdmin && nfcTags.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            label: text("btnBulkEditRfidTags"),
            icon: "pi pi-pencil",
            onClick: openBulkEditDialog,
            "data-testid": "btn-edit"
        }) : null, isAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            label: text("btnAdd"),
            icon: "pi pi-plus",
            onClick: ()=>navigate(`/user/${userId}/userNfcTags`),
            "data-testid": "btn-add"
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: text("lblRFIDWidget"),
        headerButtons: renderWidgetHeaderButtons(),
        "data-testid": "rfid-tags"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.Table), {
        "data-testid": "rfid-tags-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "lbl-id"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblId"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), {
        "data-testid": "lbl-comment"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
        code: "lblComment"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableHeaderCell), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBody), null, nfcTags?.map((nfctag)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableRow), {
            key: nfctag.id,
            "data-testid": `row-${nfctag.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($7f6667f4e0fd8a1d$var$RfidTable, {
            "data-testid": `id-${nfctag.id}`
        }, nfctag.id, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "lblExternalId"
        }), ":", " ", nfctag.externalId ? nfctag.externalId : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "msgValueNotSet"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            "data-testid": `commet-${nfctag.id}`
        }, nfctag.comment), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eGlQL.TableBodyCell), {
            className: "vertical-align-middle"
        }, isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex justify-content-end gap-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            onClick: ()=>{
                setEditTag(nfctag);
                setEditRfidTagDialogIsOpen(true);
            },
            icon: "pi pi-pencil",
            "aria-label": text("btnEdit"),
            tooltip: text("btnEdit"),
            size: "small",
            severity: "info",
            outlined: true,
            rounded: true,
            "data-testid": "btn-edit"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            type: "button",
            onClick: ()=>deleteNfcTagFromUser(nfctag),
            icon: "pi pi-trash",
            "aria-label": text("btnRemove"),
            tooltip: text("btnRemove"),
            size: "small",
            severity: "danger",
            outlined: true,
            rounded: true,
            "data-testid": "btn-delete"
        })))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $961a91e038b9f3a0$export$3cff4f22673142c), {
        key: bulkEditDialog.sessionId,
        visible: bulkEditDialog.visible,
        nfcTags: nfcTags,
        onHide: hideBulkEditDialog,
        onSubmit: handleBulkEdit
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $diakb.RfidTagDialog), {
        rfidTag: editTag,
        visible: editRfidTagDialogIsOpen,
        onHide: hideEditRfidTagDialog
    }));
});





var $26yAo = parcelRequire("26yAo");

parcelRequire("5jmoH");
var $1YBxD = parcelRequire("1YBxD");

var $cbseE = parcelRequire("cbseE");

var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $2rQNl = parcelRequire("2rQNl");

var $1ot1u = parcelRequire("1ot1u");

var $dE8RX = parcelRequire("dE8RX");

var $fL2dz = parcelRequire("fL2dz");

var $2nOeJ = parcelRequire("2nOeJ");

var $cbseE = parcelRequire("cbseE");

var $cRXmD = parcelRequire("cRXmD");

var $1O9Jh = parcelRequire("1O9Jh");

var $e7xM3 = parcelRequire("e7xM3");

var $5u6k9 = parcelRequire("5u6k9");

var $1o9MR = parcelRequire("1o9MR");

var $aCffN = parcelRequire("aCffN");
const $75dcf4e71cd6b5fa$var$getFormValues = (user)=>({
        firstName: user.firstName ?? "",
        lastName: user.lastName ?? "",
        email: user.email ?? "",
        mobile: user.mobile ?? "",
        roleInCompany: user.roleInCompany ?? "",
        newPassword: "",
        confirmNewPassword: ""
    });
const $75dcf4e71cd6b5fa$var$userRoles = [
    {
        value: "User",
        labelCode: "lblUserTypeUser",
        testId: "radio-user"
    },
    {
        value: "Admin",
        labelCode: "lblUserTypeAdmin",
        testId: "radio-admin"
    },
    {
        value: "AdminViewOnly",
        labelCode: "lblUserTypeAdminViewOnly",
        testId: "radio-aminView"
    }
];
const $75dcf4e71cd6b5fa$export$a398983943bbde23 = /*#__PURE__*/ (0, $7E7Dk.memo)(function UserDetails() {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const signedInUser = (0, $2rQNl.useSelector)((state)=>state.user);
    const user = (0, $2rQNl.useSelector)((state)=>state.selectedUser);
    const [openPasswordChange, setOpenPasswordChange] = (0, $7E7Dk.useState)(false);
    const canEditUser = (0, $cbseE.default)(signedInUser, signedInUser.selectedCompanyId, (0, $cRXmD.default).Admin);
    const canEditPassword = canEditUser && ((0, $e7xM3.default)(signedInUser, user) || Boolean(user.passwordChangeableForAdmin));
    const userFullName = [
        user.firstName,
        user.lastName
    ].filter(Boolean).join(" ");
    const [updateUser, { isLoading: updatingUser }] = (0, $1O9Jh.useCompanyUpdateUserMutation)();
    const [updateRole, { isLoading: updatingRole }] = (0, $1O9Jh.useCompanyUpdateRoleToUserMutation)();
    const { control: control, getValues: getValues, handleSubmit: handleSubmit, register: register, reset: reset, unregister: unregister, formState: { errors: errors, isSubmitted: isSubmitted, isSubmitting: isSubmitting } } = (0, $cCnqE.useForm)({
        defaultValues: $75dcf4e71cd6b5fa$var$getFormValues(user),
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    (0, $7E7Dk.useEffect)(()=>{
        reset($75dcf4e71cd6b5fa$var$getFormValues(user));
        setOpenPasswordChange(false);
    }, [
        reset,
        user
    ]);
    const setPasswordChangeVisible = (visible)=>{
        setOpenPasswordChange(visible);
        if (!visible) unregister([
            "newPassword",
            "confirmNewPassword"
        ]);
    };
    const toChargePointUser = (values)=>({
            ...user,
            firstName: values.firstName,
            lastName: values.lastName,
            email: values.email,
            mobile: values.mobile || null,
            password: user.password,
            passwordChange: openPasswordChange ? {
                newPassword: values.newPassword
            } : null,
            roleInCompany: values.roleInCompany,
            userStatus: user.userStatus
        });
    const saveExistingUser = async (chargePointUser)=>{
        if (!chargePointUser.id) return;
        await updateUser({
            companyId: signedInUser.selectedCompanyId,
            chargePointUser: chargePointUser
        }).unwrap();
        await updateRole({
            companyId: signedInUser.selectedCompanyId,
            userId: chargePointUser.id,
            role: {
                claim: chargePointUser.roleInCompany,
                companyId: signedInUser.selectedCompanyId,
                chargePointUserId: chargePointUser.id
            }
        }).unwrap();
        toast.notifySuccess(text(openPasswordChange ? "msgProfilePasswordUpdated" : "msgUserUpdated"));
    };
    const save = async (values)=>{
        if (!canEditUser) return;
        const chargePointUser = toChargePointUser(values);
        try {
            await saveExistingUser(chargePointUser);
        } catch (error) {
            toast.notifyError(text("msgUserNotSaved"));
            console.error(error);
        }
    };
    const isLoading = updatingRole || updatingUser;
    const saveDisabled = !canEditUser || isLoading || isSubmitting || isSubmitted && Object.keys(errors).length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2nOeJ.WidgetLayout), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("header", {
            className: "flex flex-column gap-1"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h2", {
            className: "text-xl font-semibold m-0"
        }, userFullName), user.email ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            className: "text-sm font-normal text-600",
            "data-testid": "user-details-header-email"
        }, user.email) : null),
        "data-testid": "userDetails"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        onSubmit: handleSubmit(save),
        autoComplete: "off",
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "formgrid grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 md:col-6",
        "data-testid": "firstName"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "first-name-input",
        label: text("lblUserDetailsFirstNameField"),
        "data-testid": "firstName-input",
        disabled: !canEditUser,
        required: true,
        error: errors.firstName?.message,
        ...register("firstName", {
            required: text("msgFirstNameRequired")
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 md:col-6",
        "data-testid": "lastName"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "last-name-input",
        label: text("lblUserDetailsLastNameField"),
        "data-testid": "lastName-input",
        disabled: !canEditUser,
        required: true,
        error: errors.lastName?.message,
        ...register("lastName", {
            required: text("msgLastNameRequired")
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 md:col-6",
        "data-testid": "email"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "email-input",
        type: "email",
        label: text("lblEmail"),
        "data-testid": "email-input",
        autoComplete: "email",
        disabled: true,
        required: true,
        error: errors.email?.message,
        ...register("email", {
            required: text("msgEmailRequired")
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 md:col-6",
        "data-testid": "mobile"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "mobile-input",
        type: "tel",
        label: text("lblMobile"),
        "data-testid": "mobile-input",
        disabled: !canEditUser,
        ...register("mobile")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 mb-3",
        role: "group",
        "aria-labelledby": "user-role-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        id: "user-role-label",
        className: "p-label block mb-2"
    }, text("lblRole")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "roleInCompany",
        control: control,
        rules: {
            required: text("msgRequiredShort")
        },
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                className: "flex flex-column gap-2"
            }, $75dcf4e71cd6b5fa$var$userRoles.map((role)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                    key: role.value,
                    className: "flex align-items-center gap-2"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $fL2dz.RadioButton), {
                    inputId: `user-role-${role.value}`,
                    value: role.value,
                    name: field.name,
                    className: "w-1rem h-1rem",
                    checked: field.value === role.value,
                    disabled: !canEditUser,
                    onBlur: field.onBlur,
                    onChange: (event)=>field.onChange(event.value),
                    "data-testid": role.testId,
                    pt: {
                        box: {
                            className: "w-1rem h-1rem"
                        },
                        icon: {
                            style: {
                                width: "0.5rem",
                                height: "0.5rem"
                            }
                        }
                    }
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
                    htmlFor: `user-role-${role.value}`
                }, text(role.labelCode)))))
    }), errors.roleInCompany?.message ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dE8RX.Message), {
        severity: "error",
        text: errors.roleInCompany.message,
        className: "mt-2"
    }) : null), canEditPassword ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("lblChangingPassword"),
        icon: openPasswordChange ? "pi pi-chevron-down" : "pi pi-chevron-right",
        type: "button",
        link: true,
        size: "small",
        className: "p-0",
        "aria-expanded": openPasswordChange,
        "aria-controls": "change-password-fields",
        onClick: ()=>setPasswordChangeVisible(!openPasswordChange),
        "data-testid": "change-password"
    }), openPasswordChange ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        id: "change-password-fields",
        className: "grid formgrid mt-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 md:col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "new-password-input",
        type: "password",
        label: text("lblNewPasswordField"),
        "data-testid": "newPassword-input",
        required: true,
        subtitle: text("msgMinimumPasswordLength"),
        error: errors.newPassword?.message,
        ...register("newPassword", {
            required: text("msgPasswordRequired"),
            minLength: {
                value: 8,
                message: text("msgPasswordToShort")
            }
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "field col-12 md:col-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "confirm-new-password-input",
        type: "password",
        label: text("lblUserDetailsConfirmPasswordField"),
        "data-testid": "passcordCompare-input",
        required: true,
        error: errors.confirmNewPassword?.message,
        ...register("confirmNewPassword", {
            required: text("msgPasswordDoNotMatch"),
            deps: "newPassword",
            validate: (value)=>value === getValues("newPassword") || text("msgPasswordDoNotMatch")
        })
    }))) : null) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end mt-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("btnSave"),
        icon: "pi pi-save",
        disabled: saveDisabled,
        loading: isLoading || isSubmitting,
        type: "submit",
        "data-testid": "btnSave"
    }))));
});





var $cRXmD = parcelRequire("cRXmD");

var $5u6k9 = parcelRequire("5u6k9");

var $9p3YO = parcelRequire("9p3YO");
const $a74bb418999b3559$var$Column = (0, $gRonV.default).div`
    display: flex;
    flex-direction: column;
    width: 50%;

    @media screen and (max-width: 800px) {
        width: 100%;
    }
`;
const $a74bb418999b3559$var$Row = (0, $gRonV.default).div`
    display: flex;
    flex-direction: row;
    gap: 20px;

    @media screen and (max-width: 800px) {
        flex-direction: column;
    }
`;
const $a74bb418999b3559$export$ecdc3cf9d1cfe143 = /*#__PURE__*/ (0, $7E7Dk.memo)(function UserPage() {
    const text = (0, $5u6k9.default)();
    const dispatch = (0, $2rQNl.useDispatch)();
    const { id: id } = (0, $4AX6R.useParams)();
    const userId = id ?? "";
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const signedInUser = (0, $2rQNl.useSelector)((state)=>state.user);
    const selectedUserId = (0, $2rQNl.useSelector)((state)=>state.selectedUser.id);
    /**Fetch data **/ const { data: user } = (0, $1O9Jh.useUserGetUserByIdQuery)({
        userId: userId,
        companyId: companyId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    const { data: nfcTags, refetch: getNfcTags, isLoading: loadingNfcTags } = (0, $1O9Jh.useCompanyGetNfcTagsForUserQuery)({
        userId: userId,
        companyId: companyId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    const { data: registeredChargePoints, isLoading: loadingRegisteredChargePoints } = (0, $1O9Jh.useCompanyGetChargePointsForUserQuery)({
        companyId: companyId,
        userId: userId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    const { data: nfcAccessChargePoints, isLoading: loadingNfcAccessChargePoints } = (0, $1O9Jh.useUserGetForUserByNfcAccessWithNfcAccessInfoQuery)({
        companyId: companyId,
        userId: userId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    const { data: pools, isLoading: loadingPools } = (0, $1O9Jh.useUserGetPoolsForSelectedCompanyQuery)({
        userId: userId,
        companyId: companyId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    const { data: companyPools, isLoading: loadingCompanyPools } = (0, $1O9Jh.useCompanyGetPoolsQuery)({
        companyId: companyId
    }, {
        skip: !userId,
        refetchOnMountOrArgChange: true
    });
    /** Mutations **/ const [updateNfcTag] = (0, $1O9Jh.useNfcTagUpdateMutation)();
    const [deleteNfcTag] = (0, $1O9Jh.useNfcTagDisconnectFromUserMutation)();
    /***************/ (0, $7E7Dk.useEffect)(()=>{
        if (user) dispatch((0, $d66a8c58f38f865e$export$cb57a0abd67769d3)(user));
    }, [
        dispatch,
        user
    ]);
    const isAdmin = ()=>{
        return (0, $cbseE.default)(signedInUser, companyId, (0, $cRXmD.default).Admin);
    };
    const userDetailsReady = !userId || selectedUserId === userId;
    const bulkEditRfidTags = async (tags)=>{
        try {
            for(let i = 0; i < tags.length; i++)await updateNfcTag({
                nfcTag: tags[i]
            }).unwrap();
            await getNfcTags();
            (0, $r38ZI.notifySuccess)(text("msgRFIDTagsUpdated"));
            return true;
        } catch (e) {
            (0, $r38ZI.notifyError)(text("msgNFCTagNotUpdated"));
            return false;
        }
    };
    const deleteNfcTagFromUser = async (nfcTag)=>{
        if (!nfcTag) return;
        const confirmed = await (0, $9p3YO.confirm)({
            header: text("lblProceedConfirmation"),
            message: text("lblConfirmDeletingRFIDTag"),
            variant: "danger"
        });
        if (!confirmed) return;
        try {
            if (nfcTag.id && userId) await deleteNfcTag({
                nfcTagId: nfcTag.id,
                userId: userId
            }).unwrap();
            await getNfcTags();
            (0, $r38ZI.notifySuccess)(text("msgNFCTagRemoved", {
                id: nfcTag.id
            }));
        } catch (e) {
            (0, $r38ZI.notifyError)(text("msgRFIDNotRemoved"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a74bb418999b3559$var$Row, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a74bb418999b3559$var$Column, null, userDetailsReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $75dcf4e71cd6b5fa$export$a398983943bbde23), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), null), user && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $0bc1ae4548fed1b8$export$a71ecc24683233d6), {
        chargePoints: nfcAccessChargePoints ?? [],
        isAdmin: isAdmin(),
        dataLoadingChargePoints: loadingNfcAccessChargePoints
    }), loadingNfcAccessChargePoints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), {
        headerButton: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($a74bb418999b3559$var$Column, null, !loadingRegisteredChargePoints && user && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8bc24291d4c88354$export$72eeb2e143f5b912), {
        registeredChargePoints: registeredChargePoints ?? [],
        dataLoadingOwnedChargePoints: loadingRegisteredChargePoints
    }), loadingRegisteredChargePoints && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), null), !loadingNfcTags && user && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7f6667f4e0fd8a1d$export$dca7950e5ef74285), {
        nfcTags: nfcTags ?? [],
        isAdmin: isAdmin(),
        onBulkEdit: bulkEditRfidTags,
        deleteNfcTagFromUser: (tag)=>deleteNfcTagFromUser(tag)
    }), loadingNfcTags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), {
        headerButton: true
    }), !loadingPools && user && user.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $f84e076af9a796bc$export$3dcba8e413d97468), {
        pools: pools ?? [],
        isAdmin: isAdmin(),
        dataloadingPools: loadingPools || loadingCompanyPools,
        disableEdit: companyPools?.length === 0,
        userId: user.id
    }), loadingPools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1YBxD.WidgetLoadingState), {
        headerButton: true
    }))));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $3um4r = parcelRequire("3um4r");
var $4AX6R = parcelRequire("4AX6R");

var $1ot1u = parcelRequire("1ot1u");

var $2rQNl = parcelRequire("2rQNl");

var $56EgM = parcelRequire("56EgM");

var $dE8RX = parcelRequire("dE8RX");

var $aBfUs = parcelRequire("aBfUs");

var $eUJ8c = parcelRequire("eUJ8c");

var $1O9Jh = parcelRequire("1O9Jh");

var $7E7Dk = parcelRequire("7E7Dk");

var $2rQNl = parcelRequire("2rQNl");

var $3um4r = parcelRequire("3um4r");

var $1O9Jh = parcelRequire("1O9Jh");

var $7y3ec = parcelRequire("7y3ec");

var $5u6k9 = parcelRequire("5u6k9");


var $c6fcw = parcelRequire("c6fcw");

var $hw820 = parcelRequire("hw820");

var $aCffN = parcelRequire("aCffN");
const $ea01144bee449b6d$export$a4c3015f5b9342d9 = ()=>{
    const text = (0, $5u6k9.default)();
    const navigate = (0, $3um4r.useNavigate)();
    const toast = (0, $aCffN.useToast)();
    const dispatch = (0, $2rQNl.useDispatch)();
    const applyOrganisationSelection = (0, $7y3ec.useApplyOrganisationSelection)();
    const isConfirmedScopedAccessActive = (0, $2rQNl.useSelector)((0, $c24d70584502555a$export$3c3500f95c5ce184));
    const { data: organisations, isLoading: isLoading } = (0, $1O9Jh.useCompanyGetAdministratedCompaniesQuery)();
    const [getEntitlements] = (0, $1O9Jh.useEntitlementsCreateContextTokenMutation)();
    const organisationOptions = organisations?.map((organisation)=>({
            label: organisation?.name,
            value: organisation?.id
        }));
    const signedInUser = (0, $2rQNl.useSelector)((state)=>state.user);
    const handleChangeOrganisation = async (companyId)=>{
        if (!signedInUser || !signedInUser.selectedCompanyId) {
            navigate("/login", {
                replace: true
            });
            return;
        }
        try {
            const authenticationServiceContextRequest = {
                organizationId: companyId ?? ""
            };
            await getEntitlements({
                authenticationServiceContextRequest: authenticationServiceContextRequest
            }).unwrap();
            await applyOrganisationSelection({
                organizationId: companyId
            });
        } catch  {
            dispatch((0, $hw820.clearEntitlements)());
            toast.notifyError(text("lblCouldNotGetEntitlements"));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
        className: "w-10rem md:w-auto",
        id: "organisation-select",
        options: organisationOptions,
        value: signedInUser?.selectedCompanyId,
        onChange: (event)=>void handleChangeOrganisation(event.value),
        loading: isLoading,
        disabled: isLoading || isConfirmedScopedAccessActive,
        disabledReason: isConfirmedScopedAccessActive ? text("msgScopedAccessOrganisationSwitchDisabled") : undefined,
        filter: true,
        placeholder: text("lblSelectOrganisation"),
        showClear: false
    });
};





var $5u6k9 = parcelRequire("5u6k9");

var $igvrl = parcelRequire("igvrl");

var $5TMkT = parcelRequire("5TMkT");

var $aCffN = parcelRequire("aCffN");

var $gGcRO = parcelRequire("gGcRO");
const $998cfac53c0765be$export$1a35d6ac86f34b1b = ()=>{
    const { transferKey: transferKey } = (0, $4AX6R.useParams)();
    const navigate = (0, $3um4r.useNavigate)();
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const [confirmTransfer, setConfirmTransfer] = (0, $7E7Dk.useState)(false);
    const handleConfirmChange = (e)=>{
        setConfirmTransfer(Boolean(e.checked));
    };
    const { selectedCompanyId: selectedCompanyId } = (0, $2rQNl.useSelector)((state)=>state.user);
    const { data: companyInfo } = (0, $1O9Jh.useCompanyGetCompanyByIdQuery)({
        companyId: selectedCompanyId
    }, {
        skip: !selectedCompanyId
    });
    const { data: partner, error: partnerError } = (0, $1O9Jh.useCompanyTransferGetPartnerQuery)({
        transferKey: transferKey ?? "",
        companyId: selectedCompanyId
    }, {
        skip: !transferKey || !selectedCompanyId
    });
    const [requestTransfer] = (0, $1O9Jh.useCompanyTransferRequestTransferMutation)();
    const renderAlreadyBelongsToPartnerContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5TMkT.LandingMessage), {
            type: (0, $5TMkT.LandingMessageType).SUCCESS,
            title: text("lblTransferToANewPartner"),
            linkText: text("btnGoToDashboard"),
            onClick: ()=>{
                navigate("/dashboard", {
                    replace: true
                });
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "msgTransferOrganisationAlreadyBelongsToPartner",
            values: {
                partnerName: partner?.name
            }
        })));
    };
    const renderInvalidOrExpiredContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5TMkT.LandingMessage), {
            title: text("lblTransferLinkIsInvalid"),
            linkText: text("btnGoToDashboard"),
            onClick: ()=>{
                navigate("/dashboard", {
                    replace: true
                });
            },
            type: (0, $5TMkT.LandingMessageType).ERROR
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            "data-testid": "message"
        }, text("msgTransferInvalidLink")));
    };
    const renderDefaultContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5TMkT.LandingMessage), {
            title: text("lblTransferToANewPartner")
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: "msgDoYouWantToChangePartner",
            values: {
                fromPartner: companyInfo?.partnerName,
                toPartner: partner?.name,
                organisation: companyInfo?.name
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", null, text("msgAfterTheTransferInfo")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dE8RX.Message), {
            severity: "error",
            className: "w-full mb-3",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
                className: "m-0 p-0 text-left"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
                code: "msgTransferConfirmationWarning",
                values: {
                    currentPartner: companyInfo?.partnerName,
                    organisationName: companyInfo?.name
                }
            }))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex align-items-center mb-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $56EgM.Checkbox), {
            inputId: "confirmTransfer",
            checked: confirmTransfer,
            onChange: handleConfirmChange,
            className: "mr-2"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("label", {
            htmlFor: "confirmTransfer",
            className: "cursor-pointer mb-0"
        }, text("msgTransferConfirmation"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            className: "flex justify-content-between gap-2 mt-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            outlined: true,
            label: text("btnCancel"),
            "data-testid": "cancel-btn",
            onClick: ()=>navigate("/dashboard", {
                    replace: true
                })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            label: text("btnApprove"),
            "data-testid": "approve-btn",
            disabled: !confirmTransfer,
            onClick: ()=>{
                if (transferKey && selectedCompanyId) requestTransfer({
                    transferKey: transferKey,
                    companyId: selectedCompanyId
                }).unwrap().then(()=>{
                    navigate("/change-operator-success", {
                        replace: true
                    });
                }).catch((error)=>{
                    if ((0, $gGcRO.isFetchBaseQueryError)(error)) {
                        if (error.status === 403) toast.notifyError(text("msgTransferInsufficientPermissions"));
                        else toast.notifyError(text("lblSomethingWentWrong"));
                    }
                });
            }
        })));
    };
    const renderContent = ()=>{
        if (partnerError) return renderInvalidOrExpiredContent();
        if (partner && companyInfo) {
            if (partner?.id === companyInfo?.partnerId) return renderAlreadyBelongsToPartnerContent();
            return renderDefaultContent();
        }
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.LandingPageLayout), {
        background: (0, $eUJ8c.theme).whiteBackground,
        hideLanguageSelect: true,
        headerContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ea01144bee449b6d$export$a4c3015f5b9342d9), null)
    }, renderContent());
};



var $7E7Dk = parcelRequire("7E7Dk");

var $3um4r = parcelRequire("3um4r");

var $5u6k9 = parcelRequire("5u6k9");

var $aBfUs = parcelRequire("aBfUs");

var $5TMkT = parcelRequire("5TMkT");

var $eUJ8c = parcelRequire("eUJ8c");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");
function $0708e877213b7da9$export$8aed1aa80404ed23({ className: className, style: style, width: width = 151, height: height = 150, color: color = "#81E18B", ["data-testid"]: dataTestid = "mark-email-icon" }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("svg", {
        width: "151",
        height: "150",
        viewBox: "0 0 151 150",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("mask", {
        id: "mask0_4816_2011",
        // style="mask-type:alpha"
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: width,
        height: height,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        "data-testid": dataTestid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("rect", {
        x: "0.5",
        width: "150",
        height: "150",
        fill: "#D9D9D9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("g", {
        mask: "url(#mask0_4816_2011)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("path", {
        d: "M96.4375 131.562L75.5 110.625L78.625 107.5L96.4375 125.312L132.062 89.6875L135.188 92.8125L96.4375 131.562ZM75.5 68.75L123 37.5H28L75.5 68.75ZM75.5 74.0625L25.5 40.9375V107.5C25.5 108.958 25.9688 110.156 26.9062 111.094C27.8438 112.031 29.0417 112.5 30.5 112.5H59.7188L64.0938 116.875H30.5C27.7917 116.875 25.5521 115.99 23.7812 114.219C22.0104 112.448 21.125 110.208 21.125 107.5V42.5C21.125 39.7917 22.0104 37.5521 23.7812 35.7812C25.5521 34.0104 27.7917 33.125 30.5 33.125H120.5C123.208 33.125 125.448 34.0104 127.219 35.7812C128.99 37.5521 129.875 39.7917 129.875 42.5V74.375L125.5 78.75V40.9375L75.5 74.0625Z",
        fill: color
    })));
}




const $91679d095db9062c$export$d99df8dc0cf8373 = ()=>{
    const text = (0, $5u6k9.default)();
    const navigate = (0, $3um4r.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aBfUs.LandingPageLayout), {
        background: (0, $eUJ8c.theme).whiteBackground,
        hideLanguageSelect: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $5TMkT.LandingMessage), {
        title: text("lblTransferRequestSent"),
        linkText: text("btnGoToDashboard"),
        onClick: ()=>{
            navigate("/dashboard", {
                replace: true
            });
        },
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $0708e877213b7da9$export$8aed1aa80404ed23), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "message"
    }, text("msgTransferRequestSent"))));
};





var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $2rQNl = parcelRequire("2rQNl");

var $3um4r = parcelRequire("3um4r");

var $eLH3C = parcelRequire("eLH3C");

var $22lzE = parcelRequire("22lzE");

var $6oqHU = parcelRequire("6oqHU");

var $26yAo = parcelRequire("26yAo");

var $1O9Jh = parcelRequire("1O9Jh");

var $b10kV = parcelRequire("b10kV");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $6oqHU = parcelRequire("6oqHU");

var $1ot1u = parcelRequire("1ot1u");

var $5u6k9 = parcelRequire("5u6k9");
const $827bc7dda15cb5cf$export$3cc4aa7b1bbcf28 = /*#__PURE__*/ (0, $7E7Dk.memo)(function BillingPaymentDetailsWidget({ className: className, style: style, billableConnectors: billableConnectors, isCustomer: isCustomer, hasActiveSubscription: hasActiveSubscription, onManagePayments: onManagePayments }) {
    const text = (0, $5u6k9.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6oqHU.Card), {
        title: text("lblDetails"),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-3"
    }, isCustomer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, hasActiveSubscription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "m-0"
    }, text("lblYourNextInvoiceWillInclude", {
        chargerCount: billableConnectors
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", null, text("lblCustomerPortalDescription")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        onClick: onManagePayments,
        label: text("lblManagePayment"),
        icon: "pi pi-cog"
    }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "m-0 text-sm text-gray-500"
    }, text("lblPaymentDetailLine"))));
});



var $aCffN = parcelRequire("aCffN");

var $5u6k9 = parcelRequire("5u6k9");

var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $6oqHU = parcelRequire("6oqHU");

var $5u6k9 = parcelRequire("5u6k9");

var $1skD3 = parcelRequire("1skD3");
const $4f3c6c8e964f65ad$var$BILLING_PLAN_INTERVAL_TEXT_KEYS = {
    month: "lblBillingIntervalMonthly",
    year: "lblBillingIntervalYearly"
};
const $4f3c6c8e964f65ad$export$8492f7b1a5cb9a11 = /*#__PURE__*/ (0, $7E7Dk.memo)(function BillingPlanWidget({ className: className, style: style, subscription: subscription, interval: interval }) {
    const text = (0, $5u6k9.default)();
    const intervalLabel = interval ? text($4f3c6c8e964f65ad$var$BILLING_PLAN_INTERVAL_TEXT_KEYS[interval]) : null;
    const cancellationDate = subscription.cancelAt ? (0, $1skD3.default)(subscription.cancelAt) : null;
    const activationDate = subscription.createdAtUtc ? (0, $1skD3.default)(subscription.createdAtUtc) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6oqHU.Card), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style,
        pt: {
            body: {
                className: "p-4"
            },
            content: {
                className: "p-0"
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "text-xl font-bold"
    }, text("lblYourPlan")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h1", {
        className: "m-0"
    }, subscription.name), intervalLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        "data-testid": "billing-plan-interval",
        className: "m-0 text-sm text-600"
    }, text("lblBillingInterval"), ": ", intervalLabel) : null), cancellationDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column align-items-start gap-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "billing-plan-cancelled-panel",
        className: "inline-flex align-self-start align-items-start gap-2 border-round bg-red-100 px-2 py-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
        className: "pi pi-times mt-1 text-xs text-red-700",
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "m-0 text-sm line-height-3 text-red-700"
    }, text("lblThisPlanHasBeenCancelled", {
        date: cancellationDate
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "m-0"
    }, text("lblIfYouWishToAbortCancel"))) : null, activationDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "billing-plan-activated-panel",
        className: "inline-flex align-self-start align-items-start gap-2 border-round bg-green-100 px-2 py-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
        className: "pi pi-check mt-1 text-xs text-green-700",
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "m-0 text-sm line-height-3 text-700"
    }, text("lblActivated"), " ", activationDate)) : null));
});



var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $6oqHU = parcelRequire("6oqHU");

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $5u6k9 = parcelRequire("5u6k9");

var $7E7Dk = parcelRequire("7E7Dk");

var $eHYdO = parcelRequire("eHYdO");

var $igvrl = parcelRequire("igvrl");
function $973763d159f5e108$export$d8948ace2e681cc0({ testId: testId, title: title, description: description, headerContent: headerContent, price: price, priceSuffix: priceSuffix, priceDetailLines: priceDetailLines, isRecommended: isRecommended = false, discountInPercent: discountInPercent, tag: tag, marketingFeatures: marketingFeatures, footer: footer }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": testId,
        className: "flex flex-column h-full surface-border overflow-hidden shadow-1 font-light border-1 gap-5 relative"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: isRecommended ? "bg-green-100" : "bg-gray-200",
        style: {
            height: "7px"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "px-6 h-9rem"
    }, tag ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": `subscription-${title}-tag`,
        className: `absolute top-0 right-0 px-3 mt-3 mr-3 py-1 text-sm border-round-sm text-center ${tag.className ?? "bg-gray-200"} text-900`
    }, tag.content) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h3", {
        className: "text-2xl font-bold"
    }, title), description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "text-base"
    }, description) : null, headerContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "text-3xl h-12rem justify-content-center flex flex-column bg-green-100 relative"
    }, discountInPercent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": `subscription-${title}-discount`,
        className: "absolute top-0 right-0 px-3 mt-3 mr-3 py-1 text-sm border-round-sm text-center bg-green-300"
    }, "-", discountInPercent, "%") : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "relative px-6 flex flex-column gap-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "text-large m-0"
    }, price, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
        className: "text-green-400"
    }, priceSuffix)), priceDetailLines.map((priceDetailLine)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
            className: "text-base m-0",
            key: priceDetailLine
        }, priceDetailLine)))), marketingFeatures.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "px-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("ul", {
        className: "m-0 p-0 list-none flex flex-column gap-3"
    }, marketingFeatures.map((marketingFeature)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("li", {
            key: marketingFeature.label,
            className: `flex align-items-center ${marketingFeature.isActive ? "text-900" : "text-500"}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("i", {
            "aria-hidden": "true",
            className: `mr-2 ${marketingFeature.isActive ? (0, $eHYdO.PrimeIcons).CHECK : (0, $eHYdO.PrimeIcons).MINUS}`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
            code: marketingFeature.label
        })))))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "px-6 h-5rem pb-4 flex align-items-center justify-content-center"
    }, footer));
}



var $aLIw2 = parcelRequire("aLIw2");

var $hPpPu = parcelRequire("hPpPu");

var $d5Zuc = parcelRequire("d5Zuc");
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

var $9cf38bb6c64c44e6$exports = {};
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $9cf38bb6c64c44e6$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty($9cf38bb6c64c44e6$exports, "__esModule", {
    value: true
});
$9cf38bb6c64c44e6$exports.default = $9cf38bb6c64c44e6$var$cloneObject;

var $9cf38bb6c64c44e6$var$_index = $9cf38bb6c64c44e6$require$_interopRequireDefault((parcelRequire("cVCzn")));
function $9cf38bb6c64c44e6$var$cloneObject(object) {
    return (0, $9cf38bb6c64c44e6$var$_index.default)({}, object);
}
$9cf38bb6c64c44e6$exports = $9cf38bb6c64c44e6$exports.default;


var $4831666288838952$exports = {};
"use strict";

var $4f3eE = parcelRequire("4f3eE");
var $4831666288838952$require$_interopRequireDefault = $4f3eE.default;
Object.defineProperty($4831666288838952$exports, "__esModule", {
    value: true
});
$4831666288838952$exports.default = $4831666288838952$var$format;

var $4831666288838952$var$_index = $4831666288838952$require$_interopRequireDefault((parcelRequire("e9RVe")));

var $4831666288838952$var$_index2 = $4831666288838952$require$_interopRequireDefault((parcelRequire("c3qQ5")));

var $4831666288838952$var$_index3 = $4831666288838952$require$_interopRequireDefault((parcelRequire("69nrk")));

var $4831666288838952$var$_index4 = $4831666288838952$require$_interopRequireDefault((parcelRequire("2S06x")));

var $4831666288838952$var$_index5 = $4831666288838952$require$_interopRequireDefault((parcelRequire("4pCyZ")));

var $4831666288838952$var$_index6 = $4831666288838952$require$_interopRequireDefault((parcelRequire("5AgSn")));
var $47aa6cd9c9f4725a$exports = {};
"use strict";
Object.defineProperty($47aa6cd9c9f4725a$exports, "__esModule", {
    value: true
});
$47aa6cd9c9f4725a$exports.isProtectedDayOfYearToken = $47aa6cd9c9f4725a$var$isProtectedDayOfYearToken;
$47aa6cd9c9f4725a$exports.isProtectedWeekYearToken = $47aa6cd9c9f4725a$var$isProtectedWeekYearToken;
$47aa6cd9c9f4725a$exports.throwProtectedError = $47aa6cd9c9f4725a$var$throwProtectedError;
var $47aa6cd9c9f4725a$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $47aa6cd9c9f4725a$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $47aa6cd9c9f4725a$var$isProtectedDayOfYearToken(token) {
    return $47aa6cd9c9f4725a$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $47aa6cd9c9f4725a$var$isProtectedWeekYearToken(token) {
    return $47aa6cd9c9f4725a$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $47aa6cd9c9f4725a$var$throwProtectedError(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}



var $4831666288838952$var$_index8 = $4831666288838952$require$_interopRequireDefault((parcelRequire("kSC9t")));

var $4831666288838952$var$_index9 = $4831666288838952$require$_interopRequireDefault((parcelRequire("aIIrR")));

var $fVGjF = parcelRequire("fVGjF");

var $4831666288838952$var$_index11 = $4831666288838952$require$_interopRequireDefault((parcelRequire("3si5s")));
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4831666288838952$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4831666288838952$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4831666288838952$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4831666288838952$var$doubleQuoteRegExp = /''/g;
var $4831666288838952$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $4831666288838952$var$format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $4831666288838952$var$_index9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $fVGjF.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : $4831666288838952$var$_index11.default;
    var firstWeekContainsDate = (0, $4831666288838952$var$_index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $4831666288838952$var$_index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $4831666288838952$var$_index3.default)(dirtyDate);
    if (!(0, $4831666288838952$var$_index.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $4831666288838952$var$_index6.default)(originalDate);
    var utcDate = (0, $4831666288838952$var$_index2.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($4831666288838952$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = $4831666288838952$var$_index5.default[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($4831666288838952$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $4831666288838952$var$cleanEscapedString(substring);
        var formatter = $4831666288838952$var$_index4.default[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $47aa6cd9c9f4725a$exports.isProtectedWeekYearToken)(substring)) (0, $47aa6cd9c9f4725a$exports.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $47aa6cd9c9f4725a$exports.isProtectedDayOfYearToken)(substring)) (0, $47aa6cd9c9f4725a$exports.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4831666288838952$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $4831666288838952$var$cleanEscapedString(input) {
    var matched = input.match($4831666288838952$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4831666288838952$var$doubleQuoteRegExp, "'");
}
$4831666288838952$exports = $4831666288838952$exports.default;


/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $470d94d7d603ca71$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $470d94d7d603ca71$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $470d94d7d603ca71$var$partsTimeZone(dtf, date) : $470d94d7d603ca71$var$hackyTimeZone(dtf, date);
}
function $470d94d7d603ca71$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === "timeZoneName") return formatted[i].value;
    }
}
function $470d94d7d603ca71$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, "");
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : "";
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $470d94d7d603ca71$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        "en-US"
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}


/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $a2e6ce12b7f8c5c1$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $a2e6ce12b7f8c5c1$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $a2e6ce12b7f8c5c1$var$partsOffset(dtf, date) : $a2e6ce12b7f8c5c1$var$hackyOffset(dtf, date);
}
var $a2e6ce12b7f8c5c1$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $a2e6ce12b7f8c5c1$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $a2e6ce12b7f8c5c1$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $a2e6ce12b7f8c5c1$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, "");
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $a2e6ce12b7f8c5c1$var$dtfCache = {};
function $a2e6ce12b7f8c5c1$var$getDateTimeFormat(timeZone) {
    if (!$a2e6ce12b7f8c5c1$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: "America/New_York",
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }).format(new Date("2014-06-25T04:00:00.123Z"));
        var hourCycleSupported = testDateFormatted === "06/25/2014, 00:00:00" || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $a2e6ce12b7f8c5c1$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: timeZone,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        }) : new Intl.DateTimeFormat("en-US", {
            hourCycle: "h23",
            timeZone: timeZone,
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }
    return $a2e6ce12b7f8c5c1$var$dtfCache[timeZone];
}


/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $ccd1bdf5f2451e39$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}


var $9bff7cc1ae1d125c$var$MILLISECONDS_IN_HOUR = 3600000;
var $9bff7cc1ae1d125c$var$MILLISECONDS_IN_MINUTE = 60000;
var $9bff7cc1ae1d125c$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function $9bff7cc1ae1d125c$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $9bff7cc1ae1d125c$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $9bff7cc1ae1d125c$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$9bff7cc1ae1d125c$var$validateTimezone(hours)) return NaN;
        return -(hours * $9bff7cc1ae1d125c$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $9bff7cc1ae1d125c$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        var minutes = parseInt(token[2], 10);
        if (!$9bff7cc1ae1d125c$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $9bff7cc1ae1d125c$var$MILLISECONDS_IN_HOUR + minutes * $9bff7cc1ae1d125c$var$MILLISECONDS_IN_MINUTE;
        return hours > 0 ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($9bff7cc1ae1d125c$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $9bff7cc1ae1d125c$var$toUtcDate(date);
        var offset = $9bff7cc1ae1d125c$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $9bff7cc1ae1d125c$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $9bff7cc1ae1d125c$var$toUtcDate(date) {
    return (0, $ccd1bdf5f2451e39$export$2e2bcd8739ae039)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $9bff7cc1ae1d125c$var$calcOffset(date, timezoneString) {
    var tokens = (0, $a2e6ce12b7f8c5c1$export$2e2bcd8739ae039)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $ccd1bdf5f2451e39$export$2e2bcd8739ae039)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $9bff7cc1ae1d125c$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $9bff7cc1ae1d125c$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $9bff7cc1ae1d125c$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $9bff7cc1ae1d125c$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $9bff7cc1ae1d125c$var$validIANATimezoneCache = {};
function $9bff7cc1ae1d125c$var$isValidTimezoneIANAString(timeZoneString) {
    if ($9bff7cc1ae1d125c$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $9bff7cc1ae1d125c$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}


var $7780ac5dc59e5a6e$var$MILLISECONDS_IN_MINUTE = 60000;
var $7780ac5dc59e5a6e$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $7780ac5dc59e5a6e$var$getTimeZoneOffset(options.timeZone, options._originalDate || date);
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $7780ac5dc59e5a6e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $7780ac5dc59e5a6e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $7780ac5dc59e5a6e$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $7780ac5dc59e5a6e$var$getTimeZoneOffset(options.timeZone, options._originalDate || date);
        switch(token){
            // Hours and optional minutes
            case "x":
                return $7780ac5dc59e5a6e$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $7780ac5dc59e5a6e$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $7780ac5dc59e5a6e$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $7780ac5dc59e5a6e$var$getTimeZoneOffset(options.timeZone, options._originalDate || date);
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $7780ac5dc59e5a6e$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $7780ac5dc59e5a6e$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        var originalDate = options._originalDate || date;
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return (0, $470d94d7d603ca71$export$2e2bcd8739ae039)("short", originalDate, options);
            // Long
            case "zzzz":
            default:
                return (0, $470d94d7d603ca71$export$2e2bcd8739ae039)("long", originalDate, options);
        }
    }
};
function $7780ac5dc59e5a6e$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $9bff7cc1ae1d125c$export$2e2bcd8739ae039)(timeZone, originalDate, true) / $7780ac5dc59e5a6e$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError("Invalid time zone specified: " + timeZone);
    return timeZoneOffset;
}
function $7780ac5dc59e5a6e$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}
function $7780ac5dc59e5a6e$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = $7780ac5dc59e5a6e$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $7780ac5dc59e5a6e$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $7780ac5dc59e5a6e$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + $7780ac5dc59e5a6e$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $7780ac5dc59e5a6e$var$formatTimezone(offset, dirtyDelimeter);
}
function $7780ac5dc59e5a6e$var$formatTimezoneShort(offset, dirtyDelimeter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimeter = dirtyDelimeter || "";
    return sign + String(hours) + delimeter + $7780ac5dc59e5a6e$var$addLeadingZeros(minutes, 2);
}
var $7780ac5dc59e5a6e$export$2e2bcd8739ae039 = $7780ac5dc59e5a6e$var$formatters;



var $kSC9t = parcelRequire("kSC9t");

var $5AgSn = parcelRequire("5AgSn");

/** Regex to identify the presence of a time zone specifier in a date string */ var $c2fcaa9a9f7868db$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $c2fcaa9a9f7868db$export$2e2bcd8739ae039 = $c2fcaa9a9f7868db$var$tzPattern;


var $d406330539ca1bab$var$MILLISECONDS_IN_HOUR = 3600000;
var $d406330539ca1bab$var$MILLISECONDS_IN_MINUTE = 60000;
var $d406330539ca1bab$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $d406330539ca1bab$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $c2fcaa9a9f7868db$export$2e2bcd8739ae039)
};
function $d406330539ca1bab$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError("1 argument required, but only " + arguments.length + " present");
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $d406330539ca1bab$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($kSC9t)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && Object.prototype.toString.call(argument) === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || Object.prototype.toString.call(argument) === "[object Number]") return new Date(argument);
    else if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $d406330539ca1bab$var$splitDateString(argument);
    var parseYearResult = $d406330539ca1bab$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $d406330539ca1bab$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $d406330539ca1bab$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $9bff7cc1ae1d125c$export$2e2bcd8739ae039)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($5AgSn)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($5AgSn)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $d406330539ca1bab$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $d406330539ca1bab$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $d406330539ca1bab$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $d406330539ca1bab$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $d406330539ca1bab$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $d406330539ca1bab$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $d406330539ca1bab$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $d406330539ca1bab$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $d406330539ca1bab$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $d406330539ca1bab$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $d406330539ca1bab$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$d406330539ca1bab$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $d406330539ca1bab$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$d406330539ca1bab$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $d406330539ca1bab$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$d406330539ca1bab$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $d406330539ca1bab$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$d406330539ca1bab$var$validateWeekDate(year, week)) return new Date(NaN);
        return $d406330539ca1bab$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $d406330539ca1bab$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$d406330539ca1bab$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $d406330539ca1bab$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $d406330539ca1bab$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $d406330539ca1bab$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(",", "."));
        if (!$d406330539ca1bab$var$validateTime(hours)) return NaN;
        return hours % 24 * $d406330539ca1bab$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $d406330539ca1bab$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(",", "."));
        if (!$d406330539ca1bab$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $d406330539ca1bab$var$MILLISECONDS_IN_HOUR + minutes * $d406330539ca1bab$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $d406330539ca1bab$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(",", "."));
        if (!$d406330539ca1bab$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $d406330539ca1bab$var$MILLISECONDS_IN_HOUR + minutes * $d406330539ca1bab$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $d406330539ca1bab$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $d406330539ca1bab$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $d406330539ca1bab$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $d406330539ca1bab$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $d406330539ca1bab$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $d406330539ca1bab$var$isLeapYearIndex(year);
        if (isLeapYear && date > $d406330539ca1bab$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $d406330539ca1bab$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $d406330539ca1bab$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $d406330539ca1bab$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $d406330539ca1bab$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $d406330539ca1bab$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}


var $e18a03c32d073f45$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $e18a03c32d073f45$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($e18a03c32d073f45$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $d406330539ca1bab$export$2e2bcd8739ae039)(dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $7780ac5dc59e5a6e$export$2e2bcd8739ae039)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($4831666288838952$exports)))(dirtyDate, formatStr, options);
}




function $cdb060c37a0b2c90$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $d406330539ca1bab$export$2e2bcd8739ae039)(dirtyDate, options);
    var offsetMilliseconds = (0, $9bff7cc1ae1d125c$export$2e2bcd8739ae039)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}


function $58942f57b25bc92b$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($9cf38bb6c64c44e6$exports)))(options);
    extendedOptions.timeZone = timeZone;
    return (0, $e18a03c32d073f45$export$2e2bcd8739ae039)((0, $cdb060c37a0b2c90$export$2e2bcd8739ae039)(date, timeZone), formatStr, extendedOptions);
}









var $b10kV = parcelRequire("b10kV");

var $aLIw2 = parcelRequire("aLIw2");
const $8745517b240a5a3d$var$getOptionalText = (text, key)=>{
    if (!key) return "";
    const value = text(key);
    return value === key ? "" : value;
};
const $8745517b240a5a3d$var$pickMonthlyPrices = (prices)=>{
    const monthlyPrices = prices.filter((p)=>p.interval === "month");
    const standard = monthlyPrices.find((p)=>p.schedulePreview == null) ?? monthlyPrices[0];
    const promo = monthlyPrices.find((p)=>p.schedulePreview != null);
    return {
        standard: standard,
        promo: promo
    };
};
const $8745517b240a5a3d$var$pickYearlyPrice = (prices)=>prices.find((price)=>price.interval === "year");
const $8745517b240a5a3d$var$toVatPriceNumber = (unitPriceInCurrency)=>(0, $b10kV.convertPriceStringToNumber)(unitPriceInCurrency ?? "0") * (0, $b10kV.SWEDISH_VAT);
const $8745517b240a5a3d$var$computeYearlyDiscountPercent = (monthlyPriceNum, yearlyPriceNum)=>{
    const yearlyTotalFromMonthly = monthlyPriceNum * 12;
    if (!Number.isFinite(yearlyTotalFromMonthly) || yearlyTotalFromMonthly <= 0) return undefined;
    if (!Number.isFinite(yearlyPriceNum) || yearlyPriceNum <= 0) return undefined;
    const raw = (1 - yearlyPriceNum / yearlyTotalFromMonthly) * 100;
    const rounded = Math.round(raw);
    return rounded > 0 ? rounded : undefined;
};
function $8745517b240a5a3d$export$875f7246de4aa4af({ product: product, billableConnectors: billableConnectors, marketingFeatures: marketingFeatures, billingInterval: billingInterval, text: text, locale: locale, currency: currency, now: now = new Date(), timeZone: timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone }) {
    const productName = product.name.trim().toLowerCase();
    const isFlex = productName === "flex";
    const isPro = productName === "pro";
    const filteredMarketingFeatures = marketingFeatures.filter((mf)=>mf.label !== "lblMarketingFeatureHistory").map((mf)=>mf.label === "lblBasicProductFeatureLine02" ? {
            ...mf,
            label: "lblMarketingFeatureHistory"
        } : mf);
    const mappedMarketingFeatures = filteredMarketingFeatures.map((mf)=>({
            ...mf,
            isActive: (product.marketingFeatures ?? []).includes(mf.label) || (product.productLevel ?? 0) > mf.productLevel
        }));
    const billableConnectorQuantity = billableConnectors?.quantities?.find((quantity)=>quantity.strategyKey === product.quantityStrategyKey)?.quantity;
    const billableConnectorsCount = billableConnectorQuantity ?? 0;
    const prices = product.prices ?? [];
    const { standard: monthlyStandard, promo: monthlyPromo } = $8745517b240a5a3d$var$pickMonthlyPrices(prices);
    const yearlyItem = $8745517b240a5a3d$var$pickYearlyPrice(prices);
    const isMonthlyBilling = billingInterval === "month";
    const monthlyPriceNum = $8745517b240a5a3d$var$toVatPriceNumber(monthlyStandard?.unitPriceInCurrency);
    const monthlyPromoPriceNum = $8745517b240a5a3d$var$toVatPriceNumber(monthlyPromo?.unitPriceInCurrency);
    const yearlyPriceNum = $8745517b240a5a3d$var$toVatPriceNumber(yearlyItem?.unitPriceInCurrency);
    const formatPrice = (price)=>(0, $b10kV.formatToCurrencyString)(currency, price, locale);
    const monthlyPrice = formatPrice(monthlyPriceNum);
    const monthlyPromoPrice = formatPrice(monthlyPromoPriceNum);
    const monthlyRealtimePrice = formatPrice(monthlyPriceNum * billableConnectorsCount);
    const monthlyRealtimePromoPrice = formatPrice(monthlyPromoPriceNum * billableConnectorsCount);
    const yearlyPricePerMonth = formatPrice(yearlyPriceNum / 12);
    const yearlyRealtimePrice = formatPrice(yearlyPriceNum * billableConnectorsCount);
    const yearlyRealtimePricePerMonth = formatPrice(yearlyPriceNum / 12 * billableConnectorsCount);
    const yearlyRealTimeSaving = monthlyStandard && yearlyItem ? formatPrice(Math.max(0, monthlyPriceNum * 12 - yearlyPriceNum) * billableConnectorsCount) : null;
    const discountPercent = isPro && !isMonthlyBilling ? $8745517b240a5a3d$var$computeYearlyDiscountPercent(monthlyPriceNum, yearlyPriceNum) : undefined;
    const i18nDescriptionKey = isPro ? "lblProduct1Description" : isFlex ? "lblProduct2Description" : undefined;
    const description = $8745517b240a5a3d$var$getOptionalText(text, i18nDescriptionKey);
    const tagKey = isPro ? "lblSubscriptionTagPro" : isFlex ? "lblSubscriptionTagFlex" : undefined;
    const tagContent = $8745517b240a5a3d$var$getOptionalText(text, tagKey);
    const tag = tagContent ? {
        content: tagContent,
        className: isFlex ? "bg-green-300" : undefined
    } : undefined;
    const isAvailableLater = new Date(product.availableFromDate) > now;
    const availableFrom = isAvailableLater ? (0, $58942f57b25bc92b$export$2e2bcd8739ae039)(product.availableFromDate, timeZone, "yyyy-MM-dd HH:mm", {
        locale: (0, $aLIw2.LOCALE_CODE_MAP)[locale] ?? (0, $d5Zuc.default)
    }) : null;
    const monthShort = text("lblMonthShort").toLowerCase();
    const perConnectorSuffix = `${text("lblPerConnector").toLowerCase()}/${monthShort}${isFlex ? "*" : ""}`;
    const hasMonthlyPromo = isFlex && !!monthlyPromo?.unitPriceInCurrency;
    const primaryAmount = isMonthlyBilling ? hasMonthlyPromo ? monthlyPromoPrice : monthlyPrice : yearlyPricePerMonth;
    const hasBillableConnectors = billableConnectorQuantity != null && billableConnectorQuantity > 0;
    const monthlyProDetailLines = isPro && hasBillableConnectors ? [
        `${text("lblYourPrice")} ${monthlyRealtimePrice}/${monthShort}.`,
        ...yearlyRealTimeSaving ? [
            text("lblSaveYearly", {
                amount: yearlyRealTimeSaving
            })
        ] : []
    ] : [];
    const monthlyFlexDetailLines = (()=>{
        if (!isFlex) return [];
        if (hasMonthlyPromo) return [
            ...hasBillableConnectors ? [
                `${text("lblYourPriceFirstMonth")} ${monthlyRealtimePromoPrice}.`
            ] : [],
            `* ${text("lblProduct2PriceDescription", {
                amount: monthlyPrice
            }).toLowerCase()}`
        ];
        return hasBillableConnectors ? [
            `${text("lblYourPrice")} ${monthlyRealtimePrice}/${monthShort}.`
        ] : [];
    })();
    const yearlyProDetailLines = isPro && hasBillableConnectors && yearlyItem ? [
        text("lblYourPriceAfterDiscount", {
            amount: yearlyRealtimePrice,
            interval: text("lblYear").toLowerCase(),
            discountAmount: discountPercent ?? 0
        }),
        `${text("lblCorrespondsTo")} ${yearlyRealtimePricePerMonth}/${monthShort}.`
    ] : [];
    const detailLines = (()=>{
        if (!isMonthlyBilling) return yearlyProDetailLines;
        if (isPro) return monthlyProDetailLines;
        return monthlyFlexDetailLines;
    })();
    const footer = isAvailableLater ? {
        type: "message",
        text: text("lblThisProductWillBeAvailableFrom", {
            date: availableFrom
        })
    } : {
        type: "cta",
        text: text("lblChoosePlan"),
        isDisabled: !product.canBeBought || (isMonthlyBilling ? !monthlyStandard : !yearlyItem)
    };
    return {
        title: product.name,
        description: description,
        isRecommended: isPro,
        tag: tag,
        discountInPercent: discountPercent,
        marketingFeatures: mappedMarketingFeatures,
        primaryPrice: {
            amount: primaryAmount,
            suffix: perConnectorSuffix
        },
        detailLines: detailLines,
        footer: footer
    };
}


const $e191ec0f9e3d7aec$var$BILLING_INTERVALS = [
    "month",
    "year"
];
const $e191ec0f9e3d7aec$var$getAvailableBillingIntervals = (product)=>$e191ec0f9e3d7aec$var$BILLING_INTERVALS.filter((interval)=>product.prices?.some((price)=>price.interval === interval));
function $e191ec0f9e3d7aec$export$9206da65ddd43509({ product: product, currency: currency, onSelectPlan: onSelectPlan, billableConnectors: billableConnectors, marketingFeatures: marketingFeatures }) {
    const text = (0, $5u6k9.default)();
    const { locale: locale } = (0, $aLIw2.useLocalizationContext)();
    const [selectedBillingInterval, setSelectedBillingInterval] = (0, $7E7Dk.useState)("month");
    const isPro = product.name.toLowerCase() === "pro";
    const availableBillingIntervals = $e191ec0f9e3d7aec$var$getAvailableBillingIntervals(product);
    const showBillingIntervalSelector = isPro && availableBillingIntervals.length > 1;
    const billingInterval = showBillingIntervalSelector ? selectedBillingInterval : availableBillingIntervals[0] ?? "month";
    const model = (0, $8745517b240a5a3d$export$875f7246de4aa4af)({
        product: product,
        billableConnectors: billableConnectors,
        marketingFeatures: marketingFeatures,
        billingInterval: billingInterval,
        text: text,
        locale: locale,
        currency: currency
    });
    const billingIntervalSelector = showBillingIntervalSelector ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hPpPu.SelectButton), {
        id: `subscription-${product.id}-interval`,
        ariaLabel: text("lblBillingInterval"),
        value: billingInterval,
        onChange: setSelectedBillingInterval,
        options: [
            {
                value: "month",
                label: text("lblPayMonthly")
            },
            {
                value: "year",
                label: text("lblPayYearly")
            }
        ],
        className: "inline-flex align-items-center border-round-sm border-1 surface-0 surface-border px-1 py-1 gap-2",
        style: {
            minWidth: "16rem",
            width: "fit-content"
        },
        "data-testid": `subscription-${product.id}-interval-selector`,
        optionContentClassName: "text-sm font-bold",
        optionLabelClassName: "text-sm font-bold",
        optionTestId: (option)=>`subscription-${product.id}-interval-${String(option.value)}`,
        optionClassName: (_option, { selected: selected })=>[
                "flex-1 justify-content-center border-none border-round-sm py-2 px-4 cursor-pointer transition-duration-150 transition-colors shadow-none",
                selected ? "bg-green-300 text-900 shadow-1" : "bg-transparent text-700 hover:surface-100"
            ].join(" ")
    })) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $973763d159f5e108$export$d8948ace2e681cc0), {
        testId: `subscription-${product.id}-card`,
        title: model.title,
        description: model.description,
        headerContent: billingIntervalSelector,
        isRecommended: model.isRecommended,
        tag: model.tag,
        discountInPercent: model.discountInPercent,
        price: model.primaryPrice.amount,
        priceSuffix: model.primaryPrice.suffix,
        priceDetailLines: model.detailLines,
        marketingFeatures: model.marketingFeatures,
        footer: model.footer.type === "cta" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
            className: "w-full text-xl radius-small",
            label: model.footer.text,
            severity: "success",
            onClick: ()=>onSelectPlan(billingInterval),
            disabled: model.footer.isDisabled
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", null, model.footer.text)
    });
}



var $1O9Jh = parcelRequire("1O9Jh");

var $7E7Dk = parcelRequire("7E7Dk");

var $5u6k9 = parcelRequire("5u6k9");


var $b10kV = parcelRequire("b10kV");

var $aLIw2 = parcelRequire("aLIw2");
function $654d689d3fd572fb$export$33be3ed9f809e989({ marketingFeatures: marketingFeatures, currency: currency }) {
    const text = (0, $5u6k9.default)();
    const { locale: locale } = (0, $aLIw2.useLocalizationContext)();
    const basicMarketingFeatures = marketingFeatures.filter((feature)=>feature.label !== "lblMarketingFeatureHistory").map((feature)=>({
            ...feature,
            isActive: feature.productLevel === 0
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $973763d159f5e108$export$d8948ace2e681cc0), {
        testId: "subscription-basic-card",
        title: text("lblBasicProductName"),
        description: text("lblBasicProductDescription"),
        price: (0, $b10kV.formatToCurrencyString)(currency, 0, locale),
        priceDetailLines: [
            text("lblFreeForCAChargers")
        ],
        marketingFeatures: basicMarketingFeatures,
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
            className: "text-xl m-0"
        }, text("lblYourCurrentPlan"))
    });
}





var $5u6k9 = parcelRequire("5u6k9");

var $aCffN = parcelRequire("aCffN");

var $aLIw2 = parcelRequire("aLIw2");

var $7E7Dk = parcelRequire("7E7Dk");

var $1ot1u = parcelRequire("1ot1u");

var $e6olx = parcelRequire("e6olx");

var $22lzE = parcelRequire("22lzE");

var $5u6k9 = parcelRequire("5u6k9");

var $MMfqT = parcelRequire("MMfqT");

var $igvrl = parcelRequire("igvrl");

var $7E7Dk = parcelRequire("7E7Dk");

var $l6tdd = parcelRequire("l6tdd");

var $1ot1u = parcelRequire("1ot1u");

var $dE8RX = parcelRequire("dE8RX");

var $cCnqE = parcelRequire("cCnqE");

var $aLIw2 = parcelRequire("aLIw2");

var $5u6k9 = parcelRequire("5u6k9");

var $b10kV = parcelRequire("b10kV");

var $c6fcw = parcelRequire("c6fcw");

var $1o9MR = parcelRequire("1o9MR");

var $dos1r = parcelRequire("dos1r");
// node_modules/personnummer/dist/esm/index.js
var $35704cfaefdc74d5$var$PersonnummerError = class extends Error {
    constructor(){
        super("Invalid swedish personal identity number");
    }
};
var $35704cfaefdc74d5$var$compareAsc = (dateLeft, dateRight)=>{
    const diff = dateLeft.getTime() - dateRight.getTime();
    return diff < 0 ? -1 : diff > 0 ? 1 : diff;
};
var $35704cfaefdc74d5$var$diffInYears = (dateLeft, dateRight)=>{
    const sign = $35704cfaefdc74d5$var$compareAsc(dateLeft, dateRight);
    const yearDiff = Math.abs(dateLeft.getFullYear() - dateRight.getFullYear());
    dateLeft.setFullYear(dateLeft.getFullYear() - sign * yearDiff);
    const isLastYearNotFull = $35704cfaefdc74d5$var$compareAsc(dateLeft, dateRight) === -sign;
    const result = sign * (yearDiff - +isLastYearNotFull);
    return result === 0 ? 0 : result;
};
var $35704cfaefdc74d5$var$luhn = (str)=>{
    let sum = 0;
    str += "";
    for(let i = 0, l = str.length; i < l; i++){
        let v = parseInt(str[i]);
        v *= 2 - i % 2;
        if (v > 9) v -= 9;
        sum += v;
    }
    return Math.ceil(sum / 10) * 10 - sum;
};
var $35704cfaefdc74d5$var$testDate = (year, month, day)=>{
    month -= 1;
    const date = new Date(year, month, day);
    return !(date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day);
};
var $35704cfaefdc74d5$var$Personnummer = class {
    /**
   * Personnummer constructor.
   *
   * @param {string} pin
   * @param {object} options
   */ constructor(pin, options){
        this._century = "";
        this._fullYear = "";
        this._year = "";
        this._month = "";
        this._day = "";
        this._sep = "";
        this._num = "";
        this._check = "";
        this.parse(pin, {
            allowCoordinationNumber: true,
            allowInterimNumber: false,
            ...options
        });
    }
    /**
   * Get century.
   *
   * @return {string}
   */ get century() {
        return this._century;
    }
    /**
   * Get age.
   *
   * @return {string}
   */ get fullYear() {
        return this._fullYear;
    }
    /**
   * Get age.
   *
   * @return {string}
   */ get year() {
        return this._year;
    }
    /**
   * Get month.
   *
   * @return {string}
   */ get month() {
        return this._month;
    }
    /**
   * Get day.
   *
   * @return {string}
   */ get day() {
        return this._day;
    }
    /**
   * Get sep.
   *
   * @return {string}
   */ get sep() {
        return this._sep;
    }
    /**
   * Get num.
   *
   * @return {string}
   */ get num() {
        return this._num;
    }
    /**
   * Get check.
   *
   * @return {string}
   */ get check() {
        return this._check;
    }
    /**
   * Parse personnummer.
   *
   * @param {string} pin
   * @param {object} options
   *
   * @return {Personnummer}
   */ static parse(pin, options) {
        return new $35704cfaefdc74d5$var$Personnummer(pin, options);
    }
    /**
   * Validate a Swedish personal identity number.
   *
   * @param {string} str
   * @param {object} options
   *
   * @return {boolean}
   */ static valid(pin, options) {
        try {
            $35704cfaefdc74d5$var$Personnummer.parse(pin, options);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * Parse personnummer and set class properties.
   *
   * @param {string} pin
   * @param {object} options
   */ parse(pin, options) {
        if (pin.length < 10 || pin.length > 13) throw new $35704cfaefdc74d5$var$PersonnummerError();
        const reg = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([+-]?)((?!000)\d{3}|[TRSUWXJKLMN]\d{2})(\d)$/;
        const match = reg.exec(pin);
        if (!match) throw new $35704cfaefdc74d5$var$PersonnummerError();
        const century = match[1];
        const year = match[2];
        const month = match[3];
        const day = match[4];
        const sep = match[5];
        const num = match[6];
        const check = match[7];
        if (typeof century === "undefined" || !century.length) {
            const d = /* @__PURE__ */ new Date();
            let baseYear = 0;
            if (sep === "+") {
                this._sep = "+";
                baseYear = d.getFullYear() - 100;
            } else {
                this._sep = "-";
                baseYear = d.getFullYear();
            }
            this._century = ("" + (baseYear - (baseYear - parseInt(year)) % 100)).substr(0, 2);
        } else {
            this._century = century;
            if (/* @__PURE__ */ new Date().getFullYear() - parseInt(century + year, 10) < 100) this._sep = "-";
            else this._sep = "+";
        }
        this._year = year;
        this._fullYear = this._century + year;
        this._month = month;
        this._day = day;
        this._num = num;
        this._check = check;
        if (!this.valid()) throw new $35704cfaefdc74d5$var$PersonnummerError();
        if (!(options == null ? void 0 : options.allowCoordinationNumber) && this.isCoordinationNumber()) throw new $35704cfaefdc74d5$var$PersonnummerError();
        if (!(options == null ? void 0 : options.allowInterimNumber) && this.isInterimNumber()) throw new $35704cfaefdc74d5$var$PersonnummerError();
    }
    /**
   * Validate a Swedish personal identity number.
   *
   * @return {boolean}
   */ valid() {
        const valid = $35704cfaefdc74d5$var$luhn(this.year + this.month + this.day + this.num.replace(/[TRSUWXJKLMN]/, "1")) === +this.check && !!this.check;
        if (valid && $35704cfaefdc74d5$var$testDate(parseInt(this.century + this.year), +this.month, +this.day)) return valid;
        return valid && $35704cfaefdc74d5$var$testDate(parseInt(this.century + this.year), +this.month, +this.day - 60);
    }
    /**
   * Format a Swedish personal identity number as one of the official formats,
   * A long format or a short format.
   *
   * If the input number could not be parsed a empty string will be returned.
   *
   * @param {boolean} longFormat
   *
   * @return {string}
   */ format(longFormat = false) {
        if (longFormat) return `${this.century}${this.year}${this.month}${this.day}${this.num}${this.check}`;
        return `${this.year}${this.month}${this.day}${this.sep}${this.num}${this.check}`;
    }
    /**
   * Get age from a Swedish personal identity number.
   *
   * @return {number}
   */ getAge() {
        const date = this.getDate();
        return $35704cfaefdc74d5$var$diffInYears(new Date(Date.now()), date);
    }
    /**
   * Get date from a Swedish personal identity number.
   *
   * @return {Date}
   */ getDate() {
        let ageDay = +this.day;
        if (this.isCoordinationNumber()) ageDay -= 60;
        const ageDate = this.century + this.year + "-" + this.month + "-" + (ageDay < 10 ? "0" + ageDay : ageDay);
        return new Date(ageDate);
    }
    /**
   * Check if a Swedish personal identity number is a interim number or not.
   *
   * @return {boolean}
   */ isInterimNumber() {
        return /[TRSUWXJKLMN]/.test(this.num[0]);
    }
    /**
   * Check if a Swedish personal identity number is a coordination number or not.
   *
   * @return {boolean}
   */ isCoordinationNumber() {
        return $35704cfaefdc74d5$var$testDate(parseInt(this.century + this.year), +this.month, +this.day - 60);
    }
    /**
   * Check if a Swedish personal identity number is for a female.
   *
   * @return {boolean}
   */ isFemale() {
        return !this.isMale();
    }
    /**
   * Check if a Swedish personal identity number is for a male.
   *
   * @return {boolean}
   */ isMale() {
        const sexDigit = parseInt(this.num.substr(-1));
        return sexDigit % 2 === 1;
    }
};
var $35704cfaefdc74d5$var$src_default = $35704cfaefdc74d5$var$Personnummer;
// src/utils.ts
var $35704cfaefdc74d5$var$luhn2 = (str)=>{
    let sum = 0;
    str += "";
    for(let i = 0, l = str.length; i < l; i++){
        let v = parseInt(str[i]);
        v *= 2 - i % 2;
        if (v > 9) v -= 9;
        sum += v;
    }
    return sum % 10 === 0;
};
// src/errors.ts
var $35704cfaefdc74d5$var$OrganisationsnummerError = class extends Error {
    constructor(){
        super("Invalid Swedish organization number");
    }
};
// src/index.ts
var $35704cfaefdc74d5$var$Organisationsnummer = class {
    /**
   * Organisationsnummer constructor.
   *
   * @param {string} org
   */ constructor(org){
        /**
     * The organization number.
     *
     * @var {string}
     */ this.number = "";
        this.parse(org);
    }
    /**
   * Parse organisationsnummer.
   *
   * @param {string} org
   */ parse(org) {
        if (org.length < 10 || org.length > 13) throw new $35704cfaefdc74d5$var$OrganisationsnummerError();
        try {
            const reg = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([-+]?)?(\d{3})(\d)$/g;
            const match = reg.exec(org);
            if (!match) throw new $35704cfaefdc74d5$var$OrganisationsnummerError();
            let number = org.replace("-", "");
            if (match[1]) {
                if (+match[1] !== 16) throw new $35704cfaefdc74d5$var$OrganisationsnummerError();
                else number = number.slice(2);
            }
            if (+match[3] < 20) throw new $35704cfaefdc74d5$var$OrganisationsnummerError();
            if (+match[2] < 10) throw new $35704cfaefdc74d5$var$OrganisationsnummerError();
            if (!$35704cfaefdc74d5$var$luhn2(number)) throw new $35704cfaefdc74d5$var$OrganisationsnummerError();
            this.number = number;
        } catch (err) {
            try {
                this._personnummer = $35704cfaefdc74d5$var$src_default.parse(org);
            } catch (_) {
                throw err;
            }
        }
    }
    /**
   * Parse organisationsnummer.
   *
   * @param {string} org
   *
   * @return {Organisationsnummer}
   */ static parse(org) {
        return new $35704cfaefdc74d5$var$Organisationsnummer(org);
    }
    /**
   * Validate a Swedish organization number.
   *
   * @param {string} org
   *
   * @return {boolean}
   */ static valid(org) {
        try {
            this.parse(org);
            return true;
        } catch (err) {
            return false;
        }
    }
    /**
   * Format Swedish organization number with or without separator.
   *
   * @param {boolean} separator
   *
   * @return {string}
   */ format(separator = true) {
        let number = this.number;
        let char = "-";
        if (this.isPersonnummer()) {
            number = this._personnummer.format(false);
            char = number.includes("+") ? "+" : "-";
            number = number.replace(char, "");
        }
        return separator ? number.slice(0, 6) + char + number.slice(6) : number;
    }
    /**
   * Get Personnummer instance.
   *
   * @return {Personnummer}
   */ personnummer() {
        return this._personnummer || null;
    }
    /**
   * Determine if personnummer or not.
   *
   * @return {boolean}
   */ isPersonnummer() {
        return !!this._personnummer;
    }
    /**
   * Get the organization type.
   *
   * @return string
   */ type() {
        if (this.isPersonnummer()) return "Enskild firma";
        const unkown = "Ok\xe4nt";
        const types = {
            1: "D\xf6dsbon",
            2: "Stat, landsting, kommun eller f\xf6rsamling",
            3: "Utl\xe4ndska f\xf6retag som bedriver n\xe4ringsverksamhet eller \xe4ger fastigheter i Sverige",
            5: "Aktiebolag",
            6: "Enkelt bolag",
            7: "Ekonomisk f\xf6rening eller bostadsr\xe4ttsf\xf6rening",
            8: "Ideella f\xf6rening och stiftelse",
            9: "Handelsbolag, kommanditbolag och enkelt bolag"
        };
        return types[+this.number[0]] || unkown;
    }
    /**
   * Get vat number for a organization number.
   *
   * @return string
   */ vatNumber() {
        return `SE${this.format(false)}01`;
    }
};
var $35704cfaefdc74d5$export$2e2bcd8739ae039 = $35704cfaefdc74d5$var$Organisationsnummer;



var $7FGDK = parcelRequire("7FGDK");

var $b10kV = parcelRequire("b10kV");
const $6f6de3ad84e95ab1$export$f107783f4ec8aeb = {
    address: {
        country: "SE"
    }
};
const $6f6de3ad84e95ab1$export$628ddb8628209698 = (text)=>$7FGDK.object().shape({
        email: $7FGDK.string().required(text("lblEmailRequired")).email(text("lblEmailFormatValidation")),
        companyName: $7FGDK.string().required(text("lblOrganisationNameRequired")),
        address: $7FGDK.object().shape({
            line1: $7FGDK.string().required(text("lblAddressLineOneRequired")),
            postalCode: $7FGDK.string().required(text("lblPostalCodeRequired")),
            city: $7FGDK.string().required(text("lblCityRequired")),
            country: $7FGDK.string().required(text("lblCountryRequired"))
        }).default(undefined),
        vatNumber: $7FGDK.string().when("address.country", {
            is: (countryCode)=>(0, $b10kV.isEuMember)(countryCode) && countryCode !== "SE",
            then: (value)=>value.required(text("lblVatNumberRequired")),
            otherwise: (value)=>value.strip(true).notRequired()
        }),
        organizationNumber: $7FGDK.string().when("address.country", {
            is: (countryCode)=>countryCode === "SE",
            then: (value)=>value.required(text("lblCompanyRegistrationNumberRequired")).test("organization-number-valid", text("lblCompanyRegistrationNumberInvalid"), (organizationNumber)=>organizationNumber ? (0, $35704cfaefdc74d5$export$2e2bcd8739ae039).valid(organizationNumber) : false),
            otherwise: (value)=>value.strip(true).notRequired()
        })
    });



var $7E7Dk = parcelRequire("7E7Dk");

var $1O9Jh = parcelRequire("1O9Jh");
const $afe1e2f1a49bba99$var$EMPTY_DISCOUNT_CODE_STATE = {
    input: "",
    appliedCode: null,
    feedback: null,
    lastAttemptedCode: null,
    submissionError: null
};
const $afe1e2f1a49bba99$export$360cc374c80df518 = ({ enabled: enabled, discountCodeInfo: discountCodeInfo, text: text })=>{
    const [state, setState] = (0, $7E7Dk.useState)($afe1e2f1a49bba99$var$EMPTY_DISCOUNT_CODE_STATE);
    const [validateDiscountCode, { isLoading: isLoading }] = (0, $1O9Jh.usePaymentValidateDiscountCodeMutation)();
    const normalizedInput = state.input.trim().toUpperCase();
    const isDisabled = discountCodeInfo?.quantity === 0;
    (0, $7E7Dk.useEffect)(()=>{
        setState($afe1e2f1a49bba99$var$EMPTY_DISCOUNT_CODE_STATE);
    }, [
        discountCodeInfo?.productId,
        discountCodeInfo?.productPriceVersionId,
        enabled
    ]);
    const getSuccessfulFeedback = (0, $7E7Dk.useCallback)((percentOff, durationInMonths)=>{
        if (percentOff == null) return text("lblInvoiceDiscountCodeApplied");
        return (durationInMonths ?? 0) > 1 ? text("lblInvoiceDiscountCodeAppliedWithPercentAndDuration", {
            discountPercentage: percentOff,
            durationInMonths: durationInMonths
        }) : text("lblInvoiceDiscountCodeAppliedWithPercent", {
            discountPercentage: percentOff
        });
    }, [
        text
    ]);
    const setInput = (0, $7E7Dk.useCallback)((input)=>{
        setState({
            ...$afe1e2f1a49bba99$var$EMPTY_DISCOUNT_CODE_STATE,
            input: input.toUpperCase()
        });
    }, []);
    const apply = (0, $7E7Dk.useCallback)(async ()=>{
        setState((current)=>({
                ...current,
                input: normalizedInput,
                submissionError: null
            }));
        if (!normalizedInput || !discountCodeInfo?.productId || !discountCodeInfo.productPriceVersionId || isDisabled) return;
        try {
            const response = await validateDiscountCode({
                scope: "Organization",
                paymentDiscountCodeValidationRequest: {
                    code: normalizedInput,
                    scope: "Organization",
                    lines: [
                        discountCodeInfo
                    ]
                }
            }).unwrap();
            const resolvedCode = response.code?.trim() || normalizedInput;
            const isValid = response.valid === true;
            setState({
                input: resolvedCode,
                appliedCode: isValid ? resolvedCode : null,
                lastAttemptedCode: resolvedCode,
                submissionError: null,
                feedback: {
                    severity: isValid ? "success" : "error",
                    text: isValid ? getSuccessfulFeedback(response.discount?.percentOff, response.discount?.durationInMonths) : text("lblInvoiceDiscountCodeInvalid")
                }
            });
        } catch  {
            setState({
                input: normalizedInput,
                appliedCode: null,
                lastAttemptedCode: normalizedInput,
                submissionError: null,
                feedback: {
                    severity: "error",
                    text: text("lblInvoiceDiscountCodeInvalid")
                }
            });
        }
    }, [
        discountCodeInfo,
        getSuccessfulFeedback,
        isDisabled,
        normalizedInput,
        text,
        validateDiscountCode
    ]);
    const validateForSubmission = (0, $7E7Dk.useCallback)(()=>{
        if (normalizedInput && normalizedInput !== (state.lastAttemptedCode ?? "")) {
            setState((current)=>({
                    ...current,
                    submissionError: text("lblInvoiceDiscountCodeApplyOrClear")
                }));
            return {
                isValid: false
            };
        }
        return {
            isValid: true,
            discountCode: enabled && !isDisabled ? state.appliedCode ?? undefined : undefined
        };
    }, [
        enabled,
        isDisabled,
        normalizedInput,
        state.appliedCode,
        state.lastAttemptedCode,
        text
    ]);
    return {
        input: state.input,
        feedback: state.feedback,
        submissionError: state.submissionError,
        isInputDisabled: isLoading || isDisabled,
        isApplyDisabled: !normalizedInput || isLoading || isDisabled,
        isApplying: isLoading,
        setInput: setInput,
        apply: apply,
        validateForSubmission: validateForSubmission
    };
};


const $911c2e53475756a1$export$552a84afc99493dc = /*#__PURE__*/ (0, $7E7Dk.memo)(function InvoiceDetailsForm({ onSubmit: onSubmit, isCreatingSubscription: isCreatingSubscription, administrativeFee: administrativeFee, currency: currency, isDiscountCodeEnabled: isDiscountCodeEnabled = false, discountCodeInfo: discountCodeInfo }) {
    const text = (0, $5u6k9.default)();
    const { locale: locale } = (0, $aLIw2.useLocalizationContext)();
    const discountCodeInputRef = (0, $7E7Dk.useRef)(null);
    const schema = (0, $7E7Dk.useMemo)(()=>(0, $6f6de3ad84e95ab1$export$628ddb8628209698)(text), [
        text
    ]);
    const { handleSubmit: handleSubmit, register: register, resetField: resetField, control: control, clearErrors: clearErrors, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $cCnqE.useForm)({
        defaultValues: (0, $6f6de3ad84e95ab1$export$f107783f4ec8aeb),
        mode: "onSubmit",
        reValidateMode: "onChange",
        shouldUnregister: true,
        resolver: (0, $l6tdd.yupResolver)(schema)
    });
    const country = (0, $cCnqE.useWatch)({
        control: control,
        name: "address.country",
        defaultValue: (0, $6f6de3ad84e95ab1$export$f107783f4ec8aeb).address?.country ?? "SE"
    });
    const discountCode = (0, $afe1e2f1a49bba99$export$360cc374c80df518)({
        enabled: isDiscountCodeEnabled,
        discountCodeInfo: discountCodeInfo,
        text: text
    });
    (0, $7E7Dk.useEffect)(()=>{
        if (country === "SE") {
            resetField("vatNumber", {
                defaultValue: undefined
            });
            clearErrors("vatNumber");
            return;
        }
        if (country && (0, $b10kV.isEuMember)(country)) {
            resetField("organizationNumber", {
                defaultValue: undefined
            });
            clearErrors("organizationNumber");
            return;
        }
        resetField("vatNumber", {
            defaultValue: undefined
        });
        resetField("organizationNumber", {
            defaultValue: undefined
        });
        clearErrors([
            "vatNumber",
            "organizationNumber"
        ]);
    }, [
        clearErrors,
        country,
        resetField
    ]);
    const countryOptions = (0, $7E7Dk.useMemo)(()=>Object.entries((0, $dos1r.getNamesWithFallback)(locale)).map(([value, label])=>({
                label: label,
                value: value
            })).sort((first, second)=>first.label.localeCompare(second.label, locale)), [
        locale
    ]);
    const administrativeFeeWithVat = (0, $b10kV.formatToCurrencyString)(administrativeFee?.currency ?? currency, (0, $b10kV.convertPriceStringToNumber)(administrativeFee?.priceInCurrency ?? "0") * (0, $b10kV.SWEDISH_VAT), locale);
    const submitInvoiceDetails = handleSubmit((formData)=>{
        const discountCodeSubmission = discountCode.validateForSubmission();
        if (!discountCodeSubmission.isValid) {
            discountCodeInputRef.current?.focus();
            return;
        }
        return onSubmit({
            ...formData,
            discountCode: discountCodeSubmission.discountCode
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: "invoicing-form",
        className: "flex flex-column gap-3",
        noValidate: true,
        onSubmit: submitInvoiceDetails
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "companyName",
        placeholder: text("lblOrganisationName"),
        error: errors.companyName?.message,
        ...register("companyName")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "address-line1",
        className: "mt-3",
        placeholder: text("lblAddressLineOne"),
        error: errors.address?.line1?.message,
        ...register("address.line1")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "address-line2",
        placeholder: `${text("lblAddressLineTwo")} (${text("lblOptional").toLowerCase()})`,
        error: errors.address?.line2?.message,
        ...register("address.line2")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "postal-code",
        placeholder: text("lblPostalCode"),
        error: errors.address?.postalCode?.message,
        ...register("address.postalCode"),
        className: "w-4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "city",
        placeholder: text("lblCity"),
        error: errors.address?.city?.message,
        ...register("address.city"),
        className: "w-8"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "state",
        placeholder: `${text("lblState")} (${text("lblOptional").toLowerCase()})`,
        error: errors.address?.state?.message,
        ...register("address.state")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "address.country",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
                value: field.value || null,
                options: countryOptions,
                placeholder: text("lblSelectCountry"),
                showClear: false,
                filter: true,
                optionLabel: "label",
                filterBy: "label,value",
                id: "country",
                className: "w-full",
                invalid: !!errors.address?.country,
                onChange: (event)=>field.onChange(event.value ?? undefined),
                onBlur: field.onBlur
            })
    }), country === "SE" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "organisations-number",
        className: "mt-3",
        placeholder: text("lblCompanyRegistrationNumber"),
        error: errors.organizationNumber?.message,
        ...register("organizationNumber")
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "vat-number",
        className: "mt-3",
        placeholder: text("lblVatNumber"),
        error: errors.vatNumber?.message,
        disabled: !!country && !(0, $b10kV.isEuMember)(country),
        ...register("vatNumber")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "yourReference",
        placeholder: `${text("lblInvoiceYourReference")} (${text("lblOptional").toLowerCase()})`,
        error: errors.yourReference?.message,
        ...register("yourReference")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        id: "email",
        placeholder: text("lblBillingEmail"),
        error: errors.email?.message,
        ...register("email")
    }), isDiscountCodeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        "data-testid": "discount-code-section",
        className: "flex flex-column gap-2 w-full mt-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex gap-2 align-items-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1o9MR.Input), {
        ref: discountCodeInputRef,
        id: "discount-code",
        name: "discountCode",
        placeholder: text("lblInvoiceDiscountCodePlaceholder"),
        value: discountCode.input,
        error: discountCode.submissionError ?? undefined,
        onChange: (event)=>discountCode.setInput(event.target.value),
        disabled: discountCode.isInputDisabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnApply"),
        onClick: ()=>void discountCode.apply(),
        loading: discountCode.isApplying,
        disabled: discountCode.isApplyDisabled
    })), discountCodeInfo?.quantity === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("small", {
        className: "block mt-1 px-1 text-xs text-500 line-height-2"
    }, text("lblInvoiceDiscountCodeDisabledZeroConnectors")) : null, discountCode.feedback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dE8RX.Message), {
        severity: discountCode.feedback.severity,
        text: discountCode.feedback.text
    }) : null) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "text-sm text-gray-700 mb-0"
    }, text("lblInvoiceAdministrationFee", {
        adminFee: administrativeFeeWithVat
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "text-sm text-gray-700"
    }, text("lblInvoiceAdministrationFeeBody"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        label: text("lblConfirmAndActivateSubscription"),
        type: "submit",
        disabled: isSubmitting || !!isCreatingSubscription,
        className: "w-full"
    }));
});


const $3df97973654f4819$var$STEP_CONFIG = {
    "customer-type": {
        headerKey: "lblBeforeYouContinue"
    },
    "business-payment-method": {
        headerKey: "lblChoosePaymentMethod",
        previousStep: "customer-type"
    },
    "invoice-details": {
        headerKey: "lblInvoiceDetails",
        previousStep: "business-payment-method"
    }
};
const $3df97973654f4819$export$f3df739c64c4290b = /*#__PURE__*/ (0, $7E7Dk.memo)(function BillingPaymentSetupDialog({ visible: visible, onHide: onHide, onSubmitInvoice: onSubmitInvoice, onSubmitCard: onSubmitCard, productId: productId, priceId: priceId, isCreatingSubscription: isCreatingSubscription, administrativeFee: administrativeFee, currency: currency, isLoadingCheckoutSession: isLoadingCheckoutSession, isCardPaymentDisabled: isCardPaymentDisabled = false, isInvoiceDiscountCodeEnabled: isInvoiceDiscountCodeEnabled = false, discountCodeQuantity: discountCodeQuantity }) {
    const text = (0, $5u6k9.default)();
    const [step, setStep] = (0, $7E7Dk.useState)("customer-type");
    const { headerKey: headerKey, previousStep: previousStep } = $3df97973654f4819$var$STEP_CONFIG[step];
    const isSpinnerVisible = isLoadingCheckoutSession && step !== "invoice-details";
    const cardPaymentUnavailableReason = isCardPaymentDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "m-0 mt-2 text-sm text-600 text-center"
    }, text("lblSubscriptionRequiresBillableConnectors")) : null;
    const footer = !isSpinnerVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnCancel"),
        text: true,
        onClick: onHide
    }), previousStep ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnBack"),
        outlined: true,
        onClick: ()=>setStep(previousStep)
    }) : null) : null;
    const renderContent = ()=>{
        switch(step){
            case "customer-type":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                    className: "flex flex-column justify-content-center align-items-center"
                }, !isLoadingCheckoutSession ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $igvrl.default), {
                    code: "lblPaymentModalDescription"
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                    className: "w-full",
                    label: text("lblCompany"),
                    onClick: ()=>setStep("business-payment-method")
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e6olx.Divider), null, text("lblOr").toLowerCase()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                    label: text("lblIndividual"),
                    className: "w-full",
                    disabled: isCardPaymentDisabled,
                    onClick: ()=>onSubmitCard("individual")
                }), cardPaymentUnavailableReason) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $22lzE.ProgressSpinner), null));
            case "business-payment-method":
                if (isLoadingCheckoutSession) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $22lzE.ProgressSpinner), null);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
                    className: "flex justify-content-center flex-column"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                    label: text("lblPayByCard"),
                    className: "w-full",
                    disabled: isCardPaymentDisabled,
                    onClick: ()=>onSubmitCard("organization")
                }), cardPaymentUnavailableReason, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e6olx.Divider), null, text("lblOr").toLowerCase()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
                    label: text("lblPayByEmailInvoice"),
                    className: "w-full",
                    onClick: ()=>setStep("invoice-details")
                }));
            case "invoice-details":
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $911c2e53475756a1$export$552a84afc99493dc), {
                    onSubmit: onSubmitInvoice,
                    administrativeFee: administrativeFee,
                    currency: currency,
                    isCreatingSubscription: isCreatingSubscription,
                    isDiscountCodeEnabled: isInvoiceDiscountCodeEnabled,
                    discountCodeInfo: {
                        productId: productId,
                        productPriceVersionId: priceId,
                        quantity: discountCodeQuantity
                    }
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        visible: visible,
        onHide: onHide,
        header: text(headerKey),
        footer: footer,
        "data-testid": "billing-payment-setup-dialog"
    }, renderContent());
});





var $b10kV = parcelRequire("b10kV");
const $2495dee4b0db0d0c$var$BASIC_MARKETING_FEATURES = [
    {
        label: "lblBasicProductFeatureLine02",
        isActive: false,
        productLevel: 0
    },
    {
        label: "lblBasicProductFeatureLine01",
        isActive: false,
        productLevel: 0
    },
    {
        label: "lblBasicProductFeatureLine03",
        isActive: false,
        productLevel: 0
    },
    {
        label: "lblBasicProductFeatureLine04",
        isActive: false,
        productLevel: 0
    },
    {
        label: "lblBasicProductFeatureLine05",
        isActive: false,
        productLevel: 0
    },
    {
        label: "lblBasicProductFeatureLine06",
        isActive: false,
        productLevel: 0
    },
    {
        label: "lblBasicProductFeatureLine07",
        isActive: false,
        productLevel: 0
    }
];
const $2495dee4b0db0d0c$export$757b7885a808970f = (commercialOfferings)=>{
    const productCurrency = commercialOfferings.products?.flatMap((product)=>product.prices ?? []).find((price)=>price.currency?.trim())?.currency?.trim();
    return productCurrency || commercialOfferings.administrativeFee?.currency?.trim() || (0, $b10kV.SWEDISH_CURRENCY);
};
const $2495dee4b0db0d0c$export$28ffc84c7e32d0d9 = (product, billingInterval)=>{
    const price = product.prices?.find((candidate)=>candidate.interval === billingInterval);
    if (!price) throw new Error(`Missing ${billingInterval} price for ${product.name} subscription`);
    return price;
};
const $2495dee4b0db0d0c$export$1c52a66935eddc6f = (billableConnectors, product)=>billableConnectors?.quantities?.find((quantity)=>quantity.strategyKey === product.quantityStrategyKey)?.quantity ?? 0;
const $2495dee4b0db0d0c$export$2bb25d7f12c1358 = ({ product: product, price: price })=>{
    const productName = product.name.trim().toLowerCase();
    return productName === "flex" || productName === "pro" && price.interval === "month";
};
const $2495dee4b0db0d0c$export$fc607240d7a91428 = (products)=>{
    const productMarketingFeatures = (products ?? []).flatMap((product)=>(product.marketingFeatures ?? []).map((label)=>({
                label: label,
                isActive: false,
                productLevel: product.productLevel ?? 0
            })));
    return Array.from(new Map([
        ...$2495dee4b0db0d0c$var$BASIC_MARKETING_FEATURES,
        ...productMarketingFeatures
    ].map((feature)=>[
            feature.label,
            feature
        ])).values());
};
const $2495dee4b0db0d0c$export$5539863336888778 = (locale)=>{
    const normalizedLocale = locale?.trim().toLowerCase();
    if (!normalizedLocale) return undefined;
    return normalizedLocale === "no" ? "nb" : normalizedLocale;
};


const $444d0aa1f5a52f59$var$EMPTY_PRODUCTS = [];
const $444d0aa1f5a52f59$export$fb1e9bf7ab908c5d = /*#__PURE__*/ (0, $7E7Dk.memo)(function BillingSubscriptionsWidget({ className: className, style: style, commercialOfferings: commercialOfferings, billableConnectors: billableConnectors, companyId: companyId, communicationLanguage: communicationLanguage, isCommunicationLanguageLoading: isCommunicationLanguageLoading, onCreateOrganizationSubscription: onCreateOrganizationSubscription }) {
    const text = (0, $5u6k9.default)();
    const toast = (0, $aCffN.useToast)();
    const { locale: locale } = (0, $aLIw2.useLocalizationContext)();
    const idemKeyRefInvoicePayment = (0, $7E7Dk.useRef)(null);
    const idemKeyRefCardPayment = (0, $7E7Dk.useRef)(null);
    const [selectedOffering, setSelectedOffering] = (0, $7E7Dk.useState)(null);
    const [isCreatingSubscription, setIsCreatingSubscription] = (0, $7E7Dk.useState)(false);
    const [isLoadingCheckoutSession, setIsLoadingCheckoutSession] = (0, $7E7Dk.useState)(false);
    const [createCheckoutSessionOrg] = (0, $1O9Jh.usePaymentCreateOrganizationCheckoutSessionMutation)();
    const [createCheckoutSessionInd] = (0, $1O9Jh.usePaymentCreateIndividualCheckoutSessionMutation)();
    const openPaymentSetup = (product, billingInterval)=>setSelectedOffering({
            product: product,
            price: (0, $2495dee4b0db0d0c$export$28ffc84c7e32d0d9)(product, billingInterval)
        });
    const closePaymentSetup = ()=>{
        setSelectedOffering(null);
        idemKeyRefInvoicePayment.current = null;
        idemKeyRefCardPayment.current = null;
    };
    const handleSubmitInvoice = async (data)=>{
        if (!selectedOffering || !companyId || isCreatingSubscription || isCommunicationLanguageLoading) return;
        if (!idemKeyRefInvoicePayment.current) idemKeyRefInvoicePayment.current = crypto.randomUUID();
        setIsCreatingSubscription(true);
        try {
            await onCreateOrganizationSubscription({
                ...data,
                preferredLocale: communicationLanguage ?? "",
                productId: selectedOffering.product.id,
                productPriceVersionId: selectedOffering.price.productPriceVersionId,
                idempotencyKey: idemKeyRefInvoicePayment.current
            });
        } finally{
            setIsCreatingSubscription(false);
            idemKeyRefInvoicePayment.current = null;
        }
    };
    const handleSubmitCard = async (type)=>{
        if (!selectedOffering || isCommunicationLanguageLoading) return;
        if (!idemKeyRefCardPayment.current) idemKeyRefCardPayment.current = crypto.randomUUID();
        try {
            setIsLoadingCheckoutSession(true);
            const stripeCheckoutLocale = (0, $2495dee4b0db0d0c$export$5539863336888778)(locale);
            const stripeCustomerPreferredLocale = (0, $2495dee4b0db0d0c$export$5539863336888778)(communicationLanguage);
            const checkoutSessionPayload = {
                productId: selectedOffering.product.id,
                productPriceVersionId: selectedOffering.price.productPriceVersionId,
                idempotencyKey: idemKeyRefCardPayment.current,
                ...stripeCheckoutLocale ? {
                    preferredLocale: stripeCheckoutLocale
                } : {},
                ...stripeCustomerPreferredLocale ? {
                    customerPreferredLocale: stripeCustomerPreferredLocale
                } : {}
            };
            const res = type === "organization" ? await createCheckoutSessionOrg({
                paymentCheckoutSessionRequest: checkoutSessionPayload
            }).unwrap() : await createCheckoutSessionInd({
                paymentIndividualCheckoutSessionRequest: checkoutSessionPayload
            }).unwrap();
            if (res.url) window.location.href = res.url;
        } catch  {
            toast.notifyError(text("lblCouldNotCreateCheckoutSession"));
        } finally{
            setIsLoadingCheckoutSession(false);
            idemKeyRefCardPayment.current = null;
        }
    };
    const products = commercialOfferings.products ?? $444d0aa1f5a52f59$var$EMPTY_PRODUCTS;
    const currency = (0, $2495dee4b0db0d0c$export$757b7885a808970f)(commercialOfferings);
    const marketingFeatures = (0, $7E7Dk.useMemo)(()=>(0, $2495dee4b0db0d0c$export$fc607240d7a91428)(products), [
        products
    ]);
    const selectedProductBillableConnectorQuantity = selectedOffering ? (0, $2495dee4b0db0d0c$export$1c52a66935eddc6f)(billableConnectors, selectedOffering.product) : undefined;
    const isCardPaymentDisabled = selectedOffering ? selectedProductBillableConnectorQuantity === 0 : false;
    const isInvoiceDiscountCodeEnabled = selectedOffering ? (0, $2495dee4b0db0d0c$export$2bb25d7f12c1358)(selectedOffering) : false;
    const subscriptionCards = products.map((product)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
            key: product.id,
            className: "col-12 md:col-6 xl:col-4"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e191ec0f9e3d7aec$export$9206da65ddd43509), {
            product: product,
            currency: currency,
            billableConnectors: billableConnectors,
            onSelectPlan: (billingInterval)=>openPaymentSetup(product, billingInterval),
            marketingFeatures: marketingFeatures
        })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6oqHU.Card), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex grid justify-content-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "col-12 md:col-6 xl:col-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $654d689d3fd572fb$export$33be3ed9f809e989), {
        marketingFeatures: marketingFeatures,
        currency: currency
    })), subscriptionCards), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex align-items-center justify-content-center text-center text-sm text-gray-500 flex-column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "m-0 flex gap-1"
    }, billableConnectors ? products.map((product)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", {
            key: product.id
        }, text("lblProductPriceBasedOnConnectors", {
            product: product.name,
            connectorCount: (0, $2495dee4b0db0d0c$export$1c52a66935eddc6f)(billableConnectors, product)
        }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("span", null, text("lblIncludingVat")))))), selectedOffering ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3df97973654f4819$export$f3df739c64c4290b), {
        visible: true,
        onHide: closePaymentSetup,
        productId: selectedOffering.product.id,
        priceId: selectedOffering.price.productPriceVersionId,
        administrativeFee: commercialOfferings.administrativeFee,
        currency: currency,
        onSubmitInvoice: handleSubmitInvoice,
        onSubmitCard: handleSubmitCard,
        isLoadingCheckoutSession: isLoadingCheckoutSession || isCommunicationLanguageLoading,
        isCreatingSubscription: isCreatingSubscription,
        isCardPaymentDisabled: isCardPaymentDisabled,
        isInvoiceDiscountCodeEnabled: isInvoiceDiscountCodeEnabled,
        discountCodeQuantity: selectedProductBillableConnectorQuantity
    }) : null);
});



var $eXdML = parcelRequire("eXdML");

var $7E7Dk = parcelRequire("7E7Dk");

var $cCnqE = parcelRequire("cCnqE");

var $1ot1u = parcelRequire("1ot1u");

var $MMfqT = parcelRequire("MMfqT");

var $c6fcw = parcelRequire("c6fcw");

var $5u6k9 = parcelRequire("5u6k9");

var $aLIw2 = parcelRequire("aLIw2");

var $dos1r = parcelRequire("dos1r");

var $eXdML = parcelRequire("eXdML");
const $d8b754988fdc7e4e$var$formId = "complete-organisation-information-form";
const $d8b754988fdc7e4e$var$communicationLanguageOptions = (0, $aLIw2.AVAILABLE_LANGUAGES).map((value)=>({
        label: (0, $aLIw2.AVAILABLE_LANGUAGES_LOCAL)[value] ?? value,
        value: value
    }));
const $d8b754988fdc7e4e$export$7c0cb29a172b9e7e = /*#__PURE__*/ (0, $7E7Dk.memo)(function CompleteOrganisationInformationDialog({ visible: visible, initialValues: initialValues, isSaving: isSaving, onHide: onHide, onSubmit: onSubmit }) {
    const text = (0, $5u6k9.default)();
    const { locale: locale } = (0, $aLIw2.useLocalizationContext)();
    const { control: control, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isSubmitted: isSubmitted, isSubmitting: isSubmitting } } = (0, $cCnqE.useForm)({
        defaultValues: {
            billingCountry: (0, $eXdML.DEFAULT_BILLING_COUNTRY),
            communicationLanguage: "en"
        },
        mode: "onSubmit",
        reValidateMode: "onChange"
    });
    const countryOptions = (0, $7E7Dk.useMemo)(()=>Object.entries((0, $dos1r.getNamesWithFallback)(locale)).map(([value, label])=>({
                label: label,
                value: value
            })).sort((a, b)=>a.label.localeCompare(b.label, locale)), [
        locale
    ]);
    (0, $7E7Dk.useEffect)(()=>{
        if (!visible) return;
        reset({
            billingCountry: initialValues.billingCountry?.trim() || (0, $eXdML.DEFAULT_BILLING_COUNTRY),
            communicationLanguage: initialValues.communicationLanguage?.trim() || "en"
        });
    }, [
        initialValues.billingCountry,
        initialValues.communicationLanguage,
        reset,
        visible
    ]);
    const save = (values)=>onSubmit(values);
    const isSaveDisabled = isSaving || isSubmitting || isSubmitted && Object.keys(errors).length > 0;
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-end gap-2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "button",
        label: text("btnCancel"),
        text: true,
        onClick: onHide
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1ot1u.Button), {
        type: "submit",
        form: $d8b754988fdc7e4e$var$formId,
        label: text("btnSave"),
        loading: isSaving || isSubmitting,
        disabled: isSaveDisabled
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $MMfqT.Dialog), {
        visible: visible,
        header: text("lblCompleteOrganisationInformationDialogTitle"),
        onHide: onHide,
        footer: footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("form", {
        id: $d8b754988fdc7e4e$var$formId,
        noValidate: true,
        onSubmit: handleSubmit(save)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "m-0 mb-4"
    }, text("msgCompleteOrganisationInformationDialogDescription")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex flex-column gap-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "billingCountry",
        control: control,
        rules: {
            required: text("msgBillingCountryRequired")
        },
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
                id: "billing-country",
                label: text("lblBillingCountry"),
                options: countryOptions,
                required: true,
                value: field.value || null,
                showClear: false,
                onChange: (event)=>field.onChange(event.value),
                onBlur: field.onBlur,
                error: errors.billingCountry?.message
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cCnqE.Controller), {
        name: "communicationLanguage",
        control: control,
        rules: {
            required: text("msgBillingCommunicationLanguageRequired")
        },
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $c6fcw.Dropdown), {
                id: "billing-organisation-communication-language",
                label: text("lblCommunicationLanguage"),
                options: $d8b754988fdc7e4e$var$communicationLanguageOptions,
                required: true,
                value: field.value,
                showClear: false,
                onChange: (event)=>field.onChange(event.value),
                onBlur: field.onBlur,
                error: errors.communicationLanguage?.message
            })
    }))));
});




const $85b5cd1510650924$var$ACTIVE_SUBSCRIPTIONS_QUERY = {
    status: [
        "active",
        "past_due"
    ]
};
const $85b5cd1510650924$var$toBillingPlanInterval = (interval)=>interval === "month" || interval === "year" ? interval : undefined;
const $85b5cd1510650924$export$66e04ca3f5ae7cd0 = /*#__PURE__*/ (0, $7E7Dk.memo)(function BillingPage({ className: className, style: style }) {
    const navigate = (0, $3um4r.useNavigate)();
    const toast = (0, $aCffN.useToast)();
    const text = (0, $5u6k9.default)();
    const [dismissedOrganisationDataCompanyId, setDismissedOrganisationDataCompanyId] = (0, $7E7Dk.useState)(null);
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const { data: companySettings, isFetching: isFetchingCompanySettings, isSuccess: isCompanySettingsLoaded } = (0, $1O9Jh.useCompanyGetCompanySettingsQuery)({
        companyId: companyId
    }, {
        skip: !companyId
    });
    const { data: customer, isLoading: isLoadingCustomer } = (0, $1O9Jh.usePaymentGetCustomerQuery)(companyId ? {
        organizationId: companyId
    } : (0, $eLH3C.skipToken));
    const { data: subscriptions, isLoading: isLoadingSubscriptions } = (0, $1O9Jh.usePaymentGetSubscriptionsByOrgQuery)($85b5cd1510650924$var$ACTIVE_SUBSCRIPTIONS_QUERY, {
        refetchOnMountOrArgChange: true
    });
    const activeSubscription = subscriptions?.[0] ?? null;
    const hasActiveSubscription = activeSubscription !== null;
    const subscriptionDetailsQueryArg = customer?.publicId && activeSubscription?.publicId ? {
        customerPublicId: customer.publicId,
        organizationId: companyId,
        subscriptionPublicId: activeSubscription.publicId
    } : undefined;
    const { data: subscriptionDetails, isLoading: isLoadingSubscriptionDetails } = (0, $1O9Jh.usePaymentGetSubscriptionDetailsQuery)(subscriptionDetailsQueryArg ?? (0, $eLH3C.skipToken));
    const billingPlanInterval = $85b5cd1510650924$var$toBillingPlanInterval(subscriptionDetails?.items?.[0]?.interval);
    const [createCustomerPortal] = (0, $1O9Jh.usePaymentCreateSelfServicePortalMutation)();
    const { data: commercialOfferings, isLoading: isLoadingCommercialOfferings } = (0, $1O9Jh.usePaymentGetCommercialOfferingsQuery)({
        kind: "subscription"
    }, {
        skip: isLoadingSubscriptions || hasActiveSubscription
    });
    const { data: billableConnectors, isLoading: isLoadingBillableConnectors } = (0, $1O9Jh.usePaymentGetBillableConnectorsQuery)(companyId ? {
        organizationId: companyId
    } : (0, $eLH3C.skipToken));
    const activeSubscriptionBillableConnectors = billableConnectors?.quantities?.find((q)=>q?.strategyKey === activeSubscription?.quantityStrategyKey)?.quantity ?? 0;
    const [createOrganizationSubscription] = (0, $1O9Jh.usePaymentCreateOrganizationSubscriptionMutation)();
    const [updateCompanySettings, { isLoading: isSavingCompanySettings }] = (0, $1O9Jh.useCompanyUpdateCompanySettingsMutation)();
    const communicationLanguage = (0, $eXdML.getCompanySettingValue)(companySettings, "Language");
    const configuredBillingCountry = (0, $eXdML.getCompanySettingValue)(companySettings, "BillingCountry");
    const billingCountry = configuredBillingCountry ?? (0, $eXdML.DEFAULT_BILLING_COUNTRY);
    const isOrganisationDataLoading = isFetchingCompanySettings;
    const isOrganisationDataLoaded = isCompanySettingsLoaded;
    const shouldPromptForOrganisationData = isOrganisationDataLoaded && !isOrganisationDataLoading && (!configuredBillingCountry || !communicationLanguage);
    const showOrganisationDataPrompt = shouldPromptForOrganisationData && dismissedOrganisationDataCompanyId !== companyId;
    const isSavingOrganisationData = isSavingCompanySettings;
    const handleCreateOrganizationSubscription = async (request)=>{
        try {
            await createOrganizationSubscription({
                paymentOrganizationSubscriptionRequest: request
            }).unwrap();
            navigate("/billing/success", {
                replace: true
            });
        } catch (err) {
            const reason = (0, $b10kV.getFailureReasonFromError)(err);
            const query = reason ? `?reason=${encodeURIComponent(reason)}` : "";
            navigate(`/billing/failed${query}`, {
                replace: true
            });
        }
    };
    const handleManagePayments = async ()=>{
        if (!companyId) return;
        try {
            const { url: url } = await createCustomerPortal({
                customerId: companyId,
                paymentSelfServicePortalRequest: {
                    idempotencyKey: crypto.randomUUID()
                }
            }).unwrap();
            window.open(url, "_blank", "noopener,noreferrer");
        } catch  {
            toast.notifyError(text("lblErrorSetupCustomerPortal"));
        }
    };
    const handleSubmitOrganisationInformation = async ({ billingCountry: nextBillingCountry, communicationLanguage: communicationLanguage })=>{
        try {
            await updateCompanySettings({
                companyId: companyId,
                body: (0, $eXdML.mapOrganisationSettingsToCompanySettings)({
                    communicationLanguage: communicationLanguage,
                    billingCountry: nextBillingCountry
                })
            }).unwrap();
            setDismissedOrganisationDataCompanyId(companyId);
            toast.notifySuccess(text("msgCompanyUpdated"));
        } catch  {
            toast.notifyError(text("msgCompanyNotUpdated"));
        }
    };
    const isLoadingContent = isLoadingBillableConnectors || isLoadingCommercialOfferings || isLoadingSubscriptions || isLoadingCustomer || hasActiveSubscription && isLoadingSubscriptionDetails;
    const renderSubscriptionContent = ()=>{
        if (hasActiveSubscription) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4f3c6c8e964f65ad$export$8492f7b1a5cb9a11), {
            interval: billingPlanInterval,
            subscription: activeSubscription
        });
        if (commercialOfferings) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $444d0aa1f5a52f59$export$fb1e9bf7ab908c5d), {
            companyId: companyId,
            communicationLanguage: communicationLanguage,
            isCommunicationLanguageLoading: isFetchingCompanySettings,
            commercialOfferings: commercialOfferings,
            billableConnectors: billableConnectors,
            onCreateOrganizationSubscription: handleCreateOrganizationSubscription
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6oqHU.Card), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
            className: "m-0 text-xl"
        }, text("lblCouldLoadCommercialOfferings")));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className, "gap-3"),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $d8b754988fdc7e4e$export$7c0cb29a172b9e7e), {
        visible: showOrganisationDataPrompt,
        initialValues: {
            billingCountry: billingCountry,
            communicationLanguage: communicationLanguage ?? ""
        },
        isSaving: isSavingOrganisationData,
        onHide: ()=>setDismissedOrganisationDataCompanyId(companyId),
        onSubmit: handleSubmitOrganisationInformation
    }), !isLoadingContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, renderSubscriptionContent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $827bc7dda15cb5cf$export$3cc4aa7b1bbcf28), {
        billableConnectors: activeSubscriptionBillableConnectors,
        hasActiveSubscription: hasActiveSubscription,
        isCustomer: !!customer,
        onManagePayments: handleManagePayments
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $22lzE.ProgressSpinner), null));
});





var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $22lzE = parcelRequire("22lzE");

var $2rQNl = parcelRequire("2rQNl");

var $3um4r = parcelRequire("3um4r");

var $26yAo = parcelRequire("26yAo");

var $1O9Jh = parcelRequire("1O9Jh");

var $gkMDS = parcelRequire("gkMDS");

var $5u6k9 = parcelRequire("5u6k9");

var $b10kV = parcelRequire("b10kV");

var $hw820 = parcelRequire("hw820");

var $bVWHj = parcelRequire("bVWHj");
const $6cc8b0635885e1a9$export$cadd549388d0ca29 = /*#__PURE__*/ (0, $7E7Dk.memo)(function BillingSuccessPage({ className: className, style: style }) {
    const navigate = (0, $3um4r.useNavigate)();
    const text = (0, $5u6k9.default)();
    const POLL_INTERVAL_MS = 3000;
    const POLL_TIMEOUT_MS = 60000;
    const dispatch = (0, $2rQNl.useDispatch)();
    const { selectedCompanyId: selectedCompanyId } = (0, $2rQNl.useSelector)((state)=>state.user);
    const [getActiveSubscriptions] = (0, $1O9Jh.useLazyPaymentGetSubscriptionsByOrgQuery)();
    const [getEntitlements] = (0, $1O9Jh.useEntitlementsCreateContextTokenMutation)();
    const [fulfillmentComplete, setFulfillmentComplete] = (0, $7E7Dk.useState)(false);
    (0, $7E7Dk.useEffect)(()=>{
        let cancelled = false;
        let hasNavigatedToFailed = false;
        const sleep = (ms)=>new Promise((r)=>setTimeout(r, ms));
        const navigateFailed = (reason)=>{
            if (hasNavigatedToFailed) return;
            hasNavigatedToFailed = true;
            const query = reason ? `?reason=${encodeURIComponent(reason)}` : "";
            navigate(`/billing/failed${query}`, {
                replace: true
            });
        };
        const onTimeout = ()=>navigateFailed("timeout");
        const pollSubscriptions = async ()=>{
            const start = Date.now();
            do {
                try {
                    const subscriptionsQueryArg = {
                        status: "active"
                    };
                    const activeSubscriptions = await getActiveSubscriptions(subscriptionsQueryArg).unwrap();
                    if (cancelled) return false;
                    if (activeSubscriptions.some((s)=>s.status === "active")) return true;
                } catch (err) {
                    if (cancelled) return false;
                    navigateFailed((0, $b10kV.getFailureReasonFromError)(err));
                    return false;
                }
                await sleep(POLL_INTERVAL_MS);
            }while (!cancelled && Date.now() - start < POLL_TIMEOUT_MS);
            return false;
        };
        const pollEntitlements = async ()=>{
            const start = Date.now();
            while(!cancelled && Date.now() - start < POLL_TIMEOUT_MS){
                try {
                    const authenticationServiceContextRequest = {
                        organizationId: selectedCompanyId
                    };
                    const entitlements = await getEntitlements({
                        authenticationServiceContextRequest: authenticationServiceContextRequest
                    }).unwrap();
                    if (cancelled) return false;
                    const entitlementsState = (0, $hw820.normalizeEntitlementsState)(entitlements, selectedCompanyId);
                    dispatch((0, $hw820.setEntitlements)(entitlementsState));
                    if ((0, $bVWHj.hasAccessToEntitlement)((0, $bVWHj.EntitlementsEnum).AUTOMATED_REPORTS, entitlementsState)) {
                        setFulfillmentComplete(true);
                        return true;
                    }
                } catch (err) {
                    if (cancelled) return false;
                    dispatch((0, $hw820.clearEntitlements)());
                    navigateFailed((0, $b10kV.getFailureReasonFromError)(err));
                    return false;
                }
                await sleep(POLL_INTERVAL_MS);
            }
            return false;
        };
        (async ()=>{
            try {
                const okSubs = await pollSubscriptions();
                if (cancelled) return;
                if (!okSubs) {
                    if (!hasNavigatedToFailed) onTimeout();
                    return;
                }
                const okEnt = await pollEntitlements();
                if (cancelled) return;
                if (!okEnt) {
                    if (!hasNavigatedToFailed) onTimeout();
                    return;
                }
            } catch  {
                if (!cancelled) navigateFailed("unknown");
            }
        })();
        return ()=>{
            cancelled = true;
        };
    }, [
        dispatch,
        getActiveSubscriptions,
        getEntitlements,
        navigate,
        selectedCompanyId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "flex justify-content-center align-items-center flex-column gap-4",
        style: {
            height: "33vh"
        }
    }, !fulfillmentComplete ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h4", null, text("lblBillingProcessing")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", {
        className: "text-xl"
    }, text("lblBillingProcessingDescription", {
        time: POLL_TIMEOUT_MS * 2 / 60000
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $22lzE.ProgressSpinner), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $gkMDS.LandingMessageSuccessIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h4", null, text("lblBillingPlanActivatedSuccessfully")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.Link), {
        "data-testid": "linkBtn",
        to: "/billing"
    }, text("lblBackToRoute", {
        route: text("lblBilling")
    })))));
});



var $7E7Dk = parcelRequire("7E7Dk");

var $76MyM = parcelRequire("76MyM");

var $3um4r = parcelRequire("3um4r");

var $26yAo = parcelRequire("26yAo");

var $8OyAW = parcelRequire("8OyAW");

var $5u6k9 = parcelRequire("5u6k9");
const $861dcb3c0288f159$export$d625d1657edc3885 = /*#__PURE__*/ (0, $7E7Dk.memo)(function BillingFailedPage({ className: className, style: style }) {
    const text = (0, $5u6k9.default)();
    const [searchParams] = (0, $3um4r.useSearchParams)();
    const reasonParam = searchParams.get("reason");
    const titleKeyByReason = {
        timeout: "lblBillingPlanActivationFailedTimeout",
        bad_request: "lblBillingPlanActivationFailedBadRequest",
        server_error: "lblBillingPlanActivationFailedServerError",
        network_error: "lblBillingPlanActivationFailedNetworkError",
        unknown: "lblBillingPlanActivationFailedUnknown"
    };
    const titleKey = titleKeyByReason[reasonParam ?? ""] ?? "lblBillingPlanActivationFailedUnknown";
    const containerClassName = "flex justify-content-center align-items-center flex-column gap-4";
    const containerStyle = {
        height: "33vh"
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $26yAo.PageLayoutContainer), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($76MyM)))(className),
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: containerClassName,
        style: containerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8OyAW.LandingMessageErrorIcon), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("h4", {
        className: "m-0 mb-3"
    }, text("lblBillingPlanActivationFailedTitle")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("p", null, text(titleKey)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.Link), {
        "data-testid": "linkBtn",
        to: "/billing"
    }, text("lblBackToRoute", {
        route: text("lblBilling")
    }))));
});


const $8abf663814327bd2$var$RequireAuth = ({ isHeaderShown: isHeaderShown = true, sessionStatus: sessionStatus })=>{
    const location = (0, $3um4r.useLocation)();
    const companyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    if (sessionStatus === "loading") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kNBIm.PortalSessionLoader), null);
    if (sessionStatus !== "authenticated") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Navigate), {
        to: "/login",
        state: {
            from: location.pathname
        },
        replace: true
    });
    if (!companyId && location.pathname !== "/select-organisation") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Navigate), {
        to: "/select-organisation",
        state: {
            from: location.pathname
        },
        replace: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", {
        className: "sticky top-0 z-5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $010482ba7d327024$export$b4fa564fef3bb0f8), null), isHeaderShown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8b8a6f2964387153$export$e47503f05082112), {
        className: "static h-5rem bg-white px-4 lg:px-6 pt-5 pb-6 xl:pt-4 xl:pb-4"
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Outlet), null));
};
const $8abf663814327bd2$var$App = ()=>{
    const sessionStatus = (0, $PmdvF.usePortalSession)();
    const selectedCompanyId = (0, $2rQNl.useSelector)((state)=>state.user.selectedCompanyId);
    const entitlements = (0, $81LJ2.useEntitlements)();
    const billingEnabled = (0, $bVWHj.canAccessBillingPage)(entitlements);
    const location = (0, $3um4r.useLocation)();
    (0, $7E7Dk.useLayoutEffect)(()=>{
        // Scroll to the top of the page when the route changes
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"
        });
    }, [
        location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $j60L3.HeadProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $j60L3.Title), null, "Charge Amps Admin"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $j60L3.Link), {
        rel: "shortcut icon",
        href: "/common/content/images/favicon-16.png"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $j60L3.Link), {
        rel: "apple-touch-icon",
        href: "/common/content/images/logo_white_retina.png"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Routes), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "/*",
        element: sessionStatus === "loading" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $kNBIm.PortalSessionLoader), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Navigate), {
            to: sessionStatus !== "authenticated" ? "/login" : selectedCompanyId ? "/dashboard" : "/select-organisation"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "login",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9Rf8k.SignInPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "reset-password",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $f0ov8.PasswordResetPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "acceptInvitation",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6dd54a8f0093c2fd$export$49b43be1058c84eb), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "reset-password-request",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aojuQ.ResetPasswordRequestPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "reset-password-request-success",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $dm5pM.ResetPasswordRequestSuccessPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "reset-password-request-error",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $a4GLo.ResetPasswordRequestErrorPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8abf663814327bd2$var$RequireAuth, {
            isHeaderShown: false,
            sessionStatus: sessionStatus
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "select-organisation",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aa23c1e069405140$export$d89e43e3db240a63), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "change-operator/:transferKey",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $998cfac53c0765be$export$1a35d6ac86f34b1b), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "change-operator-success",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $91679d095db9062c$export$d99df8dc0cf8373), null)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement($8abf663814327bd2$var$RequireAuth, {
            sessionStatus: sessionStatus
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "dashboard",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $133c0d2af6898776$export$fedd53519a0e2bce), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "pools",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $f05131e21285008e$export$4c210577356eef88), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "pool/:poolId",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $af8c754e567304aa$export$72fb5ffeaac1b378), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "measurementDevices",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aec0605491af26da$export$8de4554fe05e44f8), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "measurementDevice/:deviceId",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $cemTh.MeasurementDevicePage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "loadbalancer",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $hcqxO.LoadbalancerPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "loadbalancer/:id",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $feN3c.LoadBalancerDetailsWidgetPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "nfcTags",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $lRXhp.RFIDTagsPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "users",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9c7d2f5b2d3027a4$export$107317390f5aa598), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "user/:id",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $a74bb418999b3559$export$ecdc3cf9d1cfe143), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "user/:id/userPools",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $ff5dcb1437c56c04$export$51ad302672431b01), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "user/:id/userChargePoints",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2713497242aaaecb$export$11c799359c81f5d8), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "user/:id/userNfcTags",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $e0b2f92f02eafec8$export$39bb14b1a5fcc6b8), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "chargepoints",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $fa94066ef9392a1a$export$99edf21a326d7114), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "chargepoints/:chargePointId",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $awukm.ChargePointDetailsPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "reports",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $yF3FB.ReportsPage), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "settings",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $552cda2d41e0e57a$export$8f6dcfe950367406), null)
    }), billingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "billing",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $85b5cd1510650924$export$66e04ca3f5ae7cd0), null)
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "billing/success",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $6cc8b0635885e1a9$export$cadd549388d0ca29), null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $4AX6R.Route), {
        path: "billing/failed",
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $861dcb3c0288f159$export$d625d1657edc3885), null)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $h8spA.default), null));
};
var $8abf663814327bd2$export$2e2bcd8739ae039 = $8abf663814327bd2$var$App;



var $10c6O = parcelRequire("10c6O");
var $gtjDQ = parcelRequire("gtjDQ");

var $eLH3C = parcelRequire("eLH3C");

var $4UouQ = parcelRequire("4UouQ");

var $hw820 = parcelRequire("hw820");

var $eFTdF = parcelRequire("eFTdF");

var $7JRAZ = parcelRequire("7JRAZ");

var $jnDYy = parcelRequire("jnDYy");

var $2YlDj = parcelRequire("2YlDj");

var $gtjDQ = parcelRequire("gtjDQ");
const $8d7dd5a60f99452c$var$initialState = {
    value: 0
};
const $8d7dd5a60f99452c$export$8dea1a5d9f48fb86 = (0, $gtjDQ.createSlice)({
    name: "chargepoints",
    initialState: $8d7dd5a60f99452c$var$initialState,
    reducers: {
        increment: (state)=>{
            state.value += 1;
        },
        decrement: (state)=>{
            state.value -= 1;
        },
        incrementByAmount: (state, action)=>{
            state.value += action.payload;
        }
    }
});
const { increment: $8d7dd5a60f99452c$export$a2647aa13413c947, decrement: $8d7dd5a60f99452c$export$8f85cc9753f280aa, incrementByAmount: $8d7dd5a60f99452c$export$baefabcc3c150367 } = $8d7dd5a60f99452c$export$8dea1a5d9f48fb86.actions;
var $8d7dd5a60f99452c$export$2e2bcd8739ae039 = $8d7dd5a60f99452c$export$8dea1a5d9f48fb86.reducer;




const $f8c17b84c717e482$var$createRootReducers = ()=>{
    const rootReducerFn = (0, $10c6O.combineReducers)({
        chargePoints: (0, $8d7dd5a60f99452c$export$2e2bcd8739ae039),
        company: (0, $4UouQ.default),
        entitlements: (0, $hw820.default),
        portalSessionReset: (0, $eFTdF.default),
        scopedAccessSession: (0, $c24d70584502555a$export$2e2bcd8739ae039),
        user: (0, $jnDYy.default),
        selectedUser: (0, $d66a8c58f38f865e$export$2e2bcd8739ae039),
        [(0, $2YlDj.chargePointApi).reducerPath]: (0, $2YlDj.chargePointApi).reducer,
        [(0, $7JRAZ.enhancedApi).reducerPath]: (0, $7JRAZ.enhancedApi).reducer
    });
    return (state, action)=>{
        return rootReducerFn((0, $jnDYy.reset) && action.type === (0, $jnDYy.reset).type ? undefined : state, action);
    };
};
const $f8c17b84c717e482$export$6f57813fe9f31bf9 = (0, $gtjDQ.configureStore)({
    reducer: $f8c17b84c717e482$var$createRootReducers(),
    devTools: false,
    middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat([
            (0, $2YlDj.chargePointApi).middleware,
            (0, $7JRAZ.enhancedApi).middleware
        ])
});
const $f8c17b84c717e482$export$1b3de3898efde2ba = (preloadedState)=>{
    return (0, $gtjDQ.configureStore)({
        reducer: $f8c17b84c717e482$var$createRootReducers(),
        devTools: false,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat([
                (0, $2YlDj.chargePointApi).middleware,
                (0, $7JRAZ.enhancedApi).middleware
            ]),
        preloadedState: preloadedState
    });
};
(0, $eLH3C.setupListeners)($f8c17b84c717e482$export$6f57813fe9f31bf9.dispatch);


(0, $1IBeB.initAuthChangeListener)();
const $369cfa3d42b603f6$var$root = (0, $9Sg2u.createRoot)(document.getElementById("root"));
$369cfa3d42b603f6$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $1iD12.ThemeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $7E7Dk.Suspense), {
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement("div", null)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aLIw2.LocalizationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $2rQNl.Provider), {
    store: (0, $f8c17b84c717e482$export$6f57813fe9f31bf9)
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $eHYdO.PrimeReactProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $aCffN.ToastProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $3um4r.BrowserRouter), {
    basename: "admin"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $8abf663814327bd2$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7E7Dk))).createElement((0, $9p3YO.ConfirmDialog), null)))))))));


//# sourceMappingURL=index.e239640e.js.map
